"use strict";

function _toConsumableArray2(r) { return _arrayWithoutHoles2(r) || _iterableToArray2(r) || _unsupportedIterableToArray2(r) || _nonIterableSpread2(); }
function _nonIterableSpread2() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray2(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles2(r) { if (Array.isArray(r)) return _arrayLikeToArray2(r); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _typeof2(o) { "@babel/helpers - typeof"; return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof2(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray2(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty2(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof2(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof2(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof2(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray2(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray2(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray2(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray2(r, a) : void 0; } }
function _arrayLikeToArray2(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/******/(function () {
  // webpackBootstrap
  /******/
  "use strict";

  /******/
  var __webpack_modules__ = {
    /***/"./js/modules/accordion.js"
    /*!*********************************!*\
      !*** ./js/modules/accordion.js ***!
      \*********************************/: function _js_modules_accordionJs(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */"default": function _default() {
          return __WEBPACK_DEFAULT_EXPORT__;
        }
        /* harmony export */
      });
      var accordion = {
        init: function init() {
          var accordions = document.querySelectorAll('.accordion');
          if (accordions.length === 0) return;
          document.addEventListener('click', function (e) {
            if (e.target.classList.contains('accordion__head')) {
              var _accordion = e.target.closest('.accordion');
              var item = e.target.closest('.accordion__item');
              if (item.classList.contains('active')) {
                item.classList.remove('active');
              } else {
                _accordion.querySelectorAll('.accordion__item').forEach(function (item) {
                  item.classList.remove('active');
                });
                item.classList.add('active');
              }
            }
          });
        }
      };
      /* harmony default export */
      var __WEBPACK_DEFAULT_EXPORT__ = accordion;

      /***/
    },
    /***/"./js/modules/blog-filter.js"
    /*!***********************************!*\
      !*** ./js/modules/blog-filter.js ***!
      \***********************************/: function _js_modules_blogFilterJs(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */"default": function _default() {
          return __WEBPACK_DEFAULT_EXPORT__;
        }
        /* harmony export */
      });
      var blogFilter = {
        dom: document.querySelector('.blog-filter__chips'),
        form: document.getElementById('blog_filter_form'),
        init: function init() {
          if (!blogFilter.dom) return;
          var chips = blogFilter.dom.querySelectorAll('.text-chip');
          if (chips.length === 0) return;
          chips.forEach(function (chip) {
            chip.addEventListener('click', function (e) {
              e.preventDefault();
              blogFilter.form.querySelector('input[name=q]').value = '';
              blogFilter.form.submit();
            });
          });
        }
      };
      /* harmony default export */
      var __WEBPACK_DEFAULT_EXPORT__ = blogFilter;

      /***/
    },
    /***/"./js/modules/blog-progress-bar.js"
    /*!*****************************************!*\
      !*** ./js/modules/blog-progress-bar.js ***!
      \*****************************************/: function _js_modules_blogProgressBarJs(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */"default": function _default() {
          return __WEBPACK_DEFAULT_EXPORT__;
        }
        /* harmony export */
      });
      var blogProgressBar = {
        element: document.querySelector('.blog-progress-bar'),
        init: function init() {
          if (!this.element) return;
          var fill = this.element.querySelector('span');
          var getExcludedHeight = function getExcludedHeight() {
            var footer = document.querySelector('footer');
            var lastSection = document.querySelector('.cta-v1');
            var relatdPosts = document.querySelector('.related-posts');
            var footerHeight = footer ? footer.offsetHeight : 0;
            var lastSectionHeight = lastSection ? lastSection.offsetHeight : 0;
            var relatdPostsHeight = relatdPosts ? relatdPosts.offsetHeight : 0;
            return footerHeight + lastSectionHeight + relatdPostsHeight;
          };
          var updateProgressBar = function updateProgressBar() {
            var totalHeight = document.documentElement.scrollHeight - window.innerHeight - getExcludedHeight();
            var scrollTop = window.scrollY;
            var scrollPercent = scrollTop / totalHeight * 100;
            fill.style.width = "".concat(Math.min(Math.max(scrollPercent, 0), 100), "%");
          };
          window.addEventListener('scroll', updateProgressBar);
          updateProgressBar();
        }
      };
      /* harmony default export */
      var __WEBPACK_DEFAULT_EXPORT__ = blogProgressBar;

      /***/
    },
    /***/"./js/modules/color-picker.js"
    /*!************************************!*\
      !*** ./js/modules/color-picker.js ***!
      \************************************/: function _js_modules_colorPickerJs(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */"default": function _default() {
          return __WEBPACK_DEFAULT_EXPORT__;
        }
        /* harmony export */
      });
      /* harmony import */
      var _cv_builder_v2_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./cv-builder-v2.js */"./js/modules/cv-builder-v2.js");
      var colorPicker = {
        pickers: document.querySelectorAll('.oz-color-picker'),
        init: function init() {
          if (colorPicker.pickers.length === 0) return;
          colorPicker.pickers.forEach(function (picker) {
            var realField = picker.querySelector('input');
            var colors = JSON.parse(realField.getAttribute('data-colors'));
            var customColorField = document.querySelector("input[name=".concat(realField.name, "_custom]"));
            var customColorFieldWrap = customColorField === null || customColorField === void 0 ? void 0 : customColorField.closest('.oz-color-picker-custom-wrapper');
            var colorsDOM = document.createElement('div');
            colorsDOM.classList.add('oz-color-picker__wrap');
            var itemSelected = false;
            colors.forEach(function (color, i) {
              var selected = realField.value == color ? 'selected' : '';
              var colorElement = document.createElement('span');
              colorElement.className = "oz-color-picker__color ".concat(selected !== null && selected !== void 0 ? selected : i === 0 ? 'selected' : '');
              colorElement.setAttribute('data-value', color);
              colorElement.style.backgroundColor = color;
              colorsDOM.appendChild(colorElement);
              if (selected) {
                itemSelected = true;
              }
            });
            picker.appendChild(colorsDOM);

            // Custom color field
            if (customColorField && customColorFieldWrap) {
              picker.appendChild(customColorFieldWrap);
            }
            picker.addEventListener('click', function (e) {
              if (e.target.classList.contains('oz-color-picker__color')) {
                var _cv_builder_v2_js__WE;
                picker.querySelectorAll('.oz-color-picker__color').forEach(function (color) {
                  color.classList.remove('selected');
                });
                e.target.classList.add('selected');
                realField.value = e.target.getAttribute('data-value');
                customColorFieldWrap === null || customColorFieldWrap === void 0 || customColorFieldWrap.classList.remove('selected');
                if ((_cv_builder_v2_js__WE = _cv_builder_v2_js__WEBPACK_IMPORTED_MODULE_0__["default"]) !== null && _cv_builder_v2_js__WE !== void 0 && _cv_builder_v2_js__WE.isDesktop) {
                  var _cv_builder_v2_js__WE2;
                  (_cv_builder_v2_js__WE2 = _cv_builder_v2_js__WEBPACK_IMPORTED_MODULE_0__["default"]) === null || _cv_builder_v2_js__WE2 === void 0 || _cv_builder_v2_js__WE2.updatePreview();
                }
              }
            });

            // Custom color picker
            customColorField === null || customColorField === void 0 || customColorField.addEventListener('input', function (e) {
              var color = e.target.value;
              picker.querySelectorAll('.oz-color-picker__color').forEach(function (color) {
                color.classList.remove('selected');
              });
              realField.value = color;
              customColorFieldWrap === null || customColorFieldWrap === void 0 || customColorFieldWrap.classList.add('selected');
            });
            if (!itemSelected && (customColorField === null || customColorField === void 0 ? void 0 : customColorField.value.toLowerCase()) !== '#000000') {
              customColorFieldWrap === null || customColorFieldWrap === void 0 || customColorFieldWrap.classList.add('selected');
            }
          });
        }
      };
      /* harmony default export */
      var __WEBPACK_DEFAULT_EXPORT__ = colorPicker;

      /***/
    },
    /***/"./js/modules/common.js"
    /*!******************************!*\
      !*** ./js/modules/common.js ***!
      \******************************/: function _js_modules_commonJs(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */"default": function _default() {
          return __WEBPACK_DEFAULT_EXPORT__;
        }
        /* harmony export */
      });
      var common = {
        forms: document.querySelectorAll('form'),
        init: function init() {
          if (this.forms.length === 0) return;
          this.forms.forEach(function (form) {
            form.querySelectorAll('input, textarea, select, checkbox, radio').forEach(function (field) {
              var enableActionBtn = function enableActionBtn() {
                setTimeout(function () {
                  var _form$querySelector;
                  (_form$querySelector = form.querySelector('input[type="submit"]')) === null || _form$querySelector === void 0 || _form$querySelector.removeAttribute('disabled');
                }, 500);
              };
              field.addEventListener('keyup', enableActionBtn);
              field.addEventListener('change', enableActionBtn);
            });
          });
        }
      };
      /* harmony default export */
      var __WEBPACK_DEFAULT_EXPORT__ = common;

      /***/
    },
    /***/"./js/modules/custom-range.js"
    /*!************************************!*\
      !*** ./js/modules/custom-range.js ***!
      \************************************/: function _js_modules_customRangeJs(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */"default": function _default() {
          return __WEBPACK_DEFAULT_EXPORT__;
        }
        /* harmony export */
      });
      var customRange = {
        init: function init() {
          var _this4 = this;
          var rangeFields = document.querySelectorAll('.oz-range');
          if (rangeFields.length === 0) return;
          rangeFields.forEach(function (field) {
            var _range$getAttribute;
            var range = field.querySelector('input[type="range"]'),
              value = field.querySelector('.range-value'),
              suffix = (_range$getAttribute = range.getAttribute('data-suffix')) !== null && _range$getAttribute !== void 0 ? _range$getAttribute : '';

            // Set fill range
            if (field.querySelectorAll('.range-fill').length === 0) {
              var fill = document.createElement('span');
              fill.classList.add('range-fill');
              field.appendChild(fill);
            }
            _this4.fillRange(field);

            // Get the final value (default value or data-values)
            var getFinalValue = function getFinalValue() {
              var finalVal = range.value;
              if (range.getAttribute('data-values')) {
                finalVal = JSON.parse(range.getAttribute('data-values'))[range.value];
              }
              return finalVal;
            };
            value.innerHTML = "".concat(getFinalValue()).concat(suffix);
            range.addEventListener('input', function () {
              value.innerHTML = "".concat(getFinalValue()).concat(suffix); // Update value
              _this4.fillRange(field);
            });
          });
        },
        // Fill custom range
        fillRange: function fillRange(field) {
          var range = field.querySelector('input[type="range"]');
          var fill = field.querySelector('.range-fill');
          var val = +range.value;
          var min = +range.min || 0;
          var max = +range.max || 100;
          var percent = (val - min) / (max - min);
          fill.style.width = "".concat(percent * 100, "%");
        }
      };
      /* harmony default export */
      var __WEBPACK_DEFAULT_EXPORT__ = customRange;

      /***/
    },
    /***/"./js/modules/cv-builder-v2.js"
    /*!*************************************!*\
      !*** ./js/modules/cv-builder-v2.js ***!
      \*************************************/: function _js_modules_cvBuilderV2Js(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */"default": function _default() {
          return __WEBPACK_DEFAULT_EXPORT__;
        }
        /* harmony export */
      });
      /* harmony import */
      var _vendor_ozz_wyg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../vendor/ozz-wyg */"./js/vendor/ozz-wyg.js");
      /* harmony import */
      var _vendor_Sortable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../vendor/Sortable */"./js/vendor/Sortable.js");
      /* harmony import */
      var _utils_FormHandler__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils/FormHandler */"./js/utils/FormHandler.js");
      /* harmony import */
      var _utils_variables__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils/variables */"./js/utils/variables.js");
      /* harmony import */
      var _utils_Fetch__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../utils/Fetch */"./js/utils/Fetch.js");
      /* harmony import */
      var _color_picker__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./color-picker */"./js/modules/color-picker.js");
      /* harmony import */
      var _utils_StructureFormData__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../utils/StructureFormData */"./js/utils/StructureFormData.js");
      /* harmony import */
      var _utils_UpdateUrl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/UpdateUrl */"./js/utils/UpdateUrl.js");
      /* harmony import */
      var _date_picker__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./date-picker */"./js/modules/date-picker.js");
      var cvBuilderV2 = {
        builderDOM: document.querySelector('.cv-builder-v2'),
        builderSlider: document.querySelector('.cv-builder-v2__slider'),
        themePresetDOM: document.getElementById('cv_builder_theme'),
        templateInputField: document.querySelector('#cv_builder_theme input[name="temp"]'),
        resetPresetsBtn: document.getElementById('reset_template_presets'),
        blocks: false,
        currentSlide: false,
        prevBtn: false,
        nextBtn: false,
        currentSlideIndex: 0,
        responseNotRecived: false,
        isDesktop: window.innerWidth >= 1200,
        isPreviewOpen: false,
        init: function init() {
          if (!cvBuilderV2.builderSlider) return;
          cvBuilderV2.initSlider();
          cvBuilderV2.initWygEditors();
          cvBuilderV2.settingsMenu();
          cvBuilderV2.templateSelectorPopup();
          cvBuilderV2.skillsRatingTypeSelector();
          cvBuilderV2.initMoreFieldsAccordion();
          cvBuilderV2.livePreviewUpdate();
          cvBuilderV2.resetTemplatePresets();
          _date_picker__WEBPACK_IMPORTED_MODULE_8__["default"].init();
          if (cvBuilderV2.isDesktop) {
            cvBuilderV2.updatePreview();
          }
          window.addEventListener('load', cvBuilderV2.scaleIframePreview);
          window.addEventListener('resize', function () {
            cvBuilderV2.scaleIframePreview();
            cvBuilderV2.isDesktop = window.innerWidth >= 1200;

            // Always open the preview on desktop when resized
            if (cvBuilderV2.isDesktop && !cvBuilderV2.isPreviewOpen) {
              cvBuilderV2.updatePreview();
            }
          });
          window.addEventListener('message', function (e) {
            var _e$data;
            if (e.origin == 'null' && ((_e$data = e.data) === null || _e$data === void 0 ? void 0 : _e$data.source) === 'request_prky') {
              cvBuilderV2.sendPrky();
            }
          });
        },
        showLoading: function showLoading() {
          var loadingDOM = document.querySelector('#loadingDOM');
          loadingDOM.classList.add('active');
        },
        removeLoading: function removeLoading() {
          var loadingDOM = document.querySelector('#loadingDOM');
          loadingDOM.classList.remove('active');
        },
        /**
         * Approve preview
         */
        sendPrky: function sendPrky() {
          var iframe = document.querySelector('#temp_live_preview iframe');
          if (iframe) {
            iframe.contentWindow.postMessage({
              source: '__pr_key_vld'
            }, '*');
          }
        },
        /**
         * Scale preview iframe automatically
         */
        scaleIframePreview: function scaleIframePreview() {
          var previewWrapper = document.querySelector('.cv-builder-v2__previewer');
          if (!previewWrapper) return;
          var livePreview = previewWrapper.querySelector('.live-preview');
          if (!livePreview) return;
          var iframe = livePreview.querySelector('iframe');
          var baseWidth = 794; // original A4 width
          var availableWidth = previewWrapper.getBoundingClientRect().width - (cvBuilderV2.isDesktop ? 60 : 20);
          var scale = Math.min(availableWidth / baseWidth, 1);
          if (iframe) {
            var scaledHeight = (iframe.offsetHeight || 0) * scale + 10;
            livePreview.style.transform = "scale(".concat(scale, ")");
            livePreview.style.width = "".concat(baseWidth, "px");
            livePreview.style.height = "".concat(scaledHeight, "px");
            livePreview.style.overflow = 'visible';
          } else {
            livePreview.style.transform = 'none';
            livePreview.style.width = 'auto';
            livePreview.style.height = 'auto';
            livePreview.style.overflow = 'visible';
          }
        },
        /**
         * Initialize ozz wysiwyg editors
         * @returns 
         */
        initWygEditors: function initWygEditors() {
          new _vendor_ozz_wyg__WEBPACK_IMPORTED_MODULE_0__["default"]({
            selector: '.cv-builder-v2 [data-ozz-wyg]',
            tools: _utils_variables__WEBPACK_IMPORTED_MODULE_3__.BASIC_WYG_TOOLS
          });
        },
        initSlider: function initSlider() {
          cvBuilderV2.blocks = cvBuilderV2.builderSlider.querySelectorAll('.cv-builder-v2__block');
          cvBuilderV2.prevBtn = cvBuilderV2.builderSlider.querySelector('.prev-btn');
          cvBuilderV2.nextBtn = cvBuilderV2.builderSlider.querySelector('.next-btn');
          var previewBtn = document.querySelectorAll('.cv_preview_button');
          var previewAndCloseMobileTrigger = document.querySelectorAll('.cv_preview_button_mobile');
          cvBuilderV2.makeSortable();
          cvBuilderV2.buildNavigator();
          cvBuilderV2.blocks.forEach(function (block, i) {
            block.setAttribute('data-index', i);
          });

          // Initial State
          cvBuilderV2.blocks[0].classList.add('active');
          cvBuilderV2.currentSlide = cvBuilderV2.blocks[0]; // Set current slide
          cvBuilderV2.nextBtn.classList.add('active');

          // Button Events
          cvBuilderV2.prevBtn.addEventListener('click', function (e) {
            e.preventDefault();
            cvBuilderV2.prevSlide();
          });
          cvBuilderV2.nextBtn.addEventListener('click', function (e) {
            e.preventDefault();
            cvBuilderV2.nextSlide();
          });

          // On submit
          document.querySelector('form[name=cv-builder-v2]').addEventListener('submit', function (e) {
            e.preventDefault();
            if (!cvBuilderV2.validateSlide()) return;
            return (0, _utils_FormHandler__WEBPACK_IMPORTED_MODULE_2__["default"])({
              target: document.querySelector('form[name=cv-builder-v2]')
            });
          });
          cvBuilderV2.updateBlockLabels();

          // Preview CV
          previewBtn === null || previewBtn === void 0 || previewBtn.forEach(function (btn) {
            btn.addEventListener('click', function (e) {
              e.preventDefault();
              cvBuilderV2.updatePreview();
            });
          });

          // Preview and close (Mobile)
          previewAndCloseMobileTrigger === null || previewAndCloseMobileTrigger === void 0 || previewAndCloseMobileTrigger.forEach(function (btn) {
            btn.addEventListener('click', function (e) {
              e.preventDefault();
              var previewPopup = document.querySelector('.cv-builder-v2__previewer');
              if (previewPopup.classList.contains('active')) {
                btn.classList.remove('opened');
                cvBuilderV2.closePreview();
              } else {
                btn.classList.add('opened');
                cvBuilderV2.updatePreview();
              }
            });
          });
        },
        /**
         * Update Block label on update
         */
        updateBlockLabels: function updateBlockLabels() {
          cvBuilderV2.builderSlider.querySelectorAll('.oz-repeater__block').forEach(function (block) {
            var primaryFields = block.querySelectorAll('input.primary');
            primaryFields.forEach(function (field) {
              var defaultLabel = block.querySelector('.accordion__head .label').getAttribute('data-default');
              field.addEventListener('keyup', function () {
                if (field.value == '') {
                  block.querySelector('.accordion__head .label').textContent = defaultLabel;
                } else {
                  block.querySelector('.accordion__head .label').textContent = field.value;
                }
              });
            });
          });
        },
        /**
         * Make block items sortable
         */
        makeSortable: function makeSortable() {
          var blockWrappers = cvBuilderV2.builderSlider.querySelectorAll('.oz-repeater__area');
          blockWrappers.forEach(function (section) {
            new _vendor_Sortable__WEBPACK_IMPORTED_MODULE_1__["default"](section, {
              animation: 150,
              handle: '.drag-handle',
              ghostClass: 'blue-background-class',
              onSort: function onSort() {
                cvBuilderV2.indexFieldNames(section);
                cvBuilderV2.updatePreview();
              }
            });
          });
        },
        /**
         * Re index field names by block order
         */
        indexFieldNames: function indexFieldNames(section) {
          var blocks = section.querySelectorAll('.oz-repeater__block');
          blocks.forEach(function (block, i) {
            block.querySelectorAll('input, textarea, progress, meter, select, datalist').forEach(function (field) {
              field.name = field.name.replace(/\[\d+\]/, "[".concat(i, "]"));
            });
            block.querySelectorAll('[data-ozz-wyg]').forEach(function (wygField) {
              wygField.setAttribute('data-field-name', wygField.getAttribute('data-field-name').replace(/\[\d+\]/, "[".concat(i, "]")));
            });
          });
        },
        /**
         * Build Top navigator
         */
        buildNavigator: function buildNavigator() {
          var topNav = document.querySelector('.cv-builder-v2__navigator');
          var navDOM = '';
          cvBuilderV2.blocks.forEach(function (block, i) {
            var title = block.querySelector('h2').getAttribute('data-top-label');
            navDOM += "<div class=\"cv-builder-v2__navigator-tab tab-index-".concat(i, " ").concat(i == 0 ? 'active current' : '', "\" data-tabindex=\"").concat(i, "\">\n        <span class=\"title\">").concat(title, "</span>\n      </div>");
          });
          topNav.innerHTML = navDOM;
          topNav.addEventListener('click', function (e) {
            var clickedTab = e.target.classList.contains('cv-builder-v2__navigator-tab') ? e.target : e.target.closest('.cv-builder-v2__navigator-tab');
            if (clickedTab) {
              cvBuilderV2.moveToSlide(clickedTab.getAttribute('data-tabindex'));
            }
          });
        },
        /**
         * Activate navigation tabs
         */
        activateTabs: function activateTabs() {
          document.querySelectorAll('.cv-builder-v2__navigator-tab').forEach(function (tab, i) {
            tab.classList.remove('current');
            if (i > cvBuilderV2.currentSlideIndex) {
              tab.classList.remove('active');
            } else {
              tab.classList.add('active');
              if (cvBuilderV2.currentSlideIndex == i) {
                tab.classList.add('current');
              }
            }
          });
        },
        /**
         * Update CV preview
         */
        updatePreview: function updatePreview() {
          if (!cvBuilderV2.isDesktop) {
            cvBuilderV2.closeSettingsMenu();
          }
          var previewPopup = document.querySelector('.cv-builder-v2__previewer');
          var previewDOM = document.getElementById('temp_live_preview');
          var form = document.querySelector('form[name=cv-builder-v2]');
          var data = (0, _utils_StructureFormData__WEBPACK_IMPORTED_MODULE_6__["default"])(form);
          if (cvBuilderV2.responseNotRecived) return;
          previewPopup.classList.remove('active');
          cvBuilderV2.showLoading();
          cvBuilderV2.responseNotRecived = true;
          var getPreview = (0, _utils_Fetch__WEBPACK_IMPORTED_MODULE_4__.send)('/cv-preview', 'POST', JSON.stringify(data));
          getPreview.then(function (response) {
            previewDOM.innerHTML = response.preview;
            cvBuilderV2.responseNotRecived = false;
            document.body.classList.add('prevent-scroll');
            window.addEventListener('message', function (e) {
              var _e$data2, _e$data3, _e$data4, _e$data5, _e$data6;
              // iFrame ready
              if (e.origin == 'null' && ((_e$data2 = e.data) === null || _e$data2 === void 0 ? void 0 : _e$data2.source) === 'iframeReady') {
                cvBuilderV2.updateLiveImageObj();
                previewPopup.classList.add('active');
                cvBuilderV2.removeLoading();
              }

              // Setup iframe height
              if (e.origin == 'null' && ((_e$data3 = e.data) === null || _e$data3 === void 0 ? void 0 : _e$data3.source) === 'iframeBase64') {
                previewDOM.querySelector('iframe').style.height = "".concat(e.data.height + 15, "px");
                cvBuilderV2.scaleIframePreview();
              }

              // Re-order sections
              if (e.origin == 'null' && ((_e$data4 = e.data) === null || _e$data4 === void 0 ? void 0 : _e$data4.source) === 'sectionOrder') {
                form.querySelector('[name=section_order]').value = e.data.order;
              }

              // Move to section editor form area
              if (e.origin == 'null' && ((_e$data5 = e.data) === null || _e$data5 === void 0 ? void 0 : _e$data5.source) === 'routeToFormSection') {
                cvBuilderV2.moveToSlide(e.data.formSlide);
              }

              // Live update if missing field (if DOM is not already rendered)
              if (e.origin == 'null' && ((_e$data6 = e.data) === null || _e$data6 === void 0 ? void 0 : _e$data6.source) === 'cvBuilderV2_live_update_missing_field') {
                cvBuilderV2.updatePreview();
              }
            });
          });
          cvBuilderV2.isPreviewOpen = true;
        },
        /**
         * Close CV Previewer
         */
        closePreview: function closePreview() {
          document.querySelector('.cv-builder-v2__previewer').classList.remove('active');
          document.getElementById('temp_live_preview').innerHTML = '';
          cvBuilderV2.closeSettingsMenu();
          document.body.classList.remove('prevent-scroll');
          cvBuilderV2.isPreviewOpen = false;
          var previewAndCloseMobileTrigger = document.querySelectorAll('.cv_preview_button_mobile');
          previewAndCloseMobileTrigger === null || previewAndCloseMobileTrigger === void 0 || previewAndCloseMobileTrigger.forEach(function (btn) {
            btn.classList.remove('opened');
          });
        },
        /**
         * Move to previouse slider
         */
        prevSlide: function prevSlide() {
          var prevIndex = parseInt(cvBuilderV2.currentSlideIndex) - 1;
          cvBuilderV2.moveToSlide(prevIndex);
        },
        /**
         * Move to next slider
         */
        nextSlide: function nextSlide() {
          var nextIndex = parseInt(cvBuilderV2.currentSlideIndex) + 1;
          cvBuilderV2.moveToSlide(nextIndex);
        },
        /**
         * Move to a specific slide
         * @param {number} index - The index of the slide to move to
         */
        moveToSlide: function moveToSlide(index) {
          if (index < 0 || index >= cvBuilderV2.blocks.length) return;

          // Validation for first slide
          if (!cvBuilderV2.validateSlide()) return;
          cvBuilderV2.currentSlide.classList.remove('active');
          cvBuilderV2.blocks[index].classList.add('active');
          cvBuilderV2.currentSlide = cvBuilderV2.blocks[index];
          cvBuilderV2.currentSlideIndex = parseInt(index);
          if (cvBuilderV2.currentSlide.getAttribute('data-index') == 0) {
            cvBuilderV2.prevBtn.classList.remove('active');
            cvBuilderV2.prevBtn.setAttribute('disabled', true);
          } else {
            cvBuilderV2.prevBtn.classList.add('active');
            cvBuilderV2.prevBtn.removeAttribute('disabled', true);
          }
          if (cvBuilderV2.currentSlide.getAttribute('data-index') == cvBuilderV2.blocks.length - 1) {
            cvBuilderV2.nextBtn.classList.remove('active');
            cvBuilderV2.nextBtn.setAttribute('disabled', true);
          } else {
            cvBuilderV2.nextBtn.classList.add('active');
            cvBuilderV2.nextBtn.removeAttribute('disabled', true);
          }
          cvBuilderV2.activateTabs();
        },
        /**
         *  Validate mandatory fields
         * @returns
         */
        validateSlide: function validateSlide() {
          var fName = cvBuilderV2.builderDOM.querySelector('input[name="first_name"]'),
            lName = cvBuilderV2.builderDOM.querySelector('input[name="surname"]'),
            email = cvBuilderV2.builderDOM.querySelector('input[name="email"]'),
            industry = cvBuilderV2.builderDOM.querySelector('select[name="industry"]'),
            profession = cvBuilderV2.builderDOM.querySelector('input[name="profession"]');
          var isValid = true;
          var fields = [{
            field: fName,
            errorMessage: 'First name is required'
          }, {
            field: lName,
            errorMessage: 'Surname is required'
          }, {
            field: email,
            errorMessage: 'Email is required'
          }, {
            field: industry,
            errorMessage: 'Industry is required'
          }, {
            field: profession,
            errorMessage: 'Profession is required'
          }];
          var makeError = function makeError(field, errorMessage) {
            var _parent$querySelector;
            var parent = field === null || field === void 0 ? void 0 : field.parentElement;
            field.classList.add('error');
            (_parent$querySelector = parent.querySelector('.field-error')) === null || _parent$querySelector === void 0 || _parent$querySelector.remove();
            var errorEl = document.createElement('span');
            errorEl.classList.add('field-error');
            errorEl.textContent = errorMessage;
            parent.appendChild(errorEl);
          };
          var clearError = function clearError(field) {
            var _field$parentElement$;
            field.classList.remove('error');
            (_field$parentElement$ = field.parentElement.querySelector('.field-error')) === null || _field$parentElement$ === void 0 || _field$parentElement$.remove();
          };
          fields.forEach(function (item) {
            var _item$field;
            if (!((_item$field = item.field) !== null && _item$field !== void 0 && _item$field.value.trim())) {
              isValid = false;
              makeError(item.field, item.errorMessage);
            } else if (item.field.name == 'email') {
              var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              if (!emailRegex.test(item.field.value)) {
                isValid = false;
                makeError(item.field, 'Invalid email address');
              } else {
                clearError(item.field);
              }
            } else {
              clearError(item.field);
            }
            item.field.addEventListener('input', function (e) {
              if (e.target.value !== '') {
                clearError(item.field);
              } else {
                makeError(item.field, item.errorMessage);
              }
            });
          });
          return isValid;
        },
        /**
         * Mobile settings menu toggle
         */
        settingsMenu: function settingsMenu() {
          var _document$querySelect;
          var toggleClass = function toggleClass() {
            if (cvBuilderV2.builderDOM.classList.contains('state__settings-open')) {
              cvBuilderV2.closeSettingsMenu();
            } else {
              cvBuilderV2.openSettingsMenu();
            }
            setTimeout(function () {
              cvBuilderV2.scaleIframePreview();
            }, 302);
          };
          (_document$querySelect = document.querySelector('.settings-menu-trigger')) === null || _document$querySelect === void 0 || _document$querySelect.addEventListener('click', toggleClass);
        },
        /**
         * Open Mobile Settings Menu
         * @returns {void}
         */
        openSettingsMenu: function openSettingsMenu() {
          if (!cvBuilderV2.isDesktop) {
            cvBuilderV2.closePreview();
          }
          cvBuilderV2.builderDOM.classList.add('state__settings-open');
          cvBuilderV2.scaleIframePreview();
          document.body.classList.add('prevent-scroll');
        },
        /**
         * Close Mobile Settings Menu
         * @returns {void}
         */
        closeSettingsMenu: function closeSettingsMenu() {
          cvBuilderV2.builderDOM.classList.remove('state__settings-open');
          cvBuilderV2.scaleIframePreview();
          document.body.classList.remove('prevent-scroll');
        },
        /**
         * Open popup and reset presets on select a template
         */
        templateSelectorPopup: function templateSelectorPopup() {
          var selectorDOM = document.querySelector('.template-selector');
          var trigger = document.getElementById('change_template_trigger');
          if (!selectorDOM || !trigger) return;
          trigger.addEventListener('click', function () {
            selectorDOM.classList.add('active');
          });

          // Activate selected template by default
          var selectedTemplateThumb = document.querySelector("[data-template=\"".concat(cvBuilderV2.templateInputField.value, "\"]"));
          selectedTemplateThumb.classList.add('selected');
          var templates = selectorDOM.querySelectorAll('.template');
          templates.forEach(function (template) {
            template.addEventListener('click', function () {
              templates.forEach(function (tmp) {
                tmp.classList.remove('selected');
              }); // clear selected classes
              template.classList.add('selected');
              var tempName = template.getAttribute('data-template');
              var tempData = (0, _utils_Fetch__WEBPACK_IMPORTED_MODULE_4__.send)("/api/template/".concat(tempName));
              tempData.then(function (response) {
                cvBuilderV2.updateTemplatePresets(response);
              });
            });
          });

          // Close popup
          var closePopup = function closePopup() {
            selectorDOM.classList.remove('active');
            if (cvBuilderV2.isDesktop || cvBuilderV2.isPreviewOpen) {
              cvBuilderV2.updatePreview();
            }
          };
          selectorDOM.querySelector('.template-selector__close-popup').addEventListener('click', closePopup);
          selectorDOM.addEventListener('click', function (e) {
            if (!e.target.classList.contains('card-box') && !e.target.closest('.card-box')) {
              closePopup();
            }
          });
        },
        updateTemplatePresets: function updateTemplatePresets(tempData) {
          if (!cvBuilderV2.themePresetDOM) return;

          // Set template input value
          cvBuilderV2.templateInputField.value = tempData.slug;
          (0, _utils_UpdateUrl__WEBPACK_IMPORTED_MODULE_7__["default"])('temp', tempData.slug);

          //Update default values for template presets
          var fields = cvBuilderV2.builderDOM.querySelectorAll('[data-default]');
          fields.forEach(function (field) {
            var name = "df_".concat(field.dataset.dfName);
            if (tempData.content[name]) {
              field.dataset["default"] = tempData.content[name] || '';
            }
          });

          // Update color pickers
          var colorPickers = document.querySelectorAll('.oz-color-picker');
          colorPickers.forEach(function (picker) {
            var _picker$querySelector;
            var name = picker.querySelector('input').name;
            var colors;
            switch (name) {
              case 'color_primary':
                colors = tempData.content.primary;
                break;
              case 'secondary_color':
                colors = tempData.content.secondary_color;
                break;
              default:
                colors = tempData.content.primary;
                break;
            }
            (_picker$querySelector = picker.querySelector('.oz-color-picker__wrap')) === null || _picker$querySelector === void 0 || _picker$querySelector.remove();
            picker.querySelector('input').setAttribute('data-colors', JSON.stringify(colors));
          });
          _color_picker__WEBPACK_IMPORTED_MODULE_5__["default"].init(); // set color pickers
        },
        /**
         * Update rating field by skills rating type
         * @returns {void}
         */
        skillsRatingTypeSelector: function skillsRatingTypeSelector() {
          var ratingTypeField = cvBuilderV2.builderSlider.querySelector('input[name=skills_rating_type]');
          if (!ratingTypeField) return;

          // Update rating fields
          var rangeFields = ratingTypeField.closest('.cv-builder-v2__block.skills').querySelectorAll('input[type=range]');
          var updateRatingField = function updateRatingField(val) {
            if (val == 'No Rating') {
              rangeFields.forEach(function (range) {
                range.closest('.oz-range').classList.add('disabled');
                range.setAttribute('disabled', true);
              });
            } else {
              rangeFields.forEach(function (range) {
                range.closest('.oz-range').classList.remove('disabled');
                range.removeAttribute('disabled', true);
              });
            }
          };
          var fields = ratingTypeField.closest('.ozz-fm__radio-wrapper').querySelectorAll('input[type=radio]');
          fields.forEach(function (radio) {
            if (radio.checked) updateRatingField(radio.value);
            radio.addEventListener('change', function () {
              if (radio.checked) updateRatingField(radio.value);
            });
          });
        },
        /**
         * Additional fields under Contact slide
         */
        initMoreFieldsAccordion: function initMoreFieldsAccordion() {
          var accDom = cvBuilderV2.builderDOM.querySelector('.contact--more-info');
          if (!accDom) return;
          accDom.addEventListener('click', function (e) {
            if (!e.target.closest('.optional-fields')) {
              accDom.classList.toggle('active');
            }
          });
          if (accDom.querySelectorAll('.field-error').length > 0) {
            accDom.classList.add('active');
          }
          accDom.querySelectorAll('input, select').forEach(function (field) {
            if (field.value !== '') {
              accDom.classList.add('active');
            }
          });
        },
        /**
         * Update preview if there is an image already selected
         */
        updateLiveImageObj: function updateLiveImageObj() {
          var _form$querySelector2;
          var form = document.querySelector('form[name=cv-builder-v2]');
          var iframe = document.querySelector('#temp_live_preview iframe');
          if (iframe && ((_form$querySelector2 = form.querySelector('input[name="photo"]')) === null || _form$querySelector2 === void 0 ? void 0 : _form$querySelector2.value) !== '') {
            var data = (0, _utils_StructureFormData__WEBPACK_IMPORTED_MODULE_6__["default"])(form);
            iframe.contentWindow.postMessage({
              source: 'cvBuilderV2_live_update_request',
              data: data,
              fieldName: 'photo'
            }, '*');
          }
        },
        /**
         * Live update iframe preview on form fields change
         */
        livePreviewUpdate: function livePreviewUpdate() {
          var form = document.querySelector('form[name=cv-builder-v2]');
          form.querySelectorAll('input, textarea, select, [data-ozz-wyg]').forEach(function (field) {
            var handler = function handler() {
              var iframe = document.querySelector('#temp_live_preview iframe');
              if (iframe) {
                var data = (0, _utils_StructureFormData__WEBPACK_IMPORTED_MODULE_6__["default"])(form);
                iframe.contentWindow.postMessage({
                  source: 'cvBuilderV2_live_update_request',
                  data: data,
                  fieldName: field.name
                }, '*');
              }
            };
            var excludedFields = ['industry'];
            if (!excludedFields.includes(field.name)) {
              if (field.type == 'checkbox' || field.type == 'radio' || field.type == 'range') {
                field.addEventListener('change', handler);
              } else if (field.type == 'file') {
                field.addEventListener('change', function () {
                  // Validate file size (Max: 1MB) and Format
                  var _field$files = _slicedToArray(field.files, 1),
                    file = _field$files[0];
                  var allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
                  if (!file || file.size > 1048576 || !allowedTypes.includes(file.type)) {
                    return;
                  }
                  handler();
                });
              } else if (field.hasAttribute('data-ozz-wyg')) {
                field.addEventListener('ozzwyg:input', function () {
                  field.name = field.getAttribute('data-field-name');
                  handler();
                });
              } else {
                field.addEventListener('input', handler);
              }
            }
          });
        },
        /**
         * Reset template presets to default values
         */
        resetTemplatePresets: function resetTemplatePresets() {
          var _cvBuilderV2$resetPre;
          var fields = cvBuilderV2.builderDOM.querySelectorAll('[data-default]');
          (_cvBuilderV2$resetPre = cvBuilderV2.resetPresetsBtn) === null || _cvBuilderV2$resetPre === void 0 || _cvBuilderV2$resetPre.addEventListener('click', function () {
            cvBuilderV2.resetPresetsBtn.classList.add('disabled');
            fields.forEach(function (field) {
              var defaultValue = field.getAttribute('data-default');
              field.value = defaultValue;
              field.dispatchEvent(new Event('input', {
                bubbles: true
              }));
              field.dispatchEvent(new Event('change', {
                bubbles: true
              }));
            });
            setTimeout(function () {
              cvBuilderV2.resetPresetsBtn.classList.remove('disabled');
            }, 5000);
          });
        }
      };
      /* harmony default export */
      var __WEBPACK_DEFAULT_EXPORT__ = cvBuilderV2;

      /***/
    },
    /***/"./js/modules/cv-delete-action.js"
    /*!****************************************!*\
      !*** ./js/modules/cv-delete-action.js ***!
      \****************************************/: function _js_modules_cvDeleteActionJs(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */"default": function _default() {
          return __WEBPACK_DEFAULT_EXPORT__;
        }
        /* harmony export */
      });
      var cvDeleteAction = {
        init: function init() {
          var deleteForms = document.querySelectorAll('form[name=delete-cv-form]');
          if (deleteForms.length === 0) return;
          deleteForms.forEach(function (form) {
            form.addEventListener('submit', function (e) {
              e.preventDefault();
              var confirmationMessage = "Are you sure you want to delete this item? \n[ Resume - ".concat(form.getAttribute('data-cv-name'), " ]");
              if (confirm(confirmationMessage)) {
                form.submit();
              }
            });
          });
        }
      };
      /* harmony default export */
      var __WEBPACK_DEFAULT_EXPORT__ = cvDeleteAction;

      /***/
    },
    /***/"./js/modules/date-picker.js"
    /*!***********************************!*\
      !*** ./js/modules/date-picker.js ***!
      \***********************************/: function _js_modules_datePickerJs(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */"default": function _default() {
          return __WEBPACK_DEFAULT_EXPORT__;
        }
        /* harmony export */
      });
      var datePicker = {
        init: function init() {
          var datePickers = document.querySelectorAll('.datepicker');
          if (datePickers.length === 0 || typeof AirDatepicker == 'undefined') return;
          var lang = {
            en: {
              days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
              daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
              daysMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
              months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
              monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
              today: 'Today',
              clear: 'Clear',
              dateFormat: 'MM/dd/yyyy',
              firstDay: 0
            }
          };
          datePickers.forEach(function (datePicker) {
            var options = {
              view: 'months',
              minView: 'months',
              dateFormat: 'MMMM yyyy',
              locale: lang.en,
              autoClose: true,
              onSelect: function onSelect() {
                datePicker.dispatchEvent(new Event('input', {
                  bubbles: true
                }));
              }
            };
            new AirDatepicker(datePicker, options);
          });
        }
      };
      /* harmony default export */
      var __WEBPACK_DEFAULT_EXPORT__ = datePicker;

      /***/
    },
    /***/"./js/modules/hash-route.js"
    /*!**********************************!*\
      !*** ./js/modules/hash-route.js ***!
      \**********************************/: function _js_modules_hashRouteJs(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */"default": function _default() {
          return __WEBPACK_DEFAULT_EXPORT__;
        }
        /* harmony export */
      });
      var hashRoute = {
        init: function init() {
          var route = function route() {
            var _document$querySelect2, _document$querySelect3;
            if (document.querySelectorAll('[data-section]').length === 0 || document.querySelectorAll('[data-hash-router]').length === 0) return;
            var link = location.hash.slice(1) || 'edit-profile';
            var targetSection = document.querySelector("[data-section=".concat(link, "]"));
            var activeAnchor = document.querySelector("a[href=\"#".concat(link, "\"]"));
            (_document$querySelect2 = document.querySelectorAll('.hash-active-section')) === null || _document$querySelect2 === void 0 || _document$querySelect2.forEach(function (item) {
              item.classList.remove('hash-active-section');
            });
            (_document$querySelect3 = document.querySelectorAll('.hash-active-link')) === null || _document$querySelect3 === void 0 || _document$querySelect3.forEach(function (item) {
              item.classList.remove('hash-active-link');
            });
            targetSection === null || targetSection === void 0 || targetSection.classList.add('hash-active-section');
            activeAnchor === null || activeAnchor === void 0 || activeAnchor.classList.add('hash-active-link');
          };
          window.addEventListener('hashchange', route);
          window.onload = function () {
            return route();
          };
        }
      };
      /* harmony default export */
      var __WEBPACK_DEFAULT_EXPORT__ = hashRoute;

      /***/
    },
    /***/"./js/modules/header.js"
    /*!******************************!*\
      !*** ./js/modules/header.js ***!
      \******************************/: function _js_modules_headerJs(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */"default": function _default() {
          return __WEBPACK_DEFAULT_EXPORT__;
        }
        /* harmony export */
      });
      var header = {
        mobileNavToggle: function mobileNavToggle() {
          var theHeader = document.querySelector('header');
          if (!theHeader) return;
          theHeader.addEventListener('click', function (e) {
            if (e.target.closest('a') || e.target.tag === 'A') {
              theHeader.classList.remove('mobile-active');
              document.body.classList.remove('mobile-nav-active');
            }
          });
          var trigger = theHeader.querySelector('.header-hamburger');
          trigger.addEventListener('click', function (e) {
            e.preventDefault();
            theHeader.classList.toggle('mobile-active');
            if (theHeader.classList.contains('mobile-active')) {
              document.body.classList.add('mobile-nav-active');
            } else {
              document.body.classList.remove('mobile-nav-active');
            }
          });
        }
      };
      /* harmony default export */
      var __WEBPACK_DEFAULT_EXPORT__ = header;

      /***/
    },
    /***/"./js/modules/highlight-text.js"
    /*!**************************************!*\
      !*** ./js/modules/highlight-text.js ***!
      \**************************************/: function _js_modules_highlightTextJs(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */"default": function _default() {
          return __WEBPACK_DEFAULT_EXPORT__;
        }
        /* harmony export */
      });
      var highlightText = {
        texts: document.querySelectorAll('[data-highlight]'),
        highlight: function highlight() {
          highlightText.texts.forEach(function (text) {
            var textToHighlight = text.getAttribute(['data-highlight']);
            var regex = new RegExp(textToHighlight, 'g');
            text.innerHTML = text.innerHTML.replace(regex, "<span class=\"highlight-txt\">".concat(textToHighlight, "</span>"));
          });
        }
      };
      /* harmony default export */
      var __WEBPACK_DEFAULT_EXPORT__ = highlightText;

      /***/
    },
    /***/"./js/modules/icon-selector.js"
    /*!*************************************!*\
      !*** ./js/modules/icon-selector.js ***!
      \*************************************/: function _js_modules_iconSelectorJs(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */"default": function _default() {
          return __WEBPACK_DEFAULT_EXPORT__;
        }
        /* harmony export */
      });
      var iconSelector = {
        selectors: document.querySelectorAll('[data-icon-selector]'),
        init: function init() {
          var _this5 = this;
          this.selectors = document.querySelectorAll('[data-icon-selector]');
          if (this.selectors.length === 0) return;
          this.selectors.forEach(function (selector) {
            _this5.initSelector(selector);
          });
        },
        initSelector: function initSelector(selector) {
          var input = selector.querySelector('input');
          var iconsWrapper = document.createElement('div');
          var button = selector.querySelector('.select-button');

          // Show initially selected icon on button
          button.querySelector('span').style.backgroundPosition = input.value || '0px 0px';
          var icons = '';
          var xy = ['0px 0px', '-34px 0px', '-68px 0px', '-102px 0px', '-136px 0px', '-170px 0px', '0px -34px', '-34px -34px', '-68px -34px', '-102px -34px', '-136px -34px', '-170px -34px', '0px -68px', '-34px -68px', '-68px -68px', '-102px -68px', '-136px -68px', '-170px -68px', '0px -102px', '-34px -102px', '-68px -102px', '-102px -102px', '-136px -102px', '-170px -102px', '0px -136px', '-34px -136px', '-68px -136px', '-102px -136px', '-136px -136px', '-170px -136px', '0px -170px', '-34px -170px', '-68px -170px', '-102px -170px', '-136px -170px', '-170px -170px', '0px -204px', '-34px -204px', '-68px -204px', '-102px -204px', '-136px -204px', '-170px -204px', '0px -238px', '-34px -238px', '-68px -238px', '-102px -238px', '-136px -238px', '-170px -238px'];
          for (var i = 0; i < 48; i++) {
            var selected = input.value == xy[i] ? 'selected' : '';
            icons += "<span class=\"icon ".concat(selected, "\" data-xy=\"").concat(xy[i], "\"></span>");
          }
          iconsWrapper.classList.add('icon-selector-dropdown');
          iconsWrapper.innerHTML = icons;
          selector.appendChild(iconsWrapper);
          selector.querySelectorAll('span.icon').forEach(function (span) {
            span.addEventListener('click', function () {
              // Remove selected class
              var selected = selector.querySelector('.selected');
              if (selected) {
                selected.classList.remove('selected');
              }

              // Set value and make item selected
              var bgPosition = span.getAttribute('data-xy');
              input.value = bgPosition;
              input.dispatchEvent(new Event('input', {
                bubbles: true
              }));
              span.classList.add('selected');
              button.querySelector('span').style.backgroundPosition = bgPosition;
            });
          });
        }
      };
      /* harmony default export */
      var __WEBPACK_DEFAULT_EXPORT__ = iconSelector;

      /***/
    },
    /***/"./js/modules/image-preview.js"
    /*!*************************************!*\
      !*** ./js/modules/image-preview.js ***!
      \*************************************/: function _js_modules_imagePreviewJs(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */"default": function _default() {
          return __WEBPACK_DEFAULT_EXPORT__;
        }
        /* harmony export */
      });
      var imagePreview = {
        fileFields: document.querySelectorAll('input[type="file"]'),
        init: function init() {
          if (this.fileFields.length === 0) return false;
          this.fileFields.forEach(function (field) {
            var form = field.closest('form');
            var liveThumb = form.querySelector('img.img-upload-live-preview');

            // Create reusable error element
            var error = field.parentElement.querySelector('.img-live-view-error');
            if (!error) {
              error = document.createElement('span');
              error.className = 'field-error img-live-view-error';
              error.style.display = 'none';
              field.parentElement.appendChild(error);
            }
            field.onchange = function () {
              var _field$files2 = _slicedToArray(field.files, 1),
                file = _field$files2[0];

              // Reset error and preview
              error.style.display = 'none';
              error.innerText = '';
              liveThumb.classList.add('hidden');
              liveThumb.src = '';
              if (!file) return;

              // Validate file size (Max: 1MB)
              if (file.size > 1048576) {
                error.innerText = 'Image is too large. Please select an image under 1MB.';
                error.style.display = 'block';
                field.value = '';
                return;
              }

              // Validate file format
              var allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
              if (!allowedTypes.includes(file.type)) {
                error.innerText = 'Invalid image format. Only JPG, PNG or WEBP are allowed.';
                error.style.display = 'block';
                field.value = '';
                return;
              }

              // Show preview
              liveThumb.src = URL.createObjectURL(file);
              liveThumb.classList.remove('hidden');
            };
          });
        }
      };
      /* harmony default export */
      var __WEBPACK_DEFAULT_EXPORT__ = imagePreview;

      /***/
    },
    /***/"./js/modules/main-alert.js"
    /*!**********************************!*\
      !*** ./js/modules/main-alert.js ***!
      \**********************************/: function _js_modules_mainAlertJs(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */"default": function _default() {
          return __WEBPACK_DEFAULT_EXPORT__;
        }
        /* harmony export */
      });
      var mainAlert = {
        init: function init() {
          var notifyDOM = document.querySelector('.main-alert');
          if (notifyDOM) {
            setTimeout(function () {
              notifyDOM.classList.add('hidden');
            }, 6000);
          }
        }
      };
      /* harmony default export */
      var __WEBPACK_DEFAULT_EXPORT__ = mainAlert;

      /***/
    },
    /***/"./js/modules/notification.js"
    /*!************************************!*\
      !*** ./js/modules/notification.js ***!
      \************************************/: function _js_modules_notificationJs(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */"default": function _default() {
          return __WEBPACK_DEFAULT_EXPORT__;
        }
        /* harmony export */
      });
      var notification = {
        notificationDOM: document.querySelector('.notification'),
        closeTrigger: document.querySelector('.notification__close-trigger'),
        init: function init() {
          var _this6 = this;
          if (!this.closeTrigger) return;
          var header = document.querySelector('header');
          var headerNav = header.querySelector('nav.header-nav');
          var setTopSpace = function setTopSpace() {
            var notifyHeight = _this6.notificationDOM.getBoundingClientRect().height;
            header.style.top = "".concat(Math.round(notifyHeight), "px");
            headerNav.style.top = "".concat(Math.round(notifyHeight) + 61, "px");
            document.body.classList.add('has-notification');
          };
          setTopSpace();
          setTimeout(function () {
            setTopSpace;
          }, 2000);
          window.addEventListener('resize', setTopSpace);
          this.closeTrigger.addEventListener('click', function () {
            document.cookie = "notify_off=true; path=/";
            _this6.notificationDOM.remove();
            header.style.top = '0px';
            headerNav.style.top = '61px';
            document.body.classList.remove('has-notification');
          });
        }
      };
      /* harmony default export */
      var __WEBPACK_DEFAULT_EXPORT__ = notification;

      /***/
    },
    /***/"./js/modules/repeater.js"
    /*!********************************!*\
      !*** ./js/modules/repeater.js ***!
      \********************************/: function _js_modules_repeaterJs(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */"default": function _default() {
          return __WEBPACK_DEFAULT_EXPORT__;
        }
        /* harmony export */
      });
      /* harmony import */
      var _vendor_ozz_wyg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../vendor/ozz-wyg */"./js/vendor/ozz-wyg.js");
      /* harmony import */
      var _cv_builder_v2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./cv-builder-v2 */"./js/modules/cv-builder-v2.js");
      /* harmony import */
      var _date_picker__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./date-picker */"./js/modules/date-picker.js");
      /* harmony import */
      var _custom_range__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./custom-range */"./js/modules/custom-range.js");
      /* harmony import */
      var _icon_selector__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./icon-selector */"./js/modules/icon-selector.js");
      /* harmony import */
      var _smart_assistant__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./smart-assistant */"./js/modules/smart-assistant.js");
      /* harmony import */
      var _utils_variables__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../utils/variables */"./js/utils/variables.js");
      var repeater = {
        repeaters: document.querySelectorAll('.oz-repeater'),
        init: function init() {
          if (repeater.repeaters.length === 0) return;
          repeater.repeaters.forEach(function (rpt) {
            var addTrigger = rpt.querySelector('.oz-repeater__add-btn');
            var area = rpt.querySelector('.oz-repeater__area');
            var block = rpt.querySelector('.oz-repeater__block');
            addTrigger.addEventListener('click', function (e) {
              e.preventDefault();
              var cloned = repeater.cleanClonedDOM(block);
              area.querySelectorAll('.accordion__item').forEach(function (item) {
                item.classList.remove('active');
              });
              cloned.querySelector('.accordion__item').classList.add('active');
              area.appendChild(cloned);
              _cv_builder_v2__WEBPACK_IMPORTED_MODULE_1__["default"].updateBlockLabels();
              _cv_builder_v2__WEBPACK_IMPORTED_MODULE_1__["default"].livePreviewUpdate();
              var elementPosition = cloned.getBoundingClientRect().top + window.scrollY;
              window.scrollTo({
                top: elementPosition - 75,
                behavior: 'smooth'
              });

              // Clear initialized atribute on smart assistant instance
              if (cloned.querySelector('[data-smart-assistant]')) {
                cloned.querySelector('[data-smart-assistant]').dataset.initialized = 'false';
              }
              _date_picker__WEBPACK_IMPORTED_MODULE_2__["default"].init(); // Initialize date picker for new block
              _custom_range__WEBPACK_IMPORTED_MODULE_3__["default"].init(); // Update custom range feilds
              _cv_builder_v2__WEBPACK_IMPORTED_MODULE_1__["default"].skillsRatingTypeSelector(); // Update skills rating blocks
              _icon_selector__WEBPACK_IMPORTED_MODULE_4__["default"].init(); // Initialize Icon selector
              _smart_assistant__WEBPACK_IMPORTED_MODULE_5__["default"].init(); // Initialize smart assistant
            });
          });

          // Remove Item
          document.addEventListener('click', function (e) {
            if (e.target.classList.contains('oz-repeater__remove')) {
              var thisRepeater = e.target.closest('.oz-repeater');
              if (thisRepeater && thisRepeater.querySelectorAll('.oz-repeater__block').length > 1) {
                if (confirm('Are you sure? you want to delete this?')) {
                  e.target.closest('.oz-repeater__block').remove();

                  // Update indexes and preview
                  var repeaters = thisRepeater.querySelectorAll('.oz-repeater__area');
                  repeaters.forEach(function (section) {
                    _cv_builder_v2__WEBPACK_IMPORTED_MODULE_1__["default"].indexFieldNames(section);
                  });
                  _cv_builder_v2__WEBPACK_IMPORTED_MODULE_1__["default"].updatePreview();
                }
              }
            }
          });
        },
        /**
         * Make a clean duplicate block
         * @param {Element} block Block to duplicate
         * @return {Element} New block
         */
        cleanClonedDOM: function cleanClonedDOM(block) {
          var _block$closest, _DOM$querySelector;
          var DOM = block.cloneNode(true);
          var lastIndex = (_block$closest = block.closest('.oz-repeater__area')) === null || _block$closest === void 0 || (_block$closest = _block$closest.querySelectorAll('.oz-repeater__block')) === null || _block$closest === void 0 ? void 0 : _block$closest.length;

          // Clear and set up input fields
          DOM.querySelectorAll('input, textarea, progress, meter, select, datalist, .ozz-wyg__editor-area').forEach(function (field) {
            var _field$name;
            field.name = (_field$name = field.name) === null || _field$name === void 0 ? void 0 : _field$name.replace(/\[\d+\]/, "[".concat(lastIndex, "]"));
            field.innerHTML = '';
            if (field.type !== 'checkbox') {
              field.value = '';
              field.removeAttribute('checked');
            }
          });

          // Clear and set up Ozz wyg fields
          DOM.querySelectorAll('[data-ozz-wyg]').forEach(function (wygField) {
            wygField.innerHTML = '';
            new _vendor_ozz_wyg__WEBPACK_IMPORTED_MODULE_0__["default"]({
              selector: wygField,
              tools: _utils_variables__WEBPACK_IMPORTED_MODULE_6__.BASIC_WYG_TOOLS
            });
            if (wygField.hasAttribute('data-field-name')) {
              wygField.setAttribute('data-field-name', wygField.getAttribute('data-field-name').replace(/\[\d+\]/, "[".concat(lastIndex, "]")));
            }
          });

          // Update Label
          var defaultLabel = (_DOM$querySelector = DOM.querySelector('.accordion__head .label')) === null || _DOM$querySelector === void 0 ? void 0 : _DOM$querySelector.getAttribute('data-default');
          if (defaultLabel) {
            DOM.querySelector('.accordion__head .label').textContent = defaultLabel;
          }
          return DOM;
        }
      };
      /* harmony default export */
      var __WEBPACK_DEFAULT_EXPORT__ = repeater;

      /***/
    },
    /***/"./js/modules/smart-assistant.js"
    /*!***************************************!*\
      !*** ./js/modules/smart-assistant.js ***!
      \***************************************/: function _js_modules_smartAssistantJs(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */"default": function _default() {
          return __WEBPACK_DEFAULT_EXPORT__;
        }
        /* harmony export */
      });
      /* harmony import */
      var _utils_Fetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/Fetch */"./js/utils/Fetch.js");
      /* harmony import */
      var _utils_StructureFormData__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils/StructureFormData */"./js/utils/StructureFormData.js");
      var smartAssistant = {
        DOMs: null,
        init: function init() {
          var _this7 = this;
          this.DOMs = document.querySelectorAll('[data-smart-assistant]');
          if (this.DOMs.length === 0) return;
          this.DOMs.forEach(function (instance) {
            _this7.initInstance(instance);
          });
        },
        /**
         * Initialize assistant instance
         * @param {HTMLElement} instance 
         * @returns 
         */
        initInstance: function initInstance(instance) {
          var _this8 = this;
          if (instance.dataset.initialized === 'true') return;
          var trigger = instance.querySelector('.smart-assistant__trigger'),
            thisSection = instance.closest('.oz-repeater__block'),
            jobTitle = thisSection.querySelector('input.job-title-for-assistant'),
            industry = thisSection.closest('form').querySelector('select[name="industry"]');
          var handleClick = function handleClick() {
            var parent = jobTitle.parentElement;
            if (jobTitle.value.trim() == '') {
              var _parent$querySelector2;
              jobTitle.classList.add('error');
              (_parent$querySelector2 = parent.querySelector('.field-error')) === null || _parent$querySelector2 === void 0 || _parent$querySelector2.remove();
              var errorEl = document.createElement('span');
              errorEl.classList.add('field-error');
              errorEl.textContent = 'Please provide Job title to get a better result';
              parent.appendChild(errorEl);
              return;
            } else {
              var _parent$querySelector3;
              jobTitle.classList.remove('error');
              (_parent$querySelector3 = parent.querySelector('.field-error')) === null || _parent$querySelector3 === void 0 || _parent$querySelector3.remove();
              instance.classList.add('opened');
              _this8.openAIpopup(industry.value, jobTitle.value, instance);
            }
          };
          trigger.addEventListener('click', handleClick);
          instance.dataset.initialized = 'true';
        },
        /**
         * Get the response and Open popup
         * @param {string} industry 
         * @param {string} jobTitle
         * @param {HTMLElement} instance 
         */
        openAIpopup: function openAIpopup(industry, jobTitle, instance) {
          var _instance$closest;
          var popupDOM = document.querySelector('.smart-assistant-popup');
          var popup = popupDOM.querySelector('.smart-assistant-popup__box');
          var activeTextarea = (_instance$closest = instance.closest('.cv-builder-v2__field')) === null || _instance$closest === void 0 ? void 0 : _instance$closest.querySelector('.ozz-wyg__editor-area');
          var field = instance.closest('.cv-builder-v2__field').querySelector('[data-field-name]');
          var url = "/api/suggestions/".concat(industry, "/").concat(jobTitle);
          popupDOM.classList.add('active');
          popup.innerHTML = "\n      <div class=\"smart-assistant-popup__header\">\n        <h3>Suggestions</h3>\n        <span class=\"smart-assistant-popup__close\" aria-label=\"Close\"></span>\n      </div><br>\n      <div class=\"loader\">\n      <span></span><span></span><span></span><span></span>\n      <span></span><span></span><span></span><span></span>\n    </div>";
          var suggestions = (0, _utils_Fetch__WEBPACK_IMPORTED_MODULE_0__.send)(url, 'GET');
          suggestions.then(function (response) {
            popup.innerHTML = "\n        <div class=\"smart-assistant-popup__header\">\n          <h3>Suggestions</h3>\n          <span class=\"smart-assistant-popup__close\" aria-label=\"Close\"></span>\n        </div>\n        <ul class=\"smart-assistant-popup__suggestions\">\n          ".concat(response.suggestions.map(function (suggestion) {
              return "\n            <li>\n              <label><input type=\"checkbox\" name=\"selected_suggestions[]\">".concat(suggestion, "</label>\n            </li>");
            }).join(''), "\n        </ul>\n        <span class=\"btn btn-primary yellow small smart-assistant-popup__insert\">Insert</span>\n      ");

            // Close popup
            var closeBtn = popup.querySelector('.smart-assistant-popup__close');
            closeBtn.addEventListener('click', function () {
              popupDOM.classList.remove('active');
            });

            // Insert selected suggestions
            var insertBtn = popup.querySelector('.smart-assistant-popup__insert');
            insertBtn.addEventListener('click', function () {
              var checkedSuggestions = popup.querySelectorAll('input[name="selected_suggestions[]"]:checked');
              if (checkedSuggestions.length > 0) {
                var selectionDOM = document.createElement('ul');
                checkedSuggestions.forEach(function (checkbox) {
                  var li = document.createElement('li');
                  li.textContent = checkbox.parentElement.textContent.trim();
                  selectionDOM.appendChild(li);
                });

                // Insert into active textarea
                activeTextarea.appendChild(selectionDOM);
              }
              popupDOM.classList.remove('active');

              // Send update request
              var iframe = document.querySelector('#temp_live_preview iframe');
              var form = document.querySelector('form[name=cv-builder-v2]');
              if (iframe) {
                var data = (0, _utils_StructureFormData__WEBPACK_IMPORTED_MODULE_1__["default"])(form);
                iframe.contentWindow.postMessage({
                  source: 'cvBuilderV2_live_update_request',
                  data: data,
                  fieldName: field.dataset.fieldName
                }, '*');
              }
            });
          });
        }
      };
      /* harmony default export */
      var __WEBPACK_DEFAULT_EXPORT__ = smartAssistant;

      /***/
    },
    /***/"./js/modules/template-carousel.js"
    /*!*****************************************!*\
      !*** ./js/modules/template-carousel.js ***!
      \*****************************************/: function _js_modules_templateCarouselJs(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */"default": function _default() {
          return __WEBPACK_DEFAULT_EXPORT__;
        }
        /* harmony export */
      });
      var templateCarousel = {
        init: function init() {
          var carousels = document.querySelectorAll('.template-carousel');
          if (carousels.length === 0) return;
          carousels.forEach(function (carousel) {
            var track = carousel.querySelector('.template-carousel__track');
            var items = track.querySelectorAll('.template-carousel__template');
            track.style.animationDuration = "".concat(items.length * 4, "s");
            for (var i = 0; i < 5; i++) {
              var clone = track.cloneNode(true);
              carousel.appendChild(clone);
            }
          });
        }
      };
      /* harmony default export */
      var __WEBPACK_DEFAULT_EXPORT__ = templateCarousel;

      /***/
    },
    /***/"./js/modules/testimonial-slider.js"
    /*!******************************************!*\
      !*** ./js/modules/testimonial-slider.js ***!
      \******************************************/: function _js_modules_testimonialSliderJs(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */"default": function _default() {
          return __WEBPACK_DEFAULT_EXPORT__;
        }
        /* harmony export */
      });
      var testimonialSlider = {
        init: function init() {
          if (document.querySelectorAll('.testimonial-slider').length === 0 || typeof Swiper === 'undefined') return;
          var swiper = new Swiper('.testimonial-slider', {
            loop: false,
            slidesPerView: 1.3,
            spaceBetween: 20,
            centeredSlides: true,
            keyboard: true,
            autoHeight: false,
            speed: 600,
            autoplay: false,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            },
            pagination: {
              el: '.swiper-pagination',
              clickable: false
            },
            breakpoints: {
              768: {
                slidesPerView: 3,
                initialSlide: 1
              },
              1024: {
                spaceBetween: 40,
                slidesPerView: 3,
                initialSlide: 1
              }
            }
          });
        }
      };
      /* harmony default export */
      var __WEBPACK_DEFAULT_EXPORT__ = testimonialSlider;

      /***/
    },
    /***/"./js/utils/Fetch.js"
    /*!***************************!*\
      !*** ./js/utils/Fetch.js ***!
      \***************************/: function _js_utils_FetchJs(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */send: function send() {
          return /* binding */_send;
        }
        /* harmony export */
      });
      // Send fetch request
      var getCsrfToken = function getCsrfToken() {
        // Check meta tag first, then hidden input field
        var meta = document.querySelector('meta[name="csrf-token"]');
        if (meta !== null && meta !== void 0 && meta.content) return meta.content;
        var input = document.querySelector('input[name="csrf_token"]');
        if (input !== null && input !== void 0 && input.value) return input.value;
        return null;
      };
      var _send = /*#__PURE__*/function () {
        var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(url) {
          var method,
            body,
            headers,
            csrfToken,
            options,
            _response$headers$get,
            response,
            errorBody,
            isJson,
            _args = arguments,
            _t,
            _t2;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.p = _context.n) {
              case 0:
                method = _args.length > 1 && _args[1] !== undefined ? _args[1] : 'GET';
                body = _args.length > 2 && _args[2] !== undefined ? _args[2] : null;
                headers = _args.length > 3 && _args[3] !== undefined ? _args[3] : {};
                csrfToken = getCsrfToken();
                options = {
                  method: method,
                  headers: _objectSpread(_objectSpread({
                    'Content-Type': 'application/json'
                  }, csrfToken && {
                    'X-CSRF-Token': csrfToken
                  }), headers)
                };
                if (body && method !== 'GET' && method !== 'HEAD') {
                  options.body = typeof body === 'string' ? body : JSON.stringify(body);
                }
                _context.p = 1;
                _context.n = 2;
                return fetch(url, options);
              case 2:
                response = _context.v;
                if (response.ok) {
                  _context.n = 4;
                  break;
                }
                _context.n = 3;
                return response.json()["catch"](function () {
                  return {};
                });
              case 3:
                errorBody = _context.v;
                throw new Error(errorBody.message || "HTTP ".concat(response.status, ": ").concat(response.statusText));
              case 4:
                isJson = (_response$headers$get = response.headers.get('content-type')) === null || _response$headers$get === void 0 ? void 0 : _response$headers$get.includes('application/json');
                if (!isJson) {
                  _context.n = 6;
                  break;
                }
                _context.n = 5;
                return response.json();
              case 5:
                _t = _context.v;
                _context.n = 7;
                break;
              case 6:
                _t = null;
              case 7:
                return _context.a(2, _t);
              case 8:
                _context.p = 8;
                _t2 = _context.v;
                console.error('Fetch Error:', _t2);
                throw _t2;
              case 9:
                return _context.a(2);
            }
          }, _callee, null, [[1, 8]]);
        }));
        return function _send(_x) {
          return _ref0.apply(this, arguments);
        };
      }();

      /***/
    },
    /***/"./js/utils/FormHandler.js"
    /*!*********************************!*\
      !*** ./js/utils/FormHandler.js ***!
      \*********************************/: function _js_utils_FormHandlerJs(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */"default": function _default() {
          return __WEBPACK_DEFAULT_EXPORT__;
        }
        /* harmony export */
      });
      var FormHandler = function FormHandler(e) {
        var thisForm = e.target;

        // Store OzzWyg data in a hidden field
        var ozzWygEditors = thisForm.querySelectorAll('[data-ozz-wyg]');
        ozzWygEditors.forEach(function (wygEditor) {
          var name = wygEditor.getAttribute('data-field-name');
          var value = wygEditor.querySelector('[data-editor-area]').innerHTML;
          var existingHiddenField = thisForm.querySelector("input[name=\"".concat(name, "\"]"));
          if (!existingHiddenField) {
            var hdnField = document.createElement('input');
            hdnField.type = 'hidden';
            hdnField.name = name;
            hdnField.value = value;
            thisForm.appendChild(hdnField);
          } else {
            existingHiddenField.value = value;
          }
        });
        thisForm.submit();
      };
      /* harmony default export */
      var __WEBPACK_DEFAULT_EXPORT__ = FormHandler;

      /***/
    },
    /***/"./js/utils/StructureFormData.js"
    /*!***************************************!*\
      !*** ./js/utils/StructureFormData.js ***!
      \***************************************/: function _js_utils_StructureFormDataJs(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */"default": function _default() {
          return __WEBPACK_DEFAULT_EXPORT__;
        }
        /* harmony export */
      });
      /**
       * Convert default form data into nested object
       * @param {Element} form
       * @returns 
       */
      var StructureFormData = function StructureFormData(form) {
        var result = {};
        var formData = new FormData(form);
        var editors = form.querySelectorAll('[data-editor-area]');

        // Add WYSIWYG editor data to FormData
        if (editors.length > 0) {
          editors.forEach(function (editor) {
            var fieldName = editor.closest('[data-field-name]').getAttribute('data-field-name');
            if (fieldName) {
              formData.set(fieldName, editor.innerHTML);
            }
          });
        }

        // Helper function to set nested keys
        var setNestedValue = function setNestedValue(obj, keys, value) {
          var lastKey = keys.pop();
          var nested = keys.reduce(function (acc, key) {
            if (!acc[key]) {
              acc[key] = {};
            }
            return acc[key];
          }, obj);
          nested[lastKey] = value;
        };

        // Convert FormData to nested object
        var _iterator = _createForOfIteratorHelper(formData.entries()),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _slicedToArray(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];
            var keys = key.split(/[\[\]]+/).filter(function (k) {
              return k;
            });
            setNestedValue(result, keys, value);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return result;
      };
      /* harmony default export */
      var __WEBPACK_DEFAULT_EXPORT__ = StructureFormData;

      /***/
    },
    /***/"./js/utils/UpdateUrl.js"
    /*!*******************************!*\
      !*** ./js/utils/UpdateUrl.js ***!
      \*******************************/: function _js_utils_UpdateUrlJs(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */"default": function _default() {
          return __WEBPACK_DEFAULT_EXPORT__;
        }
        /* harmony export */
      });
      var updateUrl = function updateUrl(key, value) {
        var url = new URL(window.location.href);
        url.searchParams.set(key, value);
        window.history.pushState({}, '', url);
      };
      /* harmony default export */
      var __WEBPACK_DEFAULT_EXPORT__ = updateUrl;

      /***/
    },
    /***/"./js/utils/variables.js"
    /*!*******************************!*\
      !*** ./js/utils/variables.js ***!
      \*******************************/: function _js_utils_variablesJs(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */BASIC_WYG_TOOLS: function BASIC_WYG_TOOLS() {
          return /* binding */_BASIC_WYG_TOOLS;
        }
        /* harmony export */
      });
      var _BASIC_WYG_TOOLS = ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'ol', 'ul'];

      /***/
    },
    /***/"./js/vendor/Sortable.js"
    /*!*******************************!*\
      !*** ./js/vendor/Sortable.js ***!
      \*******************************/: function _js_vendor_SortableJs(module, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */"default": function _default() {
          return __WEBPACK_DEFAULT_EXPORT__;
        }
        /* harmony export */
      });
      /* module decorator */
      module = __webpack_require__.hmd(module);
      /**!
      * Sortable 1.15.2
      * @author	RubaXa   <trash@rubaxa.org>
      * @author	owenm    <owen23355@gmail.com>
      * @license MIT
      */
      (function (global, factory) {
        (typeof exports === "undefined" ? "undefined" : _typeof2(exports)) === 'object' && "object" !== 'undefined' ? module.exports = factory() : typeof define === 'function' && __webpack_require__.amdO ? define(factory) : (global = global || self, global.Sortable = factory());
      })(undefined, function () {
        'use strict';

        function ownKeys(object, enumerableOnly) {
          var keys = Object.keys(object);
          if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) {
              symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
              });
            }
            keys.push.apply(keys, symbols);
          }
          return keys;
        }
        function _objectSpread2(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) {
              ownKeys(Object(source), true).forEach(function (key) {
                _defineProperty(target, key, source[key]);
              });
            } else if (Object.getOwnPropertyDescriptors) {
              Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            } else {
              ownKeys(Object(source)).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
              });
            }
          }
          return target;
        }
        function _typeof(obj) {
          "@babel/helpers - typeof";

          if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
            _typeof = function _typeof(obj) {
              return typeof obj;
            };
          } else {
            _typeof = function _typeof(obj) {
              return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
          }
          return _typeof(obj);
        }
        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key] = value;
          }
          return obj;
        }
        function _extends() {
          _extends = Object.assign || function (target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i];
              for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                  target[key] = source[key];
                }
              }
            }
            return target;
          };
          return _extends.apply(this, arguments);
        }
        function _objectWithoutPropertiesLoose(source, excluded) {
          if (source == null) return {};
          var target = {};
          var sourceKeys = Object.keys(source);
          var key, i;
          for (i = 0; i < sourceKeys.length; i++) {
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
          }
          return target;
        }
        function _objectWithoutProperties(source, excluded) {
          if (source == null) return {};
          var target = _objectWithoutPropertiesLoose(source, excluded);
          var key, i;
          if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for (i = 0; i < sourceSymbolKeys.length; i++) {
              key = sourceSymbolKeys[i];
              if (excluded.indexOf(key) >= 0) continue;
              if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
              target[key] = source[key];
            }
          }
          return target;
        }
        function _toConsumableArray(arr) {
          return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
        }
        function _arrayWithoutHoles(arr) {
          if (Array.isArray(arr)) return _arrayLikeToArray(arr);
        }
        function _iterableToArray(iter) {
          if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
        }
        function _unsupportedIterableToArray(o, minLen) {
          if (!o) return;
          if (typeof o === "string") return _arrayLikeToArray(o, minLen);
          var n = Object.prototype.toString.call(o).slice(8, -1);
          if (n === "Object" && o.constructor) n = o.constructor.name;
          if (n === "Map" || n === "Set") return Array.from(o);
          if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
        }
        function _arrayLikeToArray(arr, len) {
          if (len == null || len > arr.length) len = arr.length;
          for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
          return arr2;
        }
        function _nonIterableSpread() {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var version = "1.15.2";
        function userAgent(pattern) {
          if (typeof window !== 'undefined' && window.navigator) {
            return !! /*@__PURE__*/navigator.userAgent.match(pattern);
          }
        }
        var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
        var Edge = userAgent(/Edge/i);
        var FireFox = userAgent(/firefox/i);
        var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
        var IOS = userAgent(/iP(ad|od|hone)/i);
        var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);
        var captureMode = {
          capture: false,
          passive: false
        };
        function on(el, event, fn) {
          el.addEventListener(event, fn, !IE11OrLess && captureMode);
        }
        function off(el, event, fn) {
          el.removeEventListener(event, fn, !IE11OrLess && captureMode);
        }
        function matches(/**HTMLElement*/el, /**String*/selector) {
          if (!selector) return;
          selector[0] === '>' && (selector = selector.substring(1));
          if (el) {
            try {
              if (el.matches) {
                return el.matches(selector);
              } else if (el.msMatchesSelector) {
                return el.msMatchesSelector(selector);
              } else if (el.webkitMatchesSelector) {
                return el.webkitMatchesSelector(selector);
              }
            } catch (_) {
              return false;
            }
          }
          return false;
        }
        function getParentOrHost(el) {
          return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
        }
        function closest(/**HTMLElement*/el, /**String*/selector, /**HTMLElement*/ctx, includeCTX) {
          if (el) {
            ctx = ctx || document;
            do {
              if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
                return el;
              }
              if (el === ctx) break;
              /* jshint boss:true */
            } while (el = getParentOrHost(el));
          }
          return null;
        }
        var R_SPACE = /\s+/g;
        function toggleClass(el, name, state) {
          if (el && name) {
            if (el.classList) {
              el.classList[state ? 'add' : 'remove'](name);
            } else {
              var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
              el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
            }
          }
        }
        function css(el, prop, val) {
          var style = el && el.style;
          if (style) {
            if (val === void 0) {
              if (document.defaultView && document.defaultView.getComputedStyle) {
                val = document.defaultView.getComputedStyle(el, '');
              } else if (el.currentStyle) {
                val = el.currentStyle;
              }
              return prop === void 0 ? val : val[prop];
            } else {
              if (!(prop in style) && prop.indexOf('webkit') === -1) {
                prop = '-webkit-' + prop;
              }
              style[prop] = val + (typeof val === 'string' ? '' : 'px');
            }
          }
        }
        function matrix(el, selfOnly) {
          var appliedTransforms = '';
          if (typeof el === 'string') {
            appliedTransforms = el;
          } else {
            do {
              var transform = css(el, 'transform');
              if (transform && transform !== 'none') {
                appliedTransforms = transform + ' ' + appliedTransforms;
              }
              /* jshint boss:true */
            } while (!selfOnly && (el = el.parentNode));
          }
          var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
          /*jshint -W056 */
          return matrixFn && new matrixFn(appliedTransforms);
        }
        function find(ctx, tagName, iterator) {
          if (ctx) {
            var list = ctx.getElementsByTagName(tagName),
              i = 0,
              n = list.length;
            if (iterator) {
              for (; i < n; i++) {
                iterator(list[i], i);
              }
            }
            return list;
          }
          return [];
        }
        function getWindowScrollingElement() {
          var scrollingElement = document.scrollingElement;
          if (scrollingElement) {
            return scrollingElement;
          } else {
            return document.documentElement;
          }
        }

        /**
        * Returns the "bounding client rect" of given element
        * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
        * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
        * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
        * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
        * @param  {[HTMLElement]} container              The parent the element will be placed in
        * @return {Object}                               The boundingClientRect of el, with specified adjustments
        */
        function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
          if (!el.getBoundingClientRect && el !== window) return;
          var elRect, top, left, bottom, right, height, width;
          if (el !== window && el.parentNode && el !== getWindowScrollingElement()) {
            elRect = el.getBoundingClientRect();
            top = elRect.top;
            left = elRect.left;
            bottom = elRect.bottom;
            right = elRect.right;
            height = elRect.height;
            width = elRect.width;
          } else {
            top = 0;
            left = 0;
            bottom = window.innerHeight;
            right = window.innerWidth;
            height = window.innerHeight;
            width = window.innerWidth;
          }
          if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
            // Adjust for translate()
            container = container || el.parentNode;

            // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
            // Not needed on <= IE11
            if (!IE11OrLess) {
              do {
                if (container && container.getBoundingClientRect && (css(container, 'transform') !== 'none' || relativeToNonStaticParent && css(container, 'position') !== 'static')) {
                  var containerRect = container.getBoundingClientRect();

                  // Set relative to edges of padding box of container
                  top -= containerRect.top + parseInt(css(container, 'border-top-width'));
                  left -= containerRect.left + parseInt(css(container, 'border-left-width'));
                  bottom = top + elRect.height;
                  right = left + elRect.width;
                  break;
                }
                /* jshint boss:true */
              } while (container = container.parentNode);
            }
          }
          if (undoScale && el !== window) {
            // Adjust for scale()
            var elMatrix = matrix(container || el),
              scaleX = elMatrix && elMatrix.a,
              scaleY = elMatrix && elMatrix.d;
            if (elMatrix) {
              top /= scaleY;
              left /= scaleX;
              width /= scaleX;
              height /= scaleY;
              bottom = top + height;
              right = left + width;
            }
          }
          return {
            top: top,
            left: left,
            bottom: bottom,
            right: right,
            width: width,
            height: height
          };
        }

        /**
        * Checks if a side of an element is scrolled past a side of its parents
        * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
        * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
        * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
        * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
        */
        function isScrolledPast(el, elSide, parentSide) {
          var parent = getParentAutoScrollElement(el, true),
            elSideVal = getRect(el)[elSide];

          /* jshint boss:true */
          while (parent) {
            var parentSideVal = getRect(parent)[parentSide],
              visible = void 0;
            if (parentSide === 'top' || parentSide === 'left') {
              visible = elSideVal >= parentSideVal;
            } else {
              visible = elSideVal <= parentSideVal;
            }
            if (!visible) return parent;
            if (parent === getWindowScrollingElement()) break;
            parent = getParentAutoScrollElement(parent, false);
          }
          return false;
        }

        /**
        * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
        * and non-draggable elements
        * @param  {HTMLElement} el       The parent element
        * @param  {Number} childNum      The index of the child
        * @param  {Object} options       Parent Sortable's options
        * @return {HTMLElement}          The child at index childNum, or null if not found
        */
        function getChild(el, childNum, options, includeDragEl) {
          var currentChild = 0,
            i = 0,
            children = el.children;
          while (i < children.length) {
            if (children[i].style.display !== 'none' && children[i] !== Sortable.ghost && (includeDragEl || children[i] !== Sortable.dragged) && closest(children[i], options.draggable, el, false)) {
              if (currentChild === childNum) {
                return children[i];
              }
              currentChild++;
            }
            i++;
          }
          return null;
        }

        /**
        * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
        * @param  {HTMLElement} el       Parent element
        * @param  {selector} selector    Any other elements that should be ignored
        * @return {HTMLElement}          The last child, ignoring ghostEl
        */
        function lastChild(el, selector) {
          var last = el.lastElementChild;
          while (last && (last === Sortable.ghost || css(last, 'display') === 'none' || selector && !matches(last, selector))) {
            last = last.previousElementSibling;
          }
          return last || null;
        }

        /**
        * Returns the index of an element within its parent for a selected set of
        * elements
        * @param  {HTMLElement} el
        * @param  {selector} selector
        * @return {number}
        */
        function index(el, selector) {
          var index = 0;
          if (!el || !el.parentNode) {
            return -1;
          }

          /* jshint boss:true */
          while (el = el.previousElementSibling) {
            if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== Sortable.clone && (!selector || matches(el, selector))) {
              index++;
            }
          }
          return index;
        }

        /**
        * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
        * The value is returned in real pixels.
        * @param  {HTMLElement} el
        * @return {Array}             Offsets in the format of [left, top]
        */
        function getRelativeScrollOffset(el) {
          var offsetLeft = 0,
            offsetTop = 0,
            winScroller = getWindowScrollingElement();
          if (el) {
            do {
              var elMatrix = matrix(el),
                scaleX = elMatrix.a,
                scaleY = elMatrix.d;
              offsetLeft += el.scrollLeft * scaleX;
              offsetTop += el.scrollTop * scaleY;
            } while (el !== winScroller && (el = el.parentNode));
          }
          return [offsetLeft, offsetTop];
        }

        /**
        * Returns the index of the object within the given array
        * @param  {Array} arr   Array that may or may not hold the object
        * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
        * @return {Number}      The index of the object in the array, or -1
        */
        function indexOfObject(arr, obj) {
          for (var i in arr) {
            if (!arr.hasOwnProperty(i)) continue;
            for (var key in obj) {
              if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
            }
          }
          return -1;
        }
        function getParentAutoScrollElement(el, includeSelf) {
          // skip to window
          if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
          var elem = el;
          var gotSelf = false;
          do {
            // we don't need to get elem css if it isn't even overflowing in the first place (performance)
            if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
              var elemCSS = css(elem);
              if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
                if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
                if (gotSelf || includeSelf) return elem;
                gotSelf = true;
              }
            }
            /* jshint boss:true */
          } while (elem = elem.parentNode);
          return getWindowScrollingElement();
        }
        function extend(dst, src) {
          if (dst && src) {
            for (var key in src) {
              if (src.hasOwnProperty(key)) {
                dst[key] = src[key];
              }
            }
          }
          return dst;
        }
        function isRectEqual(rect1, rect2) {
          return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
        }
        var _throttleTimeout;
        function throttle(callback, ms) {
          return function () {
            if (!_throttleTimeout) {
              var args = arguments,
                _this = this;
              if (args.length === 1) {
                callback.call(_this, args[0]);
              } else {
                callback.apply(_this, args);
              }
              _throttleTimeout = setTimeout(function () {
                _throttleTimeout = void 0;
              }, ms);
            }
          };
        }
        function cancelThrottle() {
          clearTimeout(_throttleTimeout);
          _throttleTimeout = void 0;
        }
        function scrollBy(el, x, y) {
          el.scrollLeft += x;
          el.scrollTop += y;
        }
        function clone(el) {
          var Polymer = window.Polymer;
          var $ = window.jQuery || window.Zepto;
          if (Polymer && Polymer.dom) {
            return Polymer.dom(el).cloneNode(true);
          } else if ($) {
            return $(el).clone(true)[0];
          } else {
            return el.cloneNode(true);
          }
        }
        function setRect(el, rect) {
          css(el, 'position', 'absolute');
          css(el, 'top', rect.top);
          css(el, 'left', rect.left);
          css(el, 'width', rect.width);
          css(el, 'height', rect.height);
        }
        function unsetRect(el) {
          css(el, 'position', '');
          css(el, 'top', '');
          css(el, 'left', '');
          css(el, 'width', '');
          css(el, 'height', '');
        }
        function getChildContainingRectFromElement(container, options, ghostEl) {
          var rect = {};
          Array.from(container.children).forEach(function (child) {
            var _rect$left, _rect$top, _rect$right, _rect$bottom;
            if (!closest(child, options.draggable, container, false) || child.animated || child === ghostEl) return;
            var childRect = getRect(child);
            rect.left = Math.min((_rect$left = rect.left) !== null && _rect$left !== void 0 ? _rect$left : Infinity, childRect.left);
            rect.top = Math.min((_rect$top = rect.top) !== null && _rect$top !== void 0 ? _rect$top : Infinity, childRect.top);
            rect.right = Math.max((_rect$right = rect.right) !== null && _rect$right !== void 0 ? _rect$right : -Infinity, childRect.right);
            rect.bottom = Math.max((_rect$bottom = rect.bottom) !== null && _rect$bottom !== void 0 ? _rect$bottom : -Infinity, childRect.bottom);
          });
          rect.width = rect.right - rect.left;
          rect.height = rect.bottom - rect.top;
          rect.x = rect.left;
          rect.y = rect.top;
          return rect;
        }
        var expando = 'Sortable' + new Date().getTime();
        function AnimationStateManager() {
          var animationStates = [],
            animationCallbackId;
          return {
            captureAnimationState: function captureAnimationState() {
              animationStates = [];
              if (!this.options.animation) return;
              var children = [].slice.call(this.el.children);
              children.forEach(function (child) {
                if (css(child, 'display') === 'none' || child === Sortable.ghost) return;
                animationStates.push({
                  target: child,
                  rect: getRect(child)
                });
                var fromRect = _objectSpread2({}, animationStates[animationStates.length - 1].rect);

                // If animating: compensate for current animation
                if (child.thisAnimationDuration) {
                  var childMatrix = matrix(child, true);
                  if (childMatrix) {
                    fromRect.top -= childMatrix.f;
                    fromRect.left -= childMatrix.e;
                  }
                }
                child.fromRect = fromRect;
              });
            },
            addAnimationState: function addAnimationState(state) {
              animationStates.push(state);
            },
            removeAnimationState: function removeAnimationState(target) {
              animationStates.splice(indexOfObject(animationStates, {
                target: target
              }), 1);
            },
            animateAll: function animateAll(callback) {
              var _this = this;
              if (!this.options.animation) {
                clearTimeout(animationCallbackId);
                if (typeof callback === 'function') callback();
                return;
              }
              var animating = false,
                animationTime = 0;
              animationStates.forEach(function (state) {
                var time = 0,
                  target = state.target,
                  fromRect = target.fromRect,
                  toRect = getRect(target),
                  prevFromRect = target.prevFromRect,
                  prevToRect = target.prevToRect,
                  animatingRect = state.rect,
                  targetMatrix = matrix(target, true);
                if (targetMatrix) {
                  // Compensate for current animation
                  toRect.top -= targetMatrix.f;
                  toRect.left -= targetMatrix.e;
                }
                target.toRect = toRect;
                if (target.thisAnimationDuration) {
                  // Could also check if animatingRect is between fromRect and toRect
                  if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) &&
                  // Make sure animatingRect is on line between toRect & fromRect
                  (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
                    // If returning to same place as started from animation and on same axis
                    time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
                  }
                }

                // if fromRect != toRect: animate
                if (!isRectEqual(toRect, fromRect)) {
                  target.prevFromRect = fromRect;
                  target.prevToRect = toRect;
                  if (!time) {
                    time = _this.options.animation;
                  }
                  _this.animate(target, animatingRect, toRect, time);
                }
                if (time) {
                  animating = true;
                  animationTime = Math.max(animationTime, time);
                  clearTimeout(target.animationResetTimer);
                  target.animationResetTimer = setTimeout(function () {
                    target.animationTime = 0;
                    target.prevFromRect = null;
                    target.fromRect = null;
                    target.prevToRect = null;
                    target.thisAnimationDuration = null;
                  }, time);
                  target.thisAnimationDuration = time;
                }
              });
              clearTimeout(animationCallbackId);
              if (!animating) {
                if (typeof callback === 'function') callback();
              } else {
                animationCallbackId = setTimeout(function () {
                  if (typeof callback === 'function') callback();
                }, animationTime);
              }
              animationStates = [];
            },
            animate: function animate(target, currentRect, toRect, duration) {
              if (duration) {
                css(target, 'transition', '');
                css(target, 'transform', '');
                var elMatrix = matrix(this.el),
                  scaleX = elMatrix && elMatrix.a,
                  scaleY = elMatrix && elMatrix.d,
                  translateX = (currentRect.left - toRect.left) / (scaleX || 1),
                  translateY = (currentRect.top - toRect.top) / (scaleY || 1);
                target.animatingX = !!translateX;
                target.animatingY = !!translateY;
                css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
                this.forRepaintDummy = repaint(target); // repaint

                css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
                css(target, 'transform', 'translate3d(0,0,0)');
                typeof target.animated === 'number' && clearTimeout(target.animated);
                target.animated = setTimeout(function () {
                  css(target, 'transition', '');
                  css(target, 'transform', '');
                  target.animated = false;
                  target.animatingX = false;
                  target.animatingY = false;
                }, duration);
              }
            }
          };
        }
        function repaint(target) {
          return target.offsetWidth;
        }
        function calculateRealTime(animatingRect, fromRect, toRect, options) {
          return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
        }
        var plugins = [];
        var defaults = {
          initializeByDefault: true
        };
        var PluginManager = {
          mount: function mount(plugin) {
            // Set default static properties
            for (var option in defaults) {
              if (defaults.hasOwnProperty(option) && !(option in plugin)) {
                plugin[option] = defaults[option];
              }
            }
            plugins.forEach(function (p) {
              if (p.pluginName === plugin.pluginName) {
                throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
              }
            });
            plugins.push(plugin);
          },
          pluginEvent: function pluginEvent(eventName, sortable, evt) {
            var _this = this;
            this.eventCanceled = false;
            evt.cancel = function () {
              _this.eventCanceled = true;
            };
            var eventNameGlobal = eventName + 'Global';
            plugins.forEach(function (plugin) {
              if (!sortable[plugin.pluginName]) return;
              // Fire global events if it exists in this sortable
              if (sortable[plugin.pluginName][eventNameGlobal]) {
                sortable[plugin.pluginName][eventNameGlobal](_objectSpread2({
                  sortable: sortable
                }, evt));
              }

              // Only fire plugin event if plugin is enabled in this sortable,
              // and plugin has event defined
              if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
                sortable[plugin.pluginName][eventName](_objectSpread2({
                  sortable: sortable
                }, evt));
              }
            });
          },
          initializePlugins: function initializePlugins(sortable, el, defaults, options) {
            plugins.forEach(function (plugin) {
              var pluginName = plugin.pluginName;
              if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
              var initialized = new plugin(sortable, el, sortable.options);
              initialized.sortable = sortable;
              initialized.options = sortable.options;
              sortable[pluginName] = initialized;

              // Add default options from plugin
              _extends(defaults, initialized.defaults);
            });
            for (var option in sortable.options) {
              if (!sortable.options.hasOwnProperty(option)) continue;
              var modified = this.modifyOption(sortable, option, sortable.options[option]);
              if (typeof modified !== 'undefined') {
                sortable.options[option] = modified;
              }
            }
          },
          getEventProperties: function getEventProperties(name, sortable) {
            var eventProperties = {};
            plugins.forEach(function (plugin) {
              if (typeof plugin.eventProperties !== 'function') return;
              _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
            });
            return eventProperties;
          },
          modifyOption: function modifyOption(sortable, name, value) {
            var modifiedValue;
            plugins.forEach(function (plugin) {
              // Plugin must exist on the Sortable
              if (!sortable[plugin.pluginName]) return;

              // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin
              if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') {
                modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
              }
            });
            return modifiedValue;
          }
        };
        function dispatchEvent(_ref) {
          var sortable = _ref.sortable,
            rootEl = _ref.rootEl,
            name = _ref.name,
            targetEl = _ref.targetEl,
            cloneEl = _ref.cloneEl,
            toEl = _ref.toEl,
            fromEl = _ref.fromEl,
            oldIndex = _ref.oldIndex,
            newIndex = _ref.newIndex,
            oldDraggableIndex = _ref.oldDraggableIndex,
            newDraggableIndex = _ref.newDraggableIndex,
            originalEvent = _ref.originalEvent,
            putSortable = _ref.putSortable,
            extraEventProperties = _ref.extraEventProperties;
          sortable = sortable || rootEl && rootEl[expando];
          if (!sortable) return;
          var evt,
            options = sortable.options,
            onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1);
          // Support for new CustomEvent feature
          if (window.CustomEvent && !IE11OrLess && !Edge) {
            evt = new CustomEvent(name, {
              bubbles: true,
              cancelable: true
            });
          } else {
            evt = document.createEvent('Event');
            evt.initEvent(name, true, true);
          }
          evt.to = toEl || rootEl;
          evt.from = fromEl || rootEl;
          evt.item = targetEl || rootEl;
          evt.clone = cloneEl;
          evt.oldIndex = oldIndex;
          evt.newIndex = newIndex;
          evt.oldDraggableIndex = oldDraggableIndex;
          evt.newDraggableIndex = newDraggableIndex;
          evt.originalEvent = originalEvent;
          evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;
          var allEventProperties = _objectSpread2(_objectSpread2({}, extraEventProperties), PluginManager.getEventProperties(name, sortable));
          for (var option in allEventProperties) {
            evt[option] = allEventProperties[option];
          }
          if (rootEl) {
            rootEl.dispatchEvent(evt);
          }
          if (options[onName]) {
            options[onName].call(sortable, evt);
          }
        }
        var _excluded = ["evt"];
        var pluginEvent = function pluginEvent(eventName, sortable) {
          var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
            originalEvent = _ref.evt,
            data = _objectWithoutProperties(_ref, _excluded);
          PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread2({
            dragEl: dragEl,
            parentEl: parentEl,
            ghostEl: ghostEl,
            rootEl: rootEl,
            nextEl: nextEl,
            lastDownEl: lastDownEl,
            cloneEl: cloneEl,
            cloneHidden: cloneHidden,
            dragStarted: moved,
            putSortable: putSortable,
            activeSortable: Sortable.active,
            originalEvent: originalEvent,
            oldIndex: oldIndex,
            oldDraggableIndex: oldDraggableIndex,
            newIndex: newIndex,
            newDraggableIndex: newDraggableIndex,
            hideGhostForTarget: _hideGhostForTarget,
            unhideGhostForTarget: _unhideGhostForTarget,
            cloneNowHidden: function cloneNowHidden() {
              cloneHidden = true;
            },
            cloneNowShown: function cloneNowShown() {
              cloneHidden = false;
            },
            dispatchSortableEvent: function dispatchSortableEvent(name) {
              _dispatchEvent({
                sortable: sortable,
                name: name,
                originalEvent: originalEvent
              });
            }
          }, data));
        };
        function _dispatchEvent(info) {
          dispatchEvent(_objectSpread2({
            putSortable: putSortable,
            cloneEl: cloneEl,
            targetEl: dragEl,
            rootEl: rootEl,
            oldIndex: oldIndex,
            oldDraggableIndex: oldDraggableIndex,
            newIndex: newIndex,
            newDraggableIndex: newDraggableIndex
          }, info));
        }
        var dragEl,
          parentEl,
          ghostEl,
          rootEl,
          nextEl,
          lastDownEl,
          cloneEl,
          cloneHidden,
          oldIndex,
          newIndex,
          oldDraggableIndex,
          newDraggableIndex,
          activeGroup,
          putSortable,
          awaitingDragStarted = false,
          ignoreNextClick = false,
          sortables = [],
          tapEvt,
          touchEvt,
          lastDx,
          lastDy,
          tapDistanceLeft,
          tapDistanceTop,
          moved,
          lastTarget,
          lastDirection,
          pastFirstInvertThresh = false,
          isCircumstantialInvert = false,
          targetMoveDistance,
          // For positioning ghost absolutely
          ghostRelativeParent,
          ghostRelativeParentInitialScroll = [],
          // (left, top)

          _silent = false,
          savedInputChecked = [];

        /** @const */
        var documentExists = typeof document !== 'undefined',
          PositionGhostAbsolutely = IOS,
          CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float',
          // This will not pass for IE9, because IE9 DnD only works on anchors
          supportDraggable = documentExists && !ChromeForAndroid && !IOS && 'draggable' in document.createElement('div'),
          supportCssPointerEvents = function () {
            if (!documentExists) return;
            // false when <= IE11
            if (IE11OrLess) {
              return false;
            }
            var el = document.createElement('x');
            el.style.cssText = 'pointer-events:auto';
            return el.style.pointerEvents === 'auto';
          }(),
          _detectDirection = function _detectDirection(el, options) {
            var elCSS = css(el),
              elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth),
              child1 = getChild(el, 0, options),
              child2 = getChild(el, 1, options),
              firstChildCSS = child1 && css(child1),
              secondChildCSS = child2 && css(child2),
              firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width,
              secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;
            if (elCSS.display === 'flex') {
              return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
            }
            if (elCSS.display === 'grid') {
              return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
            }
            if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
              var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
              return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
            }
            return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
          },
          _dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
            var dragElS1Opp = vertical ? dragRect.left : dragRect.top,
              dragElS2Opp = vertical ? dragRect.right : dragRect.bottom,
              dragElOppLength = vertical ? dragRect.width : dragRect.height,
              targetS1Opp = vertical ? targetRect.left : targetRect.top,
              targetS2Opp = vertical ? targetRect.right : targetRect.bottom,
              targetOppLength = vertical ? targetRect.width : targetRect.height;
            return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
          },
          /**
          * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
          * @param  {Number} x      X position
          * @param  {Number} y      Y position
          * @return {HTMLElement}   Element of the first found nearest Sortable
          */
          _detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
            var ret;
            sortables.some(function (sortable) {
              var threshold = sortable[expando].options.emptyInsertThreshold;
              if (!threshold || lastChild(sortable)) return;
              var rect = getRect(sortable),
                insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold,
                insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
              if (insideHorizontally && insideVertically) {
                return ret = sortable;
              }
            });
            return ret;
          },
          _prepareGroup = function _prepareGroup(options) {
            function toFn(value, pull) {
              return function (to, from, dragEl, evt) {
                var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
                if (value == null && (pull || sameGroup)) {
                  // Default pull value
                  // Default pull and put value if same group
                  return true;
                } else if (value == null || value === false) {
                  return false;
                } else if (pull && value === 'clone') {
                  return value;
                } else if (typeof value === 'function') {
                  return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
                } else {
                  var otherGroup = (pull ? to : from).options.group.name;
                  return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
                }
              };
            }
            var group = {};
            var originalGroup = options.group;
            if (!originalGroup || _typeof(originalGroup) != 'object') {
              originalGroup = {
                name: originalGroup
              };
            }
            group.name = originalGroup.name;
            group.checkPull = toFn(originalGroup.pull, true);
            group.checkPut = toFn(originalGroup.put);
            group.revertClone = originalGroup.revertClone;
            options.group = group;
          },
          _hideGhostForTarget = function _hideGhostForTarget() {
            if (!supportCssPointerEvents && ghostEl) {
              css(ghostEl, 'display', 'none');
            }
          },
          _unhideGhostForTarget = function _unhideGhostForTarget() {
            if (!supportCssPointerEvents && ghostEl) {
              css(ghostEl, 'display', '');
            }
          };

        // #1184 fix - Prevent click event on fallback if dragged but item not changed position
        if (documentExists && !ChromeForAndroid) {
          document.addEventListener('click', function (evt) {
            if (ignoreNextClick) {
              evt.preventDefault();
              evt.stopPropagation && evt.stopPropagation();
              evt.stopImmediatePropagation && evt.stopImmediatePropagation();
              ignoreNextClick = false;
              return false;
            }
          }, true);
        }
        var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
          if (dragEl) {
            evt = evt.touches ? evt.touches[0] : evt;
            var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);
            if (nearest) {
              // Create imitation event
              var event = {};
              for (var i in evt) {
                if (evt.hasOwnProperty(i)) {
                  event[i] = evt[i];
                }
              }
              event.target = event.rootEl = nearest;
              event.preventDefault = void 0;
              event.stopPropagation = void 0;
              nearest[expando]._onDragOver(event);
            }
          }
        };
        var _checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
          if (dragEl) {
            dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
          }
        };

        /**
        * @class  Sortable
        * @param  {HTMLElement}  el
        * @param  {Object}       [options]
        */
        function Sortable(el, options) {
          if (!(el && el.nodeType && el.nodeType === 1)) {
            throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
          }
          this.el = el; // root element
          this.options = options = _extends({}, options);

          // Export instance
          el[expando] = this;
          var defaults = {
            group: null,
            sort: true,
            disabled: false,
            store: null,
            handle: null,
            draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
            swapThreshold: 1,
            // percentage; 0 <= x <= 1
            invertSwap: false,
            // invert always
            invertedSwapThreshold: null,
            // will be set to same as swapThreshold if default
            removeCloneOnHide: true,
            direction: function direction() {
              return _detectDirection(el, this.options);
            },
            ghostClass: 'sortable-ghost',
            chosenClass: 'sortable-chosen',
            dragClass: 'sortable-drag',
            ignore: 'a, img',
            filter: null,
            preventOnFilter: true,
            animation: 0,
            easing: null,
            setData: function setData(dataTransfer, dragEl) {
              dataTransfer.setData('Text', dragEl.textContent);
            },
            dropBubble: false,
            dragoverBubble: false,
            dataIdAttr: 'data-id',
            delay: 0,
            delayOnTouchOnly: false,
            touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
            forceFallback: false,
            fallbackClass: 'sortable-fallback',
            fallbackOnBody: false,
            fallbackTolerance: 0,
            fallbackOffset: {
              x: 0,
              y: 0
            },
            supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window && !Safari,
            emptyInsertThreshold: 5
          };
          PluginManager.initializePlugins(this, el, defaults);

          // Set default options
          for (var name in defaults) {
            !(name in options) && (options[name] = defaults[name]);
          }
          _prepareGroup(options);

          // Bind all private methods
          for (var fn in this) {
            if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
              this[fn] = this[fn].bind(this);
            }
          }

          // Setup drag mode
          this.nativeDraggable = options.forceFallback ? false : supportDraggable;
          if (this.nativeDraggable) {
            // Touch start threshold cannot be greater than the native dragstart threshold
            this.options.touchStartThreshold = 1;
          }

          // Bind events
          if (options.supportPointer) {
            on(el, 'pointerdown', this._onTapStart);
          } else {
            on(el, 'mousedown', this._onTapStart);
            on(el, 'touchstart', this._onTapStart);
          }
          if (this.nativeDraggable) {
            on(el, 'dragover', this);
            on(el, 'dragenter', this);
          }
          sortables.push(this.el);

          // Restore sorting
          options.store && options.store.get && this.sort(options.store.get(this) || []);

          // Add animation state manager
          _extends(this, AnimationStateManager());
        }
        Sortable.prototype = /** @lends Sortable.prototype */{
          constructor: Sortable,
          _isOutsideThisEl: function _isOutsideThisEl(target) {
            if (!this.el.contains(target) && target !== this.el) {
              lastTarget = null;
            }
          },
          _getDirection: function _getDirection(evt, target) {
            return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
          },
          _onTapStart: function _onTapStart(/** Event|TouchEvent */evt) {
            if (!evt.cancelable) return;
            var _this = this,
              el = this.el,
              options = this.options,
              preventOnFilter = options.preventOnFilter,
              type = evt.type,
              touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt,
              target = (touch || evt).target,
              originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target,
              filter = options.filter;
            _saveInputCheckedState(el);

            // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
            if (dragEl) {
              return;
            }
            if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
              return; // only left button and enabled
            }

            // cancel dnd if original target is content editable
            if (originalTarget.isContentEditable) {
              return;
            }

            // Safari ignores further event handling after mousedown
            if (!this.nativeDraggable && Safari && target && target.tagName.toUpperCase() === 'SELECT') {
              return;
            }
            target = closest(target, options.draggable, el, false);
            if (target && target.animated) {
              return;
            }
            if (lastDownEl === target) {
              // Ignoring duplicate `down`
              return;
            }

            // Get the index of the dragged element within its parent
            oldIndex = index(target);
            oldDraggableIndex = index(target, options.draggable);

            // Check filter
            if (typeof filter === 'function') {
              if (filter.call(this, evt, target, this)) {
                _dispatchEvent({
                  sortable: _this,
                  rootEl: originalTarget,
                  name: 'filter',
                  targetEl: target,
                  toEl: el,
                  fromEl: el
                });
                pluginEvent('filter', _this, {
                  evt: evt
                });
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return; // cancel dnd
              }
            } else if (filter) {
              filter = filter.split(',').some(function (criteria) {
                criteria = closest(originalTarget, criteria.trim(), el, false);
                if (criteria) {
                  _dispatchEvent({
                    sortable: _this,
                    rootEl: criteria,
                    name: 'filter',
                    targetEl: target,
                    fromEl: el,
                    toEl: el
                  });
                  pluginEvent('filter', _this, {
                    evt: evt
                  });
                  return true;
                }
              });
              if (filter) {
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return; // cancel dnd
              }
            }
            if (options.handle && !closest(originalTarget, options.handle, el, false)) {
              return;
            }

            // Prepare `dragstart`
            this._prepareDragStart(evt, touch, target);
          },
          _prepareDragStart: function _prepareDragStart(/** Event */evt, /** Touch */touch, /** HTMLElement */target) {
            var _this = this,
              el = _this.el,
              options = _this.options,
              ownerDocument = el.ownerDocument,
              dragStartFn;
            if (target && !dragEl && target.parentNode === el) {
              var dragRect = getRect(target);
              rootEl = el;
              dragEl = target;
              parentEl = dragEl.parentNode;
              nextEl = dragEl.nextSibling;
              lastDownEl = target;
              activeGroup = options.group;
              Sortable.dragged = dragEl;
              tapEvt = {
                target: dragEl,
                clientX: (touch || evt).clientX,
                clientY: (touch || evt).clientY
              };
              tapDistanceLeft = tapEvt.clientX - dragRect.left;
              tapDistanceTop = tapEvt.clientY - dragRect.top;
              this._lastX = (touch || evt).clientX;
              this._lastY = (touch || evt).clientY;
              dragEl.style['will-change'] = 'all';
              dragStartFn = function dragStartFn() {
                pluginEvent('delayEnded', _this, {
                  evt: evt
                });
                if (Sortable.eventCanceled) {
                  _this._onDrop();
                  return;
                }
                // Delayed drag has been triggered
                // we can re-enable the events: touchmove/mousemove
                _this._disableDelayedDragEvents();
                if (!FireFox && _this.nativeDraggable) {
                  dragEl.draggable = true;
                }

                // Bind the events: dragstart/dragend
                _this._triggerDragStart(evt, touch);

                // Drag start event
                _dispatchEvent({
                  sortable: _this,
                  name: 'choose',
                  originalEvent: evt
                });

                // Chosen item
                toggleClass(dragEl, options.chosenClass, true);
              };

              // Disable "draggable"
              options.ignore.split(',').forEach(function (criteria) {
                find(dragEl, criteria.trim(), _disableDraggable);
              });
              on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
              on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
              on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);
              on(ownerDocument, 'mouseup', _this._onDrop);
              on(ownerDocument, 'touchend', _this._onDrop);
              on(ownerDocument, 'touchcancel', _this._onDrop);

              // Make dragEl draggable (must be before delay for FireFox)
              if (FireFox && this.nativeDraggable) {
                this.options.touchStartThreshold = 4;
                dragEl.draggable = true;
              }
              pluginEvent('delayStart', this, {
                evt: evt
              });

              // Delay is impossible for native DnD in Edge or IE
              if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
                if (Sortable.eventCanceled) {
                  this._onDrop();
                  return;
                }
                // If the user moves the pointer or let go the click or touch
                // before the delay has been reached:
                // disable the delayed drag
                on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
                on(ownerDocument, 'touchend', _this._disableDelayedDrag);
                on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
                on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
                on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
                options.supportPointer && on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
                _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
              } else {
                dragStartFn();
              }
            }
          },
          _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(/** TouchEvent|PointerEvent **/e) {
            var touch = e.touches ? e.touches[0] : e;
            if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
              this._disableDelayedDrag();
            }
          },
          _disableDelayedDrag: function _disableDelayedDrag() {
            dragEl && _disableDraggable(dragEl);
            clearTimeout(this._dragStartTimer);
            this._disableDelayedDragEvents();
          },
          _disableDelayedDragEvents: function _disableDelayedDragEvents() {
            var ownerDocument = this.el.ownerDocument;
            off(ownerDocument, 'mouseup', this._disableDelayedDrag);
            off(ownerDocument, 'touchend', this._disableDelayedDrag);
            off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
            off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
            off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
            off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
          },
          _triggerDragStart: function _triggerDragStart(/** Event */evt, /** Touch */touch) {
            touch = touch || evt.pointerType == 'touch' && evt;
            if (!this.nativeDraggable || touch) {
              if (this.options.supportPointer) {
                on(document, 'pointermove', this._onTouchMove);
              } else if (touch) {
                on(document, 'touchmove', this._onTouchMove);
              } else {
                on(document, 'mousemove', this._onTouchMove);
              }
            } else {
              on(dragEl, 'dragend', this);
              on(rootEl, 'dragstart', this._onDragStart);
            }
            try {
              if (document.selection) {
                // Timeout neccessary for IE9
                _nextTick(function () {
                  document.selection.empty();
                });
              } else {
                window.getSelection().removeAllRanges();
              }
            } catch (err) {}
          },
          _dragStarted: function _dragStarted(fallback, evt) {
            awaitingDragStarted = false;
            if (rootEl && dragEl) {
              pluginEvent('dragStarted', this, {
                evt: evt
              });
              if (this.nativeDraggable) {
                on(document, 'dragover', _checkOutsideTargetEl);
              }
              var options = this.options;

              // Apply effect
              !fallback && toggleClass(dragEl, options.dragClass, false);
              toggleClass(dragEl, options.ghostClass, true);
              Sortable.active = this;
              fallback && this._appendGhost();

              // Drag start event
              _dispatchEvent({
                sortable: this,
                name: 'start',
                originalEvent: evt
              });
            } else {
              this._nulling();
            }
          },
          _emulateDragOver: function _emulateDragOver() {
            if (touchEvt) {
              this._lastX = touchEvt.clientX;
              this._lastY = touchEvt.clientY;
              _hideGhostForTarget();
              var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
              var parent = target;
              while (target && target.shadowRoot) {
                target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
                if (target === parent) break;
                parent = target;
              }
              dragEl.parentNode[expando]._isOutsideThisEl(target);
              if (parent) {
                do {
                  if (parent[expando]) {
                    var inserted = void 0;
                    inserted = parent[expando]._onDragOver({
                      clientX: touchEvt.clientX,
                      clientY: touchEvt.clientY,
                      target: target,
                      rootEl: parent
                    });
                    if (inserted && !this.options.dragoverBubble) {
                      break;
                    }
                  }
                  target = parent; // store last element
                }
                /* jshint boss:true */ while (parent = parent.parentNode);
              }
              _unhideGhostForTarget();
            }
          },
          _onTouchMove: function _onTouchMove(/**TouchEvent*/evt) {
            if (tapEvt) {
              var options = this.options,
                fallbackTolerance = options.fallbackTolerance,
                fallbackOffset = options.fallbackOffset,
                touch = evt.touches ? evt.touches[0] : evt,
                ghostMatrix = ghostEl && matrix(ghostEl, true),
                scaleX = ghostEl && ghostMatrix && ghostMatrix.a,
                scaleY = ghostEl && ghostMatrix && ghostMatrix.d,
                relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent),
                dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1),
                dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1);

              // only set the status to dragging, when we are actually dragging
              if (!Sortable.active && !awaitingDragStarted) {
                if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
                  return;
                }
                this._onDragStart(evt, true);
              }
              if (ghostEl) {
                if (ghostMatrix) {
                  ghostMatrix.e += dx - (lastDx || 0);
                  ghostMatrix.f += dy - (lastDy || 0);
                } else {
                  ghostMatrix = {
                    a: 1,
                    b: 0,
                    c: 0,
                    d: 1,
                    e: dx,
                    f: dy
                  };
                }
                var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
                css(ghostEl, 'webkitTransform', cssMatrix);
                css(ghostEl, 'mozTransform', cssMatrix);
                css(ghostEl, 'msTransform', cssMatrix);
                css(ghostEl, 'transform', cssMatrix);
                lastDx = dx;
                lastDy = dy;
                touchEvt = touch;
              }
              evt.cancelable && evt.preventDefault();
            }
          },
          _appendGhost: function _appendGhost() {
            // Bug if using scale(): https://stackoverflow.com/questions/2637058
            // Not being adjusted for
            if (!ghostEl) {
              var container = this.options.fallbackOnBody ? document.body : rootEl,
                rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container),
                options = this.options;

              // Position absolutely
              if (PositionGhostAbsolutely) {
                // Get relatively positioned parent
                ghostRelativeParent = container;
                while (css(ghostRelativeParent, 'position') === 'static' && css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document) {
                  ghostRelativeParent = ghostRelativeParent.parentNode;
                }
                if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
                  if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
                  rect.top += ghostRelativeParent.scrollTop;
                  rect.left += ghostRelativeParent.scrollLeft;
                } else {
                  ghostRelativeParent = getWindowScrollingElement();
                }
                ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
              }
              ghostEl = dragEl.cloneNode(true);
              toggleClass(ghostEl, options.ghostClass, false);
              toggleClass(ghostEl, options.fallbackClass, true);
              toggleClass(ghostEl, options.dragClass, true);
              css(ghostEl, 'transition', '');
              css(ghostEl, 'transform', '');
              css(ghostEl, 'box-sizing', 'border-box');
              css(ghostEl, 'margin', 0);
              css(ghostEl, 'top', rect.top);
              css(ghostEl, 'left', rect.left);
              css(ghostEl, 'width', rect.width);
              css(ghostEl, 'height', rect.height);
              css(ghostEl, 'opacity', '0.8');
              css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
              css(ghostEl, 'zIndex', '100000');
              css(ghostEl, 'pointerEvents', 'none');
              Sortable.ghost = ghostEl;
              container.appendChild(ghostEl);

              // Set transform-origin
              css(ghostEl, 'transform-origin', tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + '% ' + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + '%');
            }
          },
          _onDragStart: function _onDragStart(/**Event*/evt, /**boolean*/fallback) {
            var _this = this;
            var dataTransfer = evt.dataTransfer;
            var options = _this.options;
            pluginEvent('dragStart', this, {
              evt: evt
            });
            if (Sortable.eventCanceled) {
              this._onDrop();
              return;
            }
            pluginEvent('setupClone', this);
            if (!Sortable.eventCanceled) {
              cloneEl = clone(dragEl);
              cloneEl.removeAttribute("id");
              cloneEl.draggable = false;
              cloneEl.style['will-change'] = '';
              this._hideClone();
              toggleClass(cloneEl, this.options.chosenClass, false);
              Sortable.clone = cloneEl;
            }

            // #1143: IFrame support workaround
            _this.cloneId = _nextTick(function () {
              pluginEvent('clone', _this);
              if (Sortable.eventCanceled) return;
              if (!_this.options.removeCloneOnHide) {
                rootEl.insertBefore(cloneEl, dragEl);
              }
              _this._hideClone();
              _dispatchEvent({
                sortable: _this,
                name: 'clone'
              });
            });
            !fallback && toggleClass(dragEl, options.dragClass, true);

            // Set proper drop events
            if (fallback) {
              ignoreNextClick = true;
              _this._loopId = setInterval(_this._emulateDragOver, 50);
            } else {
              // Undo what was set in _prepareDragStart before drag started
              off(document, 'mouseup', _this._onDrop);
              off(document, 'touchend', _this._onDrop);
              off(document, 'touchcancel', _this._onDrop);
              if (dataTransfer) {
                dataTransfer.effectAllowed = 'move';
                options.setData && options.setData.call(_this, dataTransfer, dragEl);
              }
              on(document, 'drop', _this);

              // #1276 fix:
              css(dragEl, 'transform', 'translateZ(0)');
            }
            awaitingDragStarted = true;
            _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
            on(document, 'selectstart', _this);
            moved = true;
            if (Safari) {
              css(document.body, 'user-select', 'none');
            }
          },
          // Returns true - if no further action is needed (either inserted or another condition)
          _onDragOver: function _onDragOver(/**Event*/evt) {
            var el = this.el,
              target = evt.target,
              dragRect,
              targetRect,
              revert,
              options = this.options,
              group = options.group,
              activeSortable = Sortable.active,
              isOwner = activeGroup === group,
              canSort = options.sort,
              fromSortable = putSortable || activeSortable,
              vertical,
              _this = this,
              completedFired = false;
            if (_silent) return;
            function dragOverEvent(name, extra) {
              pluginEvent(name, _this, _objectSpread2({
                evt: evt,
                isOwner: isOwner,
                axis: vertical ? 'vertical' : 'horizontal',
                revert: revert,
                dragRect: dragRect,
                targetRect: targetRect,
                canSort: canSort,
                fromSortable: fromSortable,
                target: target,
                completed: completed,
                onMove: function onMove(target, after) {
                  return _onMove(rootEl, el, dragEl, dragRect, target, getRect(target), evt, after);
                },
                changed: changed
              }, extra));
            }

            // Capture animation state
            function capture() {
              dragOverEvent('dragOverAnimationCapture');
              _this.captureAnimationState();
              if (_this !== fromSortable) {
                fromSortable.captureAnimationState();
              }
            }

            // Return invocation when dragEl is inserted (or completed)
            function completed(insertion) {
              dragOverEvent('dragOverCompleted', {
                insertion: insertion
              });
              if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) {
                  activeSortable._hideClone();
                } else {
                  activeSortable._showClone(_this);
                }
                if (_this !== fromSortable) {
                  // Set ghost class to new sortable's ghost class
                  toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
                  toggleClass(dragEl, options.ghostClass, true);
                }
                if (putSortable !== _this && _this !== Sortable.active) {
                  putSortable = _this;
                } else if (_this === Sortable.active && putSortable) {
                  putSortable = null;
                }

                // Animation
                if (fromSortable === _this) {
                  _this._ignoreWhileAnimating = target;
                }
                _this.animateAll(function () {
                  dragOverEvent('dragOverAnimationComplete');
                  _this._ignoreWhileAnimating = null;
                });
                if (_this !== fromSortable) {
                  fromSortable.animateAll();
                  fromSortable._ignoreWhileAnimating = null;
                }
              }

              // Null lastTarget if it is not inside a previously swapped element
              if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
                lastTarget = null;
              }

              // no bubbling and not fallback
              if (!options.dragoverBubble && !evt.rootEl && target !== document) {
                dragEl.parentNode[expando]._isOutsideThisEl(evt.target);

                // Do not detect for empty insert if already inserted
                !insertion && nearestEmptyInsertDetectEvent(evt);
              }
              !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
              return completedFired = true;
            }

            // Call when dragEl has been inserted
            function changed() {
              newIndex = index(dragEl);
              newDraggableIndex = index(dragEl, options.draggable);
              _dispatchEvent({
                sortable: _this,
                name: 'change',
                toEl: el,
                newIndex: newIndex,
                newDraggableIndex: newDraggableIndex,
                originalEvent: evt
              });
            }
            if (evt.preventDefault !== void 0) {
              evt.cancelable && evt.preventDefault();
            }
            target = closest(target, options.draggable, el, true);
            dragOverEvent('dragOver');
            if (Sortable.eventCanceled) return completedFired;
            if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
              return completed(false);
            }
            ignoreNextClick = false;
            if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = parentEl !== rootEl) // Reverting item into the original list
            : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
              vertical = this._getDirection(evt, target) === 'vertical';
              dragRect = getRect(dragEl);
              dragOverEvent('dragOverValid');
              if (Sortable.eventCanceled) return completedFired;
              if (revert) {
                parentEl = rootEl; // actualization
                capture();
                this._hideClone();
                dragOverEvent('revert');
                if (!Sortable.eventCanceled) {
                  if (nextEl) {
                    rootEl.insertBefore(dragEl, nextEl);
                  } else {
                    rootEl.appendChild(dragEl);
                  }
                }
                return completed(true);
              }
              var elLastChild = lastChild(el, options.draggable);
              if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
                // Insert to end of list

                // If already at end of list: Do not insert
                if (elLastChild === dragEl) {
                  return completed(false);
                }

                // if there is a last element, it is the target
                if (elLastChild && el === evt.target) {
                  target = elLastChild;
                }
                if (target) {
                  targetRect = getRect(target);
                }
                if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
                  capture();
                  if (elLastChild && elLastChild.nextSibling) {
                    // the last draggable element is not the last node
                    el.insertBefore(dragEl, elLastChild.nextSibling);
                  } else {
                    el.appendChild(dragEl);
                  }
                  parentEl = el; // actualization

                  changed();
                  return completed(true);
                }
              } else if (elLastChild && _ghostIsFirst(evt, vertical, this)) {
                // Insert to start of list
                var firstChild = getChild(el, 0, options, true);
                if (firstChild === dragEl) {
                  return completed(false);
                }
                target = firstChild;
                targetRect = getRect(target);
                if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, false) !== false) {
                  capture();
                  el.insertBefore(dragEl, firstChild);
                  parentEl = el; // actualization

                  changed();
                  return completed(true);
                }
              } else if (target.parentNode === el) {
                targetRect = getRect(target);
                var direction = 0,
                  targetBeforeFirstSwap,
                  differentLevel = dragEl.parentNode !== el,
                  differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical),
                  side1 = vertical ? 'top' : 'left',
                  scrolledPastTop = isScrolledPast(target, 'top', 'top') || isScrolledPast(dragEl, 'top', 'top'),
                  scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
                if (lastTarget !== target) {
                  targetBeforeFirstSwap = targetRect[side1];
                  pastFirstInvertThresh = false;
                  isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
                }
                direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
                var sibling;
                if (direction !== 0) {
                  // Check if target is beside dragEl in respective direction (ignoring hidden elements)
                  var dragIndex = index(dragEl);
                  do {
                    dragIndex -= direction;
                    sibling = parentEl.children[dragIndex];
                  } while (sibling && (css(sibling, 'display') === 'none' || sibling === ghostEl));
                }
                // If dragEl is already beside target: Do not insert
                if (direction === 0 || sibling === target) {
                  return completed(false);
                }
                lastTarget = target;
                lastDirection = direction;
                var nextSibling = target.nextElementSibling,
                  after = false;
                after = direction === 1;
                var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);
                if (moveVector !== false) {
                  if (moveVector === 1 || moveVector === -1) {
                    after = moveVector === 1;
                  }
                  _silent = true;
                  setTimeout(_unsilent, 30);
                  capture();
                  if (after && !nextSibling) {
                    el.appendChild(dragEl);
                  } else {
                    target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
                  }

                  // Undo chrome's scroll adjustment (has no effect on other browsers)
                  if (scrolledPastTop) {
                    scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
                  }
                  parentEl = dragEl.parentNode; // actualization

                  // must be done before animation
                  if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) {
                    targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
                  }
                  changed();
                  return completed(true);
                }
              }
              if (el.contains(dragEl)) {
                return completed(false);
              }
            }
            return false;
          },
          _ignoreWhileAnimating: null,
          _offMoveEvents: function _offMoveEvents() {
            off(document, 'mousemove', this._onTouchMove);
            off(document, 'touchmove', this._onTouchMove);
            off(document, 'pointermove', this._onTouchMove);
            off(document, 'dragover', nearestEmptyInsertDetectEvent);
            off(document, 'mousemove', nearestEmptyInsertDetectEvent);
            off(document, 'touchmove', nearestEmptyInsertDetectEvent);
          },
          _offUpEvents: function _offUpEvents() {
            var ownerDocument = this.el.ownerDocument;
            off(ownerDocument, 'mouseup', this._onDrop);
            off(ownerDocument, 'touchend', this._onDrop);
            off(ownerDocument, 'pointerup', this._onDrop);
            off(ownerDocument, 'touchcancel', this._onDrop);
            off(document, 'selectstart', this);
          },
          _onDrop: function _onDrop(/**Event*/evt) {
            var el = this.el,
              options = this.options;

            // Get the index of the dragged element within its parent
            newIndex = index(dragEl);
            newDraggableIndex = index(dragEl, options.draggable);
            pluginEvent('drop', this, {
              evt: evt
            });
            parentEl = dragEl && dragEl.parentNode;

            // Get again after plugin event
            newIndex = index(dragEl);
            newDraggableIndex = index(dragEl, options.draggable);
            if (Sortable.eventCanceled) {
              this._nulling();
              return;
            }
            awaitingDragStarted = false;
            isCircumstantialInvert = false;
            pastFirstInvertThresh = false;
            clearInterval(this._loopId);
            clearTimeout(this._dragStartTimer);
            _cancelNextTick(this.cloneId);
            _cancelNextTick(this._dragStartId);

            // Unbind events
            if (this.nativeDraggable) {
              off(document, 'drop', this);
              off(el, 'dragstart', this._onDragStart);
            }
            this._offMoveEvents();
            this._offUpEvents();
            if (Safari) {
              css(document.body, 'user-select', '');
            }
            css(dragEl, 'transform', '');
            if (evt) {
              if (moved) {
                evt.cancelable && evt.preventDefault();
                !options.dropBubble && evt.stopPropagation();
              }
              ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);
              if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
                // Remove clone(s)
                cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
              }
              if (dragEl) {
                if (this.nativeDraggable) {
                  off(dragEl, 'dragend', this);
                }
                _disableDraggable(dragEl);
                dragEl.style['will-change'] = '';

                // Remove classes
                // ghostClass is added in dragStarted
                if (moved && !awaitingDragStarted) {
                  toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
                }
                toggleClass(dragEl, this.options.chosenClass, false);

                // Drag stop event
                _dispatchEvent({
                  sortable: this,
                  name: 'unchoose',
                  toEl: parentEl,
                  newIndex: null,
                  newDraggableIndex: null,
                  originalEvent: evt
                });
                if (rootEl !== parentEl) {
                  if (newIndex >= 0) {
                    // Add event
                    _dispatchEvent({
                      rootEl: parentEl,
                      name: 'add',
                      toEl: parentEl,
                      fromEl: rootEl,
                      originalEvent: evt
                    });

                    // Remove event
                    _dispatchEvent({
                      sortable: this,
                      name: 'remove',
                      toEl: parentEl,
                      originalEvent: evt
                    });

                    // drag from one list and drop into another
                    _dispatchEvent({
                      rootEl: parentEl,
                      name: 'sort',
                      toEl: parentEl,
                      fromEl: rootEl,
                      originalEvent: evt
                    });
                    _dispatchEvent({
                      sortable: this,
                      name: 'sort',
                      toEl: parentEl,
                      originalEvent: evt
                    });
                  }
                  putSortable && putSortable.save();
                } else {
                  if (newIndex !== oldIndex) {
                    if (newIndex >= 0) {
                      // drag & drop within the same list
                      _dispatchEvent({
                        sortable: this,
                        name: 'update',
                        toEl: parentEl,
                        originalEvent: evt
                      });
                      _dispatchEvent({
                        sortable: this,
                        name: 'sort',
                        toEl: parentEl,
                        originalEvent: evt
                      });
                    }
                  }
                }
                if (Sortable.active) {
                  /* jshint eqnull:true */
                  if (newIndex == null || newIndex === -1) {
                    newIndex = oldIndex;
                    newDraggableIndex = oldDraggableIndex;
                  }
                  _dispatchEvent({
                    sortable: this,
                    name: 'end',
                    toEl: parentEl,
                    originalEvent: evt
                  });

                  // Save sorting
                  this.save();
                }
              }
            }
            this._nulling();
          },
          _nulling: function _nulling() {
            pluginEvent('nulling', this);
            rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
            savedInputChecked.forEach(function (el) {
              el.checked = true;
            });
            savedInputChecked.length = lastDx = lastDy = 0;
          },
          handleEvent: function handleEvent(/**Event*/evt) {
            switch (evt.type) {
              case 'drop':
              case 'dragend':
                this._onDrop(evt);
                break;
              case 'dragenter':
              case 'dragover':
                if (dragEl) {
                  this._onDragOver(evt);
                  _globalDragOver(evt);
                }
                break;
              case 'selectstart':
                evt.preventDefault();
                break;
            }
          },
          /**
          * Serializes the item into an array of string.
          * @returns {String[]}
          */
          toArray: function toArray() {
            var order = [],
              el,
              children = this.el.children,
              i = 0,
              n = children.length,
              options = this.options;
            for (; i < n; i++) {
              el = children[i];
              if (closest(el, options.draggable, this.el, false)) {
                order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
              }
            }
            return order;
          },
          /**
          * Sorts the elements according to the array.
          * @param  {String[]}  order  order of the items
          */
          sort: function sort(order, useAnimation) {
            var items = {},
              rootEl = this.el;
            this.toArray().forEach(function (id, i) {
              var el = rootEl.children[i];
              if (closest(el, this.options.draggable, rootEl, false)) {
                items[id] = el;
              }
            }, this);
            useAnimation && this.captureAnimationState();
            order.forEach(function (id) {
              if (items[id]) {
                rootEl.removeChild(items[id]);
                rootEl.appendChild(items[id]);
              }
            });
            useAnimation && this.animateAll();
          },
          /**
          * Save the current sorting
          */
          save: function save() {
            var store = this.options.store;
            store && store.set && store.set(this);
          },
          /**
          * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
          * @param   {HTMLElement}  el
          * @param   {String}       [selector]  default: `options.draggable`
          * @returns {HTMLElement|null}
          */
          closest: function closest$1(el, selector) {
            return closest(el, selector || this.options.draggable, this.el, false);
          },
          /**
          * Set/get option
          * @param   {string} name
          * @param   {*}      [value]
          * @returns {*}
          */
          option: function option(name, value) {
            var options = this.options;
            if (value === void 0) {
              return options[name];
            } else {
              var modifiedValue = PluginManager.modifyOption(this, name, value);
              if (typeof modifiedValue !== 'undefined') {
                options[name] = modifiedValue;
              } else {
                options[name] = value;
              }
              if (name === 'group') {
                _prepareGroup(options);
              }
            }
          },
          /**
          * Destroy
          */
          destroy: function destroy() {
            pluginEvent('destroy', this);
            var el = this.el;
            el[expando] = null;
            off(el, 'mousedown', this._onTapStart);
            off(el, 'touchstart', this._onTapStart);
            off(el, 'pointerdown', this._onTapStart);
            if (this.nativeDraggable) {
              off(el, 'dragover', this);
              off(el, 'dragenter', this);
            }
            // Remove draggable attributes
            Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
              el.removeAttribute('draggable');
            });
            this._onDrop();
            this._disableDelayedDragEvents();
            sortables.splice(sortables.indexOf(this.el), 1);
            this.el = el = null;
          },
          _hideClone: function _hideClone() {
            if (!cloneHidden) {
              pluginEvent('hideClone', this);
              if (Sortable.eventCanceled) return;
              css(cloneEl, 'display', 'none');
              if (this.options.removeCloneOnHide && cloneEl.parentNode) {
                cloneEl.parentNode.removeChild(cloneEl);
              }
              cloneHidden = true;
            }
          },
          _showClone: function _showClone(putSortable) {
            if (putSortable.lastPutMode !== 'clone') {
              this._hideClone();
              return;
            }
            if (cloneHidden) {
              pluginEvent('showClone', this);
              if (Sortable.eventCanceled) return;

              // show clone at dragEl or original position
              if (dragEl.parentNode == rootEl && !this.options.group.revertClone) {
                rootEl.insertBefore(cloneEl, dragEl);
              } else if (nextEl) {
                rootEl.insertBefore(cloneEl, nextEl);
              } else {
                rootEl.appendChild(cloneEl);
              }
              if (this.options.group.revertClone) {
                this.animate(dragEl, cloneEl);
              }
              css(cloneEl, 'display', '');
              cloneHidden = false;
            }
          }
        };
        function _globalDragOver(/**Event*/evt) {
          if (evt.dataTransfer) {
            evt.dataTransfer.dropEffect = 'move';
          }
          evt.cancelable && evt.preventDefault();
        }
        function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
          var evt,
            sortable = fromEl[expando],
            onMoveFn = sortable.options.onMove,
            retVal;
          // Support for new CustomEvent feature
          if (window.CustomEvent && !IE11OrLess && !Edge) {
            evt = new CustomEvent('move', {
              bubbles: true,
              cancelable: true
            });
          } else {
            evt = document.createEvent('Event');
            evt.initEvent('move', true, true);
          }
          evt.to = toEl;
          evt.from = fromEl;
          evt.dragged = dragEl;
          evt.draggedRect = dragRect;
          evt.related = targetEl || toEl;
          evt.relatedRect = targetRect || getRect(toEl);
          evt.willInsertAfter = willInsertAfter;
          evt.originalEvent = originalEvent;
          fromEl.dispatchEvent(evt);
          if (onMoveFn) {
            retVal = onMoveFn.call(sortable, evt, originalEvent);
          }
          return retVal;
        }
        function _disableDraggable(el) {
          el.draggable = false;
        }
        function _unsilent() {
          _silent = false;
        }
        function _ghostIsFirst(evt, vertical, sortable) {
          var firstElRect = getRect(getChild(sortable.el, 0, sortable.options, true));
          var childContainingRect = getChildContainingRectFromElement(sortable.el, sortable.options, ghostEl);
          var spacer = 10;
          return vertical ? evt.clientX < childContainingRect.left - spacer || evt.clientY < firstElRect.top && evt.clientX < firstElRect.right : evt.clientY < childContainingRect.top - spacer || evt.clientY < firstElRect.bottom && evt.clientX < firstElRect.left;
        }
        function _ghostIsLast(evt, vertical, sortable) {
          var lastElRect = getRect(lastChild(sortable.el, sortable.options.draggable));
          var childContainingRect = getChildContainingRectFromElement(sortable.el, sortable.options, ghostEl);
          var spacer = 10;
          return vertical ? evt.clientX > childContainingRect.right + spacer || evt.clientY > lastElRect.bottom && evt.clientX > lastElRect.left : evt.clientY > childContainingRect.bottom + spacer || evt.clientX > lastElRect.right && evt.clientY > lastElRect.top;
        }
        function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
          var mouseOnAxis = vertical ? evt.clientY : evt.clientX,
            targetLength = vertical ? targetRect.height : targetRect.width,
            targetS1 = vertical ? targetRect.top : targetRect.left,
            targetS2 = vertical ? targetRect.bottom : targetRect.right,
            invert = false;
          if (!invertSwap) {
            // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
            if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
              // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
              // check if past first invert threshold on side opposite of lastDirection
              if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
                // past first invert threshold, do not restrict inverted threshold to dragEl shadow
                pastFirstInvertThresh = true;
              }
              if (!pastFirstInvertThresh) {
                // dragEl shadow (target move distance shadow)
                if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
                : mouseOnAxis > targetS2 - targetMoveDistance) {
                  return -lastDirection;
                }
              } else {
                invert = true;
              }
            } else {
              // Regular
              if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
                return _getInsertDirection(target);
              }
            }
          }
          invert = invert || invertSwap;
          if (invert) {
            // Invert of regular
            if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
              return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
            }
          }
          return 0;
        }

        /**
        * Gets the direction dragEl must be swapped relative to target in order to make it
        * seem that dragEl has been "inserted" into that element's position
        * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
        * @return {Number}                   Direction dragEl must be swapped
        */
        function _getInsertDirection(target) {
          if (index(dragEl) < index(target)) {
            return 1;
          } else {
            return -1;
          }
        }

        /**
        * Generate id
        * @param   {HTMLElement} el
        * @returns {String}
        * @private
        */
        function _generateId(el) {
          var str = el.tagName + el.className + el.src + el.href + el.textContent,
            i = str.length,
            sum = 0;
          while (i--) {
            sum += str.charCodeAt(i);
          }
          return sum.toString(36);
        }
        function _saveInputCheckedState(root) {
          savedInputChecked.length = 0;
          var inputs = root.getElementsByTagName('input');
          var idx = inputs.length;
          while (idx--) {
            var el = inputs[idx];
            el.checked && savedInputChecked.push(el);
          }
        }
        function _nextTick(fn) {
          return setTimeout(fn, 0);
        }
        function _cancelNextTick(id) {
          return clearTimeout(id);
        }

        // Fixed #973:
        if (documentExists) {
          on(document, 'touchmove', function (evt) {
            if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
              evt.preventDefault();
            }
          });
        }

        // Export utils
        Sortable.utils = {
          on: on,
          off: off,
          css: css,
          find: find,
          is: function is(el, selector) {
            return !!closest(el, selector, el, false);
          },
          extend: extend,
          throttle: throttle,
          closest: closest,
          toggleClass: toggleClass,
          clone: clone,
          index: index,
          nextTick: _nextTick,
          cancelNextTick: _cancelNextTick,
          detectDirection: _detectDirection,
          getChild: getChild
        };

        /**
        * Get the Sortable instance of an element
        * @param  {HTMLElement} element The element
        * @return {Sortable|undefined}         The instance of Sortable
        */
        Sortable.get = function (element) {
          return element[expando];
        };

        /**
        * Mount a plugin to Sortable
        * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
        */
        Sortable.mount = function () {
          for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
            plugins[_key] = arguments[_key];
          }
          if (plugins[0].constructor === Array) plugins = plugins[0];
          plugins.forEach(function (plugin) {
            if (!plugin.prototype || !plugin.prototype.constructor) {
              throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
            }
            if (plugin.utils) Sortable.utils = _objectSpread2(_objectSpread2({}, Sortable.utils), plugin.utils);
            PluginManager.mount(plugin);
          });
        };

        /**
        * Create sortable instance
        * @param {HTMLElement}  el
        * @param {Object}      [options]
        */
        Sortable.create = function (el, options) {
          return new Sortable(el, options);
        };

        // Export
        Sortable.version = version;
        var autoScrolls = [],
          scrollEl,
          scrollRootEl,
          scrolling = false,
          lastAutoScrollX,
          lastAutoScrollY,
          touchEvt$1,
          pointerElemChangedInterval;
        function AutoScrollPlugin() {
          function AutoScroll() {
            this.defaults = {
              scroll: true,
              forceAutoScrollFallback: false,
              scrollSensitivity: 30,
              scrollSpeed: 10,
              bubbleScroll: true
            };

            // Bind all private methods
            for (var fn in this) {
              if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
                this[fn] = this[fn].bind(this);
              }
            }
          }
          AutoScroll.prototype = {
            dragStarted: function dragStarted(_ref) {
              var originalEvent = _ref.originalEvent;
              if (this.sortable.nativeDraggable) {
                on(document, 'dragover', this._handleAutoScroll);
              } else {
                if (this.options.supportPointer) {
                  on(document, 'pointermove', this._handleFallbackAutoScroll);
                } else if (originalEvent.touches) {
                  on(document, 'touchmove', this._handleFallbackAutoScroll);
                } else {
                  on(document, 'mousemove', this._handleFallbackAutoScroll);
                }
              }
            },
            dragOverCompleted: function dragOverCompleted(_ref2) {
              var originalEvent = _ref2.originalEvent;
              // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
              if (!this.options.dragOverBubble && !originalEvent.rootEl) {
                this._handleAutoScroll(originalEvent);
              }
            },
            drop: function drop() {
              if (this.sortable.nativeDraggable) {
                off(document, 'dragover', this._handleAutoScroll);
              } else {
                off(document, 'pointermove', this._handleFallbackAutoScroll);
                off(document, 'touchmove', this._handleFallbackAutoScroll);
                off(document, 'mousemove', this._handleFallbackAutoScroll);
              }
              clearPointerElemChangedInterval();
              clearAutoScrolls();
              cancelThrottle();
            },
            nulling: function nulling() {
              touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
              autoScrolls.length = 0;
            },
            _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
              this._handleAutoScroll(evt, true);
            },
            _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
              var _this = this;
              var x = (evt.touches ? evt.touches[0] : evt).clientX,
                y = (evt.touches ? evt.touches[0] : evt).clientY,
                elem = document.elementFromPoint(x, y);
              touchEvt$1 = evt;

              // IE does not seem to have native autoscroll,
              // Edge's autoscroll seems too conditional,
              // MACOS Safari does not have autoscroll,
              // Firefox and Chrome are good
              if (fallback || this.options.forceAutoScrollFallback || Edge || IE11OrLess || Safari) {
                autoScroll(evt, this.options, elem, fallback);

                // Listener for pointer element change
                var ogElemScroller = getParentAutoScrollElement(elem, true);
                if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
                  pointerElemChangedInterval && clearPointerElemChangedInterval();
                  // Detect for pointer elem change, emulating native DnD behaviour
                  pointerElemChangedInterval = setInterval(function () {
                    var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);
                    if (newElem !== ogElemScroller) {
                      ogElemScroller = newElem;
                      clearAutoScrolls();
                    }
                    autoScroll(evt, _this.options, newElem, fallback);
                  }, 10);
                  lastAutoScrollX = x;
                  lastAutoScrollY = y;
                }
              } else {
                // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
                if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
                  clearAutoScrolls();
                  return;
                }
                autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
              }
            }
          };
          return _extends(AutoScroll, {
            pluginName: 'scroll',
            initializeByDefault: true
          });
        }
        function clearAutoScrolls() {
          autoScrolls.forEach(function (autoScroll) {
            clearInterval(autoScroll.pid);
          });
          autoScrolls = [];
        }
        function clearPointerElemChangedInterval() {
          clearInterval(pointerElemChangedInterval);
        }
        var autoScroll = throttle(function (evt, options, rootEl, isFallback) {
          // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
          if (!options.scroll) return;
          var x = (evt.touches ? evt.touches[0] : evt).clientX,
            y = (evt.touches ? evt.touches[0] : evt).clientY,
            sens = options.scrollSensitivity,
            speed = options.scrollSpeed,
            winScroller = getWindowScrollingElement();
          var scrollThisInstance = false,
            scrollCustomFn;

          // New scroll root, set scrollEl
          if (scrollRootEl !== rootEl) {
            scrollRootEl = rootEl;
            clearAutoScrolls();
            scrollEl = options.scroll;
            scrollCustomFn = options.scrollFn;
            if (scrollEl === true) {
              scrollEl = getParentAutoScrollElement(rootEl, true);
            }
          }
          var layersOut = 0;
          var currentParent = scrollEl;
          do {
            var el = currentParent,
              rect = getRect(el),
              top = rect.top,
              bottom = rect.bottom,
              left = rect.left,
              right = rect.right,
              width = rect.width,
              height = rect.height,
              canScrollX = void 0,
              canScrollY = void 0,
              scrollWidth = el.scrollWidth,
              scrollHeight = el.scrollHeight,
              elCSS = css(el),
              scrollPosX = el.scrollLeft,
              scrollPosY = el.scrollTop;
            if (el === winScroller) {
              canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
              canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
            } else {
              canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
              canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
            }
            var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
            var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
            if (!autoScrolls[layersOut]) {
              for (var i = 0; i <= layersOut; i++) {
                if (!autoScrolls[i]) {
                  autoScrolls[i] = {};
                }
              }
            }
            if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
              autoScrolls[layersOut].el = el;
              autoScrolls[layersOut].vx = vx;
              autoScrolls[layersOut].vy = vy;
              clearInterval(autoScrolls[layersOut].pid);
              if (vx != 0 || vy != 0) {
                scrollThisInstance = true;
                /* jshint loopfunc:true */
                autoScrolls[layersOut].pid = setInterval(function () {
                  // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
                  if (isFallback && this.layer === 0) {
                    Sortable.active._onTouchMove(touchEvt$1); // To move ghost if it is positioned absolutely
                  }
                  var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
                  var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;
                  if (typeof scrollCustomFn === 'function') {
                    if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== 'continue') {
                      return;
                    }
                  }
                  scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
                }.bind({
                  layer: layersOut
                }), 24);
              }
            }
            layersOut++;
          } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));
          scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
        }, 30);
        var drop = function drop(_ref) {
          var originalEvent = _ref.originalEvent,
            putSortable = _ref.putSortable,
            dragEl = _ref.dragEl,
            activeSortable = _ref.activeSortable,
            dispatchSortableEvent = _ref.dispatchSortableEvent,
            hideGhostForTarget = _ref.hideGhostForTarget,
            unhideGhostForTarget = _ref.unhideGhostForTarget;
          if (!originalEvent) return;
          var toSortable = putSortable || activeSortable;
          hideGhostForTarget();
          var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
          var target = document.elementFromPoint(touch.clientX, touch.clientY);
          unhideGhostForTarget();
          if (toSortable && !toSortable.el.contains(target)) {
            dispatchSortableEvent('spill');
            this.onSpill({
              dragEl: dragEl,
              putSortable: putSortable
            });
          }
        };
        function Revert() {}
        Revert.prototype = {
          startIndex: null,
          dragStart: function dragStart(_ref2) {
            var oldDraggableIndex = _ref2.oldDraggableIndex;
            this.startIndex = oldDraggableIndex;
          },
          onSpill: function onSpill(_ref3) {
            var dragEl = _ref3.dragEl,
              putSortable = _ref3.putSortable;
            this.sortable.captureAnimationState();
            if (putSortable) {
              putSortable.captureAnimationState();
            }
            var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);
            if (nextSibling) {
              this.sortable.el.insertBefore(dragEl, nextSibling);
            } else {
              this.sortable.el.appendChild(dragEl);
            }
            this.sortable.animateAll();
            if (putSortable) {
              putSortable.animateAll();
            }
          },
          drop: drop
        };
        _extends(Revert, {
          pluginName: 'revertOnSpill'
        });
        function Remove() {}
        Remove.prototype = {
          onSpill: function onSpill(_ref4) {
            var dragEl = _ref4.dragEl,
              putSortable = _ref4.putSortable;
            var parentSortable = putSortable || this.sortable;
            parentSortable.captureAnimationState();
            dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
            parentSortable.animateAll();
          },
          drop: drop
        };
        _extends(Remove, {
          pluginName: 'removeOnSpill'
        });
        var lastSwapEl;
        function SwapPlugin() {
          function Swap() {
            this.defaults = {
              swapClass: 'sortable-swap-highlight'
            };
          }
          Swap.prototype = {
            dragStart: function dragStart(_ref) {
              var dragEl = _ref.dragEl;
              lastSwapEl = dragEl;
            },
            dragOverValid: function dragOverValid(_ref2) {
              var completed = _ref2.completed,
                target = _ref2.target,
                onMove = _ref2.onMove,
                activeSortable = _ref2.activeSortable,
                changed = _ref2.changed,
                cancel = _ref2.cancel;
              if (!activeSortable.options.swap) return;
              var el = this.sortable.el,
                options = this.options;
              if (target && target !== el) {
                var prevSwapEl = lastSwapEl;
                if (onMove(target) !== false) {
                  toggleClass(target, options.swapClass, true);
                  lastSwapEl = target;
                } else {
                  lastSwapEl = null;
                }
                if (prevSwapEl && prevSwapEl !== lastSwapEl) {
                  toggleClass(prevSwapEl, options.swapClass, false);
                }
              }
              changed();
              completed(true);
              cancel();
            },
            drop: function drop(_ref3) {
              var activeSortable = _ref3.activeSortable,
                putSortable = _ref3.putSortable,
                dragEl = _ref3.dragEl;
              var toSortable = putSortable || this.sortable;
              var options = this.options;
              lastSwapEl && toggleClass(lastSwapEl, options.swapClass, false);
              if (lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
                if (dragEl !== lastSwapEl) {
                  toSortable.captureAnimationState();
                  if (toSortable !== activeSortable) activeSortable.captureAnimationState();
                  swapNodes(dragEl, lastSwapEl);
                  toSortable.animateAll();
                  if (toSortable !== activeSortable) activeSortable.animateAll();
                }
              }
            },
            nulling: function nulling() {
              lastSwapEl = null;
            }
          };
          return _extends(Swap, {
            pluginName: 'swap',
            eventProperties: function eventProperties() {
              return {
                swapItem: lastSwapEl
              };
            }
          });
        }
        function swapNodes(n1, n2) {
          var p1 = n1.parentNode,
            p2 = n2.parentNode,
            i1,
            i2;
          if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
          i1 = index(n1);
          i2 = index(n2);
          if (p1.isEqualNode(p2) && i1 < i2) {
            i2++;
          }
          p1.insertBefore(n2, p1.children[i1]);
          p2.insertBefore(n1, p2.children[i2]);
        }
        var multiDragElements = [],
          multiDragClones = [],
          lastMultiDragSelect,
          // for selection with modifier key down (SHIFT)
          multiDragSortable,
          initialFolding = false,
          // Initial multi-drag fold when drag started
          folding = false,
          // Folding any other time
          dragStarted = false,
          dragEl$1,
          clonesFromRect,
          clonesHidden;
        function MultiDragPlugin() {
          function MultiDrag(sortable) {
            // Bind all private methods
            for (var fn in this) {
              if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
                this[fn] = this[fn].bind(this);
              }
            }
            if (!sortable.options.avoidImplicitDeselect) {
              if (sortable.options.supportPointer) {
                on(document, 'pointerup', this._deselectMultiDrag);
              } else {
                on(document, 'mouseup', this._deselectMultiDrag);
                on(document, 'touchend', this._deselectMultiDrag);
              }
            }
            on(document, 'keydown', this._checkKeyDown);
            on(document, 'keyup', this._checkKeyUp);
            this.defaults = {
              selectedClass: 'sortable-selected',
              multiDragKey: null,
              avoidImplicitDeselect: false,
              setData: function setData(dataTransfer, dragEl) {
                var data = '';
                if (multiDragElements.length && multiDragSortable === sortable) {
                  multiDragElements.forEach(function (multiDragElement, i) {
                    data += (!i ? '' : ', ') + multiDragElement.textContent;
                  });
                } else {
                  data = dragEl.textContent;
                }
                dataTransfer.setData('Text', data);
              }
            };
          }
          MultiDrag.prototype = {
            multiDragKeyDown: false,
            isMultiDrag: false,
            delayStartGlobal: function delayStartGlobal(_ref) {
              var dragged = _ref.dragEl;
              dragEl$1 = dragged;
            },
            delayEnded: function delayEnded() {
              this.isMultiDrag = ~multiDragElements.indexOf(dragEl$1);
            },
            setupClone: function setupClone(_ref2) {
              var sortable = _ref2.sortable,
                cancel = _ref2.cancel;
              if (!this.isMultiDrag) return;
              for (var i = 0; i < multiDragElements.length; i++) {
                multiDragClones.push(clone(multiDragElements[i]));
                multiDragClones[i].sortableIndex = multiDragElements[i].sortableIndex;
                multiDragClones[i].draggable = false;
                multiDragClones[i].style['will-change'] = '';
                toggleClass(multiDragClones[i], this.options.selectedClass, false);
                multiDragElements[i] === dragEl$1 && toggleClass(multiDragClones[i], this.options.chosenClass, false);
              }
              sortable._hideClone();
              cancel();
            },
            clone: function clone(_ref3) {
              var sortable = _ref3.sortable,
                rootEl = _ref3.rootEl,
                dispatchSortableEvent = _ref3.dispatchSortableEvent,
                cancel = _ref3.cancel;
              if (!this.isMultiDrag) return;
              if (!this.options.removeCloneOnHide) {
                if (multiDragElements.length && multiDragSortable === sortable) {
                  insertMultiDragClones(true, rootEl);
                  dispatchSortableEvent('clone');
                  cancel();
                }
              }
            },
            showClone: function showClone(_ref4) {
              var cloneNowShown = _ref4.cloneNowShown,
                rootEl = _ref4.rootEl,
                cancel = _ref4.cancel;
              if (!this.isMultiDrag) return;
              insertMultiDragClones(false, rootEl);
              multiDragClones.forEach(function (clone) {
                css(clone, 'display', '');
              });
              cloneNowShown();
              clonesHidden = false;
              cancel();
            },
            hideClone: function hideClone(_ref5) {
              var _this = this;
              var sortable = _ref5.sortable,
                cloneNowHidden = _ref5.cloneNowHidden,
                cancel = _ref5.cancel;
              if (!this.isMultiDrag) return;
              multiDragClones.forEach(function (clone) {
                css(clone, 'display', 'none');
                if (_this.options.removeCloneOnHide && clone.parentNode) {
                  clone.parentNode.removeChild(clone);
                }
              });
              cloneNowHidden();
              clonesHidden = true;
              cancel();
            },
            dragStartGlobal: function dragStartGlobal(_ref6) {
              var sortable = _ref6.sortable;
              if (!this.isMultiDrag && multiDragSortable) {
                multiDragSortable.multiDrag._deselectMultiDrag();
              }
              multiDragElements.forEach(function (multiDragElement) {
                multiDragElement.sortableIndex = index(multiDragElement);
              });

              // Sort multi-drag elements
              multiDragElements = multiDragElements.sort(function (a, b) {
                return a.sortableIndex - b.sortableIndex;
              });
              dragStarted = true;
            },
            dragStarted: function dragStarted(_ref7) {
              var _this2 = this;
              var sortable = _ref7.sortable;
              if (!this.isMultiDrag) return;
              if (this.options.sort) {
                // Capture rects,
                // hide multi drag elements (by positioning them absolute),
                // set multi drag elements rects to dragRect,
                // show multi drag elements,
                // animate to rects,
                // unset rects & remove from DOM

                sortable.captureAnimationState();
                if (this.options.animation) {
                  multiDragElements.forEach(function (multiDragElement) {
                    if (multiDragElement === dragEl$1) return;
                    css(multiDragElement, 'position', 'absolute');
                  });
                  var dragRect = getRect(dragEl$1, false, true, true);
                  multiDragElements.forEach(function (multiDragElement) {
                    if (multiDragElement === dragEl$1) return;
                    setRect(multiDragElement, dragRect);
                  });
                  folding = true;
                  initialFolding = true;
                }
              }
              sortable.animateAll(function () {
                folding = false;
                initialFolding = false;
                if (_this2.options.animation) {
                  multiDragElements.forEach(function (multiDragElement) {
                    unsetRect(multiDragElement);
                  });
                }

                // Remove all auxiliary multidrag items from el, if sorting enabled
                if (_this2.options.sort) {
                  removeMultiDragElements();
                }
              });
            },
            dragOver: function dragOver(_ref8) {
              var target = _ref8.target,
                completed = _ref8.completed,
                cancel = _ref8.cancel;
              if (folding && ~multiDragElements.indexOf(target)) {
                completed(false);
                cancel();
              }
            },
            revert: function revert(_ref9) {
              var fromSortable = _ref9.fromSortable,
                rootEl = _ref9.rootEl,
                sortable = _ref9.sortable,
                dragRect = _ref9.dragRect;
              if (multiDragElements.length > 1) {
                // Setup unfold animation
                multiDragElements.forEach(function (multiDragElement) {
                  sortable.addAnimationState({
                    target: multiDragElement,
                    rect: folding ? getRect(multiDragElement) : dragRect
                  });
                  unsetRect(multiDragElement);
                  multiDragElement.fromRect = dragRect;
                  fromSortable.removeAnimationState(multiDragElement);
                });
                folding = false;
                insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
              }
            },
            dragOverCompleted: function dragOverCompleted(_ref10) {
              var sortable = _ref10.sortable,
                isOwner = _ref10.isOwner,
                insertion = _ref10.insertion,
                activeSortable = _ref10.activeSortable,
                parentEl = _ref10.parentEl,
                putSortable = _ref10.putSortable;
              var options = this.options;
              if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) {
                  activeSortable._hideClone();
                }
                initialFolding = false;
                // If leaving sort:false root, or already folding - Fold to new location
                if (options.animation && multiDragElements.length > 1 && (folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
                  // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
                  var dragRectAbsolute = getRect(dragEl$1, false, true, true);
                  multiDragElements.forEach(function (multiDragElement) {
                    if (multiDragElement === dragEl$1) return;
                    setRect(multiDragElement, dragRectAbsolute);

                    // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
                    // while folding, and so that we can capture them again because old sortable will no longer be fromSortable
                    parentEl.appendChild(multiDragElement);
                  });
                  folding = true;
                }

                // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out
                if (!isOwner) {
                  // Only remove if not folding (folding will remove them anyways)
                  if (!folding) {
                    removeMultiDragElements();
                  }
                  if (multiDragElements.length > 1) {
                    var clonesHiddenBefore = clonesHidden;
                    activeSortable._showClone(sortable);

                    // Unfold animation for clones if showing from hidden
                    if (activeSortable.options.animation && !clonesHidden && clonesHiddenBefore) {
                      multiDragClones.forEach(function (clone) {
                        activeSortable.addAnimationState({
                          target: clone,
                          rect: clonesFromRect
                        });
                        clone.fromRect = clonesFromRect;
                        clone.thisAnimationDuration = null;
                      });
                    }
                  } else {
                    activeSortable._showClone(sortable);
                  }
                }
              }
            },
            dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
              var dragRect = _ref11.dragRect,
                isOwner = _ref11.isOwner,
                activeSortable = _ref11.activeSortable;
              multiDragElements.forEach(function (multiDragElement) {
                multiDragElement.thisAnimationDuration = null;
              });
              if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
                clonesFromRect = _extends({}, dragRect);
                var dragMatrix = matrix(dragEl$1, true);
                clonesFromRect.top -= dragMatrix.f;
                clonesFromRect.left -= dragMatrix.e;
              }
            },
            dragOverAnimationComplete: function dragOverAnimationComplete() {
              if (folding) {
                folding = false;
                removeMultiDragElements();
              }
            },
            drop: function drop(_ref12) {
              var evt = _ref12.originalEvent,
                rootEl = _ref12.rootEl,
                parentEl = _ref12.parentEl,
                sortable = _ref12.sortable,
                dispatchSortableEvent = _ref12.dispatchSortableEvent,
                oldIndex = _ref12.oldIndex,
                putSortable = _ref12.putSortable;
              var toSortable = putSortable || this.sortable;
              if (!evt) return;
              var options = this.options,
                children = parentEl.children;

              // Multi-drag selection
              if (!dragStarted) {
                if (options.multiDragKey && !this.multiDragKeyDown) {
                  this._deselectMultiDrag();
                }
                toggleClass(dragEl$1, options.selectedClass, !~multiDragElements.indexOf(dragEl$1));
                if (!~multiDragElements.indexOf(dragEl$1)) {
                  multiDragElements.push(dragEl$1);
                  dispatchEvent({
                    sortable: sortable,
                    rootEl: rootEl,
                    name: 'select',
                    targetEl: dragEl$1,
                    originalEvent: evt
                  });

                  // Modifier activated, select from last to dragEl
                  if (evt.shiftKey && lastMultiDragSelect && sortable.el.contains(lastMultiDragSelect)) {
                    var lastIndex = index(lastMultiDragSelect),
                      currentIndex = index(dragEl$1);
                    if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
                      // Must include lastMultiDragSelect (select it), in case modified selection from no selection
                      // (but previous selection existed)
                      var n, i;
                      if (currentIndex > lastIndex) {
                        i = lastIndex;
                        n = currentIndex;
                      } else {
                        i = currentIndex;
                        n = lastIndex + 1;
                      }
                      for (; i < n; i++) {
                        if (~multiDragElements.indexOf(children[i])) continue;
                        toggleClass(children[i], options.selectedClass, true);
                        multiDragElements.push(children[i]);
                        dispatchEvent({
                          sortable: sortable,
                          rootEl: rootEl,
                          name: 'select',
                          targetEl: children[i],
                          originalEvent: evt
                        });
                      }
                    }
                  } else {
                    lastMultiDragSelect = dragEl$1;
                  }
                  multiDragSortable = toSortable;
                } else {
                  multiDragElements.splice(multiDragElements.indexOf(dragEl$1), 1);
                  lastMultiDragSelect = null;
                  dispatchEvent({
                    sortable: sortable,
                    rootEl: rootEl,
                    name: 'deselect',
                    targetEl: dragEl$1,
                    originalEvent: evt
                  });
                }
              }

              // Multi-drag drop
              if (dragStarted && this.isMultiDrag) {
                folding = false;
                // Do not "unfold" after around dragEl if reverted
                if ((parentEl[expando].options.sort || parentEl !== rootEl) && multiDragElements.length > 1) {
                  var dragRect = getRect(dragEl$1),
                    multiDragIndex = index(dragEl$1, ':not(.' + this.options.selectedClass + ')');
                  if (!initialFolding && options.animation) dragEl$1.thisAnimationDuration = null;
                  toSortable.captureAnimationState();
                  if (!initialFolding) {
                    if (options.animation) {
                      dragEl$1.fromRect = dragRect;
                      multiDragElements.forEach(function (multiDragElement) {
                        multiDragElement.thisAnimationDuration = null;
                        if (multiDragElement !== dragEl$1) {
                          var rect = folding ? getRect(multiDragElement) : dragRect;
                          multiDragElement.fromRect = rect;

                          // Prepare unfold animation
                          toSortable.addAnimationState({
                            target: multiDragElement,
                            rect: rect
                          });
                        }
                      });
                    }

                    // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
                    // properly they must all be removed
                    removeMultiDragElements();
                    multiDragElements.forEach(function (multiDragElement) {
                      if (children[multiDragIndex]) {
                        parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
                      } else {
                        parentEl.appendChild(multiDragElement);
                      }
                      multiDragIndex++;
                    });

                    // If initial folding is done, the elements may have changed position because they are now
                    // unfolding around dragEl, even though dragEl may not have his index changed, so update event
                    // must be fired here as Sortable will not.
                    if (oldIndex === index(dragEl$1)) {
                      var update = false;
                      multiDragElements.forEach(function (multiDragElement) {
                        if (multiDragElement.sortableIndex !== index(multiDragElement)) {
                          update = true;
                          return;
                        }
                      });
                      if (update) {
                        dispatchSortableEvent('update');
                        dispatchSortableEvent('sort');
                      }
                    }
                  }

                  // Must be done after capturing individual rects (scroll bar)
                  multiDragElements.forEach(function (multiDragElement) {
                    unsetRect(multiDragElement);
                  });
                  toSortable.animateAll();
                }
                multiDragSortable = toSortable;
              }

              // Remove clones if necessary
              if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
                multiDragClones.forEach(function (clone) {
                  clone.parentNode && clone.parentNode.removeChild(clone);
                });
              }
            },
            nullingGlobal: function nullingGlobal() {
              this.isMultiDrag = dragStarted = false;
              multiDragClones.length = 0;
            },
            destroyGlobal: function destroyGlobal() {
              this._deselectMultiDrag();
              off(document, 'pointerup', this._deselectMultiDrag);
              off(document, 'mouseup', this._deselectMultiDrag);
              off(document, 'touchend', this._deselectMultiDrag);
              off(document, 'keydown', this._checkKeyDown);
              off(document, 'keyup', this._checkKeyUp);
            },
            _deselectMultiDrag: function _deselectMultiDrag(evt) {
              if (typeof dragStarted !== "undefined" && dragStarted) return;

              // Only deselect if selection is in this sortable
              if (multiDragSortable !== this.sortable) return;

              // Only deselect if target is not item in this sortable
              if (evt && closest(evt.target, this.options.draggable, this.sortable.el, false)) return;

              // Only deselect if left click
              if (evt && evt.button !== 0) return;
              while (multiDragElements.length) {
                var el = multiDragElements[0];
                toggleClass(el, this.options.selectedClass, false);
                multiDragElements.shift();
                dispatchEvent({
                  sortable: this.sortable,
                  rootEl: this.sortable.el,
                  name: 'deselect',
                  targetEl: el,
                  originalEvent: evt
                });
              }
            },
            _checkKeyDown: function _checkKeyDown(evt) {
              if (evt.key === this.options.multiDragKey) {
                this.multiDragKeyDown = true;
              }
            },
            _checkKeyUp: function _checkKeyUp(evt) {
              if (evt.key === this.options.multiDragKey) {
                this.multiDragKeyDown = false;
              }
            }
          };
          return _extends(MultiDrag, {
            // Static methods & properties
            pluginName: 'multiDrag',
            utils: {
              /**
              * Selects the provided multi-drag item
              * @param  {HTMLElement} el    The element to be selected
              */
              select: function select(el) {
                var sortable = el.parentNode[expando];
                if (!sortable || !sortable.options.multiDrag || ~multiDragElements.indexOf(el)) return;
                if (multiDragSortable && multiDragSortable !== sortable) {
                  multiDragSortable.multiDrag._deselectMultiDrag();
                  multiDragSortable = sortable;
                }
                toggleClass(el, sortable.options.selectedClass, true);
                multiDragElements.push(el);
              },
              /**
              * Deselects the provided multi-drag item
              * @param  {HTMLElement} el    The element to be deselected
              */
              deselect: function deselect(el) {
                var sortable = el.parentNode[expando],
                  index = multiDragElements.indexOf(el);
                if (!sortable || !sortable.options.multiDrag || !~index) return;
                toggleClass(el, sortable.options.selectedClass, false);
                multiDragElements.splice(index, 1);
              }
            },
            eventProperties: function eventProperties() {
              var _this3 = this;
              var oldIndicies = [],
                newIndicies = [];
              multiDragElements.forEach(function (multiDragElement) {
                oldIndicies.push({
                  multiDragElement: multiDragElement,
                  index: multiDragElement.sortableIndex
                });

                // multiDragElements will already be sorted if folding
                var newIndex;
                if (folding && multiDragElement !== dragEl$1) {
                  newIndex = -1;
                } else if (folding) {
                  newIndex = index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
                } else {
                  newIndex = index(multiDragElement);
                }
                newIndicies.push({
                  multiDragElement: multiDragElement,
                  index: newIndex
                });
              });
              return {
                items: _toConsumableArray(multiDragElements),
                clones: [].concat(multiDragClones),
                oldIndicies: oldIndicies,
                newIndicies: newIndicies
              };
            },
            optionListeners: {
              multiDragKey: function multiDragKey(key) {
                key = key.toLowerCase();
                if (key === 'ctrl') {
                  key = 'Control';
                } else if (key.length > 1) {
                  key = key.charAt(0).toUpperCase() + key.substr(1);
                }
                return key;
              }
            }
          });
        }
        function insertMultiDragElements(clonesInserted, rootEl) {
          multiDragElements.forEach(function (multiDragElement, i) {
            var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];
            if (target) {
              rootEl.insertBefore(multiDragElement, target);
            } else {
              rootEl.appendChild(multiDragElement);
            }
          });
        }

        /**
        * Insert multi-drag clones
        * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
        * @param  {HTMLElement} rootEl
        */
        function insertMultiDragClones(elementsInserted, rootEl) {
          multiDragClones.forEach(function (clone, i) {
            var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];
            if (target) {
              rootEl.insertBefore(clone, target);
            } else {
              rootEl.appendChild(clone);
            }
          });
        }
        function removeMultiDragElements() {
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
          });
        }
        Sortable.mount(new AutoScrollPlugin());
        Sortable.mount(Remove, Revert);
        Sortable.mount(new SwapPlugin());
        Sortable.mount(new MultiDragPlugin());
        return Sortable;
      });
      /* harmony default export */
      var __WEBPACK_DEFAULT_EXPORT__ = Sortable;

      /***/
    },
    /***/"./js/vendor/ozz-wyg.js"
    /*!******************************!*\
      !*** ./js/vendor/ozz-wyg.js ***!
      \******************************/: function _js_vendor_ozzWygJs(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */"default": function _default() {
          return __WEBPACK_DEFAULT_EXPORT__;
        }
        /* harmony export */
      });
      /**
       * Ozz Wysiwyg Editor JS
       * The wysiwyg editor plugin for vanilla JS
       * 
       * Author: A.W.M. Shakir
       * Email: shakeerwahid@gmail.com
       */
      var OzzWyg = /*#__PURE__*/function () {
        function OzzWyg(options) {
          var _this9 = this;
          _classCallCheck(this, OzzWyg);
          this.options = _objectSpread(_objectSpread({}, OzzWyg.defaults), options);

          // Normalize selector: accept string, single DOM element, NodeList, or array of elements
          var editorElements = [];
          var selector = this.options.selector;
          if (typeof selector === 'string') {
            editorElements = document.querySelectorAll(selector);
          } else if (selector instanceof Element) {
            editorElements = [selector];
          } else if (selector instanceof NodeList || Array.isArray(selector)) {
            editorElements = selector;
          }
          this.editors = editorElements.length > 0 ? editorElements : false;

          // Tools
          this.tools = {
            'headings': {
              name: 'Headings',
              dom: '<div class="ozz-wyg__tool-headings-trigger"><button type="button">Headings</button><div class="ozz-wyg__tool-headings-setting"></div></div>',
              child: {
                'h1': {
                  name: 'Heading 1',
                  dom: '<button type="button" data-action="formatBlock" data-value="h1">Heading 1</button>'
                },
                'h2': {
                  name: 'Heading 2',
                  dom: '<button type="button" data-action="formatBlock" data-value="h2">Heading 2</button>'
                },
                'h3': {
                  name: 'Heading 3',
                  dom: '<button type="button" data-action="formatBlock" data-value="h3">Heading 3</button>'
                },
                'h4': {
                  name: 'Heading 4',
                  dom: '<button type="button" data-action="formatBlock" data-value="h4">Heading 4</button>'
                },
                'h5': {
                  name: 'Heading 5',
                  dom: '<button type="button" data-action="formatBlock" data-value="h5">Heading 5</button>'
                },
                'h6': {
                  name: 'Heading 6',
                  dom: '<button type="button" data-action="formatBlock" data-value="h6">Heading 6</button>'
                },
                'paragraph': {
                  name: 'Paragraph',
                  dom: '<button type="button" data-action="formatBlock" data-value="P">Normal Text</button>'
                },
                'quote': {
                  name: 'Quote',
                  dom: '<button type="button" data-action="quote">Quote</button>'
                },
                'code': {
                  name: 'Code',
                  dom: '<button type="button" data-action="code">Code</button>'
                }
              }
            },
            'bold': {
              name: 'Bold',
              dom: '<button type="button" data-action="bold">Bold</button>'
            },
            'italic': {
              name: 'Italic',
              dom: '<button type="button" data-action="italic">Italic</button>'
            },
            'underline': {
              name: 'Underline',
              dom: '<button type="button" data-action="underline">Underline</button>',
              child: {
                'strikethrough': {
                  name: 'Strikethrough',
                  dom: '<button type="button" data-action="strikethrough">Strikethrough</button>'
                },
                'subscript': {
                  name: 'Subscript',
                  dom: '<button type="button" data-action="subscript">Subscript</button>'
                },
                'superscript': {
                  name: 'Superscript',
                  dom: '<button type="button" data-action="superscript">Superscript</button>'
                }
              }
            },
            'link': {
              name: 'Link',
              dom: '<div class="ozz-wyg__tool-link-trigger"><button type="button" data-action="link">Link</button><div class="ozz-wyg__tool-link-setting"></div></div>'
            },
            'table': {
              name: 'Table',
              dom: '<div class="ozz-wyg__tool-table-trigger"><button type="button" data-action="table">Table</button><div class="ozz-wyg__tool-table-setting"></div></div>'
            },
            'ol': {
              name: 'Ordered List',
              dom: '<button type="button" data-action="insertOrderedList">Ordered List</button>'
            },
            'ul': {
              name: 'Un-ordered List',
              dom: '<button type="button" data-action="insertUnorderedList">Un-ordered List</button>'
            },
            'alignLeft': {
              name: 'Align Left',
              dom: '<button type="button" data-action="justifyLeft">Align Left</button>',
              child: {
                'alignRight': {
                  name: 'Align Right',
                  dom: '<button type="button" data-action="justifyRight">Align Right</button>'
                },
                'alignCenter': {
                  name: 'Align Center',
                  dom: '<button type="button" data-action="justifyCenter">Align Center</button>'
                },
                'justify': {
                  name: 'Justify',
                  dom: '<button type="button" data-action="justifyFull">Justify</button>'
                },
                'indentIncrease': {
                  name: 'Indent Increase',
                  dom: '<button type="button" data-action="indent">Indent Increase</button>'
                },
                'indentDecrease': {
                  name: 'Indent Decrease',
                  dom: '<button type="button" data-action="outdent">Indent Decrease</button>'
                }
              }
            },
            'media': {
              name: 'Media',
              dom: '<div class="ozz-wyg__tool-media-trigger"><button type="button" data-action="media">Media</button><div class="ozz-wyg__tool-media-setting"></div></div>'
            },
            'codeView': {
              name: 'Code View',
              dom: '<button type="button" data-action="codeView">Code View</button>'
            }
          };

          // Initiate Each Editors
          this.editorInstances = new Map();
          if (this.editors) {
            this.editors.forEach(function (editor) {
              var _ref1, _ref13;
              var editorID = "i-".concat(_this9.randomId());
              editor.setAttribute('data-editor', editorID);

              // Capture initial content before we overwrite the DOM
              var initialContent = (_ref1 = (_ref13 = typeof _this9.options.value === 'string' ? _this9.options.value : null) !== null && _ref13 !== void 0 ? _ref13 : editor.getAttribute('data-value')) !== null && _ref1 !== void 0 ? _ref1 : editor.innerHTML;
              var instance = {
                id: editorID,
                element: editor,
                playGround: null,
                ozzWygInstance: _this9,
                initialContent: initialContent
              };
              _this9.editorInstances.set(editorID, instance);
              _this9.currentEditorID = editorID;
              _this9.editor = editor;
              _this9.editorID = editorID;
              _this9.initEditor();
              instance.playGround = _this9.playGround;

              // Apply initial content if provided
              if (initialContent !== null && initialContent !== undefined && initialContent.trim() !== '') {
                _this9.setValue(initialContent, editorID);
              } else {
                // Initialize features for any existing content in playground
                setTimeout(function () {
                  // Ensure we're using the correct instance
                  var instancePlayGround = instance.playGround;
                  var instanceEditor = instance.element;
                  if (instancePlayGround) {
                    // Set context for initialization
                    var originalEditor = _this9.editor;
                    var originalPlayGround = _this9.playGround;
                    var originalEditorID = _this9.editorID;
                    _this9.editor = instanceEditor;
                    _this9.playGround = instancePlayGround;
                    _this9.editorID = instance.id;
                    _this9.currentEditorID = instance.id;
                    _this9.initializeContentFeatures();

                    // Restore original context
                    _this9.editor = originalEditor;
                    _this9.playGround = originalPlayGround;
                    _this9.editorID = originalEditorID;
                  }
                }, 0);
              }

              // Register instance in static registry
              OzzWyg.instances.set(editor, _this9);
              OzzWyg.instances.set(editorID, _this9);
            });
          }
        }

        /**
         * Set active editor context based on a child element (toolbar button / playground)
         * @param {HTMLElement} element
         * @returns {boolean} true if context updated
         */
        return _createClass(OzzWyg, [{
          key: "setActiveContextFromElement",
          value: function setActiveContextFromElement(element) {
            if (!element) return false;
            var editorEl = element.closest('.ozz-wyg');
            if (!editorEl) return false;
            var editorID = editorEl.getAttribute('data-editor');
            var instance = this.editorInstances.get(editorID);
            if (!instance) return false;
            this.editor = instance.element;
            this.playGround = instance.playGround;
            this.editorID = editorID;
            this.currentEditorID = editorID;
            return true;
          }

          /**
           * Initialize Wysiwyg Editor
           */
        }, {
          key: "initEditor",
          value: function initEditor() {
            var _this0 = this;
            this.editor.classList.add('ozz-wyg');
            this.editor.innerHTML = this.editorDOM();
            this.editor.querySelectorAll('button[data-action]').forEach(function (trigger) {
              trigger.addEventListener('click', function (e) {
                _this0.setActiveContextFromElement(e.target);
                _this0.fireAction(e);
              });
            });

            // Initialize child tool dropdowns
            this.editor.querySelectorAll('.ozz-wyg__tool-has-child').forEach(function (parent) {
              var trigger = parent.querySelector('.more-tools-trigger');
              var childMenu = parent.parentElement.querySelector('.ozz-wyg__tool-child');
              if (trigger && childMenu) {
                trigger.addEventListener('click', function (e) {
                  e.stopPropagation();
                  childMenu.classList.toggle('active');
                });
              }
            });

            // Close dropdowns when clicking outside
            document.addEventListener('click', function (e) {
              if (!e.target.closest('.ozz-wyg__tool-has-child')) {
                _this0.editor.querySelectorAll('.ozz-wyg__tool-child').forEach(function (menu) {
                  menu.classList.remove('active');
                });
              }
            });
            this.playGround = this.editor.querySelector('[data-editor-area]');

            // Initialize event listeners
            this.initEventListeners();
          }

          /**
           * Initialize all event listeners for the editor
           */
        }, {
          key: "initEventListeners",
          value: function initEventListeners() {
            var _this1 = this;
            // Input event - fires on content change
            this.playGround.addEventListener('input', function (e) {
              _this1.setActiveContextFromElement(_this1.playGround);
              _this1.handleInput(e);
            });

            // Focus event - when editor gains focus
            this.playGround.addEventListener('focus', function (e) {
              _this1.setActiveContextFromElement(_this1.playGround);
              _this1.emitEvent('focus', {
                editorID: _this1.editorID,
                event: e
              });
              _this1.editor.classList.add('ozz-wyg--focused');
            });

            // Blur event - when editor loses focus
            this.playGround.addEventListener('blur', function (e) {
              _this1.setActiveContextFromElement(_this1.playGround);
              _this1.emitEvent('blur', {
                editorID: _this1.editorID,
                event: e
              });
              _this1.editor.classList.remove('ozz-wyg--focused');
              _this1.emitEvent('change', {
                editorID: _this1.editorID,
                content: _this1.playGround.innerHTML,
                event: e
              });
            });

            // Paste event - clean pasted content
            this.playGround.addEventListener('paste', function (e) {
              _this1.setActiveContextFromElement(_this1.playGround);
              _this1.handlePaste(e);
            });

            // Keyboard shortcuts
            this.playGround.addEventListener('keydown', function (e) {
              _this1.setActiveContextFromElement(_this1.playGround);
              _this1.handleKeydown(e);
            });

            // Selection change - update toolbar states
            document.addEventListener('selectionchange', function () {
              var selection = window.getSelection();
              if (selection.rangeCount > 0) {
                var range = selection.getRangeAt(0);
                var commonAncestor = range.commonAncestorContainer;
                var node = commonAncestor.nodeType === 3 ? commonAncestor.parentElement : commonAncestor;
                if (node) {
                  if (_this1.setActiveContextFromElement(node) && _this1.playGround.contains(node)) {
                    _this1.updateToolbarStates();
                  }
                }
              }
            });

            // Click event - update toolbar states when clicking in editor
            this.playGround.addEventListener('click', function () {
              _this1.setActiveContextFromElement(_this1.playGround);
              setTimeout(function () {
                return _this1.updateToolbarStates();
              }, 10);
            });

            // Mouseup event - update toolbar states after selection
            this.playGround.addEventListener('mouseup', function () {
              _this1.setActiveContextFromElement(_this1.playGround);
              setTimeout(function () {
                return _this1.updateToolbarStates();
              }, 10);
            });

            // Keyup event - update toolbar states after keyboard actions
            this.playGround.addEventListener('keyup', function () {
              _this1.setActiveContextFromElement(_this1.playGround);
              setTimeout(function () {
                return _this1.updateToolbarStates();
              }, 10);
            });

            // Keydown event - update toolbar states for arrow keys and other navigation
            this.playGround.addEventListener('keydown', function (e) {
              if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) {
                _this1.setActiveContextFromElement(_this1.playGround);
                setTimeout(function () {
                  return _this1.updateToolbarStates();
                }, 10);
              }
            });
          }

          /**
           * Handle input event
           */
        }, {
          key: "handleInput",
          value: function handleInput(e) {
            // Modify tables
            var tables = this.playGround.querySelectorAll('table');
            tables.forEach(function (table) {
              // Wrap table
              if (!table.closest('.ozz-wyg-table-wrapper')) {
                var tableWrapped = document.createElement('div');
                tableWrapped.classList.add('ozz-wyg-table-wrapper');
                tableWrapped.innerHTML = table.outerHTML;
                table.outerHTML = tableWrapped.outerHTML;
              }

              // Clear inline styles
              table.removeAttribute('style');
              var tItems = table.querySelectorAll('tbody, thead, tfoot, tr, td, th');
              tItems.forEach(function (item) {
                item.removeAttribute('style');
              });
            });

            // Emit custom input event
            this.emitEvent('input', {
              editorID: this.editorID,
              content: this.playGround.innerHTML,
              event: e
            });
          }

          /**
           * Handle paste event - clean pasted content
           */
        }, {
          key: "handlePaste",
          value: function handlePaste(e) {
            e.preventDefault();

            // Get pasted content
            var clipboardData = e.clipboardData || window.clipboardData;
            var htmlData = clipboardData.getData('text/html');
            var textData = clipboardData.getData('text/plain');
            var pastedData = htmlData || textData;

            // Clean the pasted content
            var cleanedContent = this.cleanPastedContent(pastedData);
            try {
              // Insert cleaned content
              var selection = window.getSelection();
              if (selection.rangeCount > 0) {
                var range = selection.getRangeAt(0);

                // Ensure range is within this editor; otherwise collapse to end of playground
                var containerNode = range.commonAncestorContainer.nodeType === 3 ? range.commonAncestorContainer.parentElement : range.commonAncestorContainer;
                if (!containerNode || !this.playGround.contains(containerNode)) {
                  range.selectNodeContents(this.playGround);
                  range.collapse(false);
                }

                // Delete selected content
                range.deleteContents();

                // Insert cleaned content
                if (cleanedContent) {
                  if (htmlData && cleanedContent.includes('<')) {
                    // Treat as HTML: parse into a temp container and move children into a fragment
                    var tempDiv = document.createElement('div');
                    tempDiv.innerHTML = cleanedContent;
                    var fragment = document.createDocumentFragment();
                    while (tempDiv.firstChild) {
                      fragment.appendChild(tempDiv.firstChild);
                    }
                    range.insertNode(fragment);

                    // Move cursor to end of inserted content
                    var lastChild = this.playGround.lastChild;
                    if (lastChild) {
                      range.setStartAfter(lastChild);
                    }
                  } else {
                    // Plain text
                    var textNode = document.createTextNode(cleanedContent);
                    range.insertNode(textNode);
                    range.setStartAfter(textNode);
                  }
                  range.collapse(true);

                  // Update selection
                  selection.removeAllRanges();
                  selection.addRange(range);
                }
              } else {
                // No selection, insert at end of playground
                var _range = document.createRange();
                _range.selectNodeContents(this.playGround);
                _range.collapse(false);
                if (cleanedContent) {
                  if (htmlData && cleanedContent.includes('<')) {
                    var _tempDiv = document.createElement('div');
                    _tempDiv.innerHTML = cleanedContent;
                    var _fragment = document.createDocumentFragment();
                    while (_tempDiv.firstChild) {
                      _fragment.appendChild(_tempDiv.firstChild);
                    }
                    _range.insertNode(_fragment);
                  } else {
                    var _textNode = document.createTextNode(cleanedContent);
                    _range.insertNode(_textNode);
                  }
                }
              }
            } catch (err) {
              // Fallback: let the browser handle it if our manual insertion fails
              if (cleanedContent) {
                document.execCommand('insertHTML', false, cleanedContent);
              }
            }

            // Emit paste event
            this.emitEvent('paste', {
              editorID: this.editorID,
              originalContent: pastedData,
              cleanedContent: cleanedContent,
              event: e
            });

            // Trigger input event manually
            this.playGround.dispatchEvent(new Event('input', {
              bubbles: true
            }));
          }

          /**
           * Clean pasted content - remove unwanted styles and tags
           */
        }, {
          key: "cleanPastedContent",
          value: function cleanPastedContent(content) {
            // Create temporary div to parse HTML
            var tempDiv = document.createElement('div');
            tempDiv.innerHTML = content;

            // Remove unwanted attributes
            var unwantedAttributes = ['style', 'class', 'id', 'width', 'height', 'border'];
            var allElements = tempDiv.querySelectorAll('*');
            allElements.forEach(function (el) {
              unwantedAttributes.forEach(function (attr) {
                el.removeAttribute(attr);
              });
            });

            // Remove script and style tags
            var scripts = tempDiv.querySelectorAll('script, style');
            scripts.forEach(function (el) {
              return el.remove();
            });

            // Clean up empty elements
            var emptyElements = tempDiv.querySelectorAll('p:empty, div:empty, span:empty');
            emptyElements.forEach(function (el) {
              if (el.textContent.trim() === '') {
                el.remove();
              }
            });
            return tempDiv.innerHTML || tempDiv.textContent;
          }

          /**
           * Handle keyboard shortcuts
           */
        }, {
          key: "handleKeydown",
          value: function handleKeydown(e) {
            var _this10 = this;
            // Ctrl/Cmd + B - Bold
            if ((e.ctrlKey || e.metaKey) && e.key === 'b') {
              e.preventDefault();
              this.exeCMD('bold');
              this.updateToolbarStates();
              return;
            }

            // Ctrl/Cmd + I - Italic
            if ((e.ctrlKey || e.metaKey) && e.key === 'i') {
              e.preventDefault();
              this.exeCMD('italic');
              this.updateToolbarStates();
              return;
            }

            // Ctrl/Cmd + U - Underline
            if ((e.ctrlKey || e.metaKey) && e.key === 'u') {
              e.preventDefault();
              this.exeCMD('underline');
              this.updateToolbarStates();
              return;
            }

            // Ctrl/Cmd + K - Link
            if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
              e.preventDefault();
              var linkBtn = this.editor.querySelector('button[data-action="link"]');
              if (linkBtn) linkBtn.click();
              return;
            }

            // Ctrl/Cmd + Z - Undo
            if ((e.ctrlKey || e.metaKey) && e.key === 'z' && !e.shiftKey) {
              // Allow default undo behavior
              setTimeout(function () {
                return _this10.updateToolbarStates();
              }, 10);
              return;
            }

            // Ctrl/Cmd + Shift + Z or Ctrl/Cmd + Y - Redo
            if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'z' || (e.ctrlKey || e.metaKey) && e.key === 'y') {
              // Allow default redo behavior
              setTimeout(function () {
                return _this10.updateToolbarStates();
              }, 10);
              return;
            }

            // Emit keydown event
            this.emitEvent('keydown', {
              editorID: this.editorID,
              key: e.key,
              ctrlKey: e.ctrlKey,
              metaKey: e.metaKey,
              shiftKey: e.shiftKey,
              event: e
            });
          }

          /**
           * Update toolbar button states based on current selection
           */
        }, {
          key: "updateToolbarStates",
          value: function updateToolbarStates() {
            var selection = window.getSelection();
            if (!selection.rangeCount) {
              // Clear all active states if no selection
              this.clearAllToolbarStates();
              return;
            }
            var range = selection.getRangeAt(0);
            var commonAncestor = range.commonAncestorContainer;

            // Check if selection is within this editor
            var node = commonAncestor.nodeType === 3 ? commonAncestor.parentElement : commonAncestor;
            if (!node || !this.playGround.contains(node)) {
              this.clearAllToolbarStates();
              return;
            }

            // Store current focus to restore later
            var wasFocused = document.activeElement === this.playGround;

            // Temporarily focus playground for queryCommandState to work correctly
            if (!wasFocused) {
              this.playGround.focus();
            }

            // Update bold button
            var boldBtn = this.editor.querySelector('button[data-action="bold"]');
            if (boldBtn) {
              try {
                var isBold = document.queryCommandState('bold');
                boldBtn.classList.toggle('active', isBold);
              } catch (e) {
                // Fallback: check if parent is strong or b tag
                var parent = this.getParentTag(range, ['strong', 'b']);
                boldBtn.classList.toggle('active', !!parent);
              }
            }

            // Update italic button
            var italicBtn = this.editor.querySelector('button[data-action="italic"]');
            if (italicBtn) {
              try {
                var isItalic = document.queryCommandState('italic');
                italicBtn.classList.toggle('active', isItalic);
              } catch (e) {
                var _parent = this.getParentTag(range, ['em', 'i']);
                italicBtn.classList.toggle('active', !!_parent);
              }
            }

            // Update underline button
            var underlineBtn = this.editor.querySelector('button[data-action="underline"]');
            if (underlineBtn) {
              try {
                var isUnderline = document.queryCommandState('underline');
                underlineBtn.classList.toggle('active', isUnderline);
              } catch (e) {
                var _parent2 = this.getParentTag(range, ['u']);
                underlineBtn.classList.toggle('active', !!_parent2);
              }
            }

            // Update strikethrough button
            var strikeBtn = this.editor.querySelector('button[data-action="strikethrough"]');
            if (strikeBtn) {
              try {
                var isStrike = document.queryCommandState('strikethrough');
                strikeBtn.classList.toggle('active', isStrike);
              } catch (e) {
                var _parent3 = this.getParentTag(range, ['s', 'strike', 'del']);
                strikeBtn.classList.toggle('active', !!_parent3);
              }
            }

            // Update subscript button
            var subBtn = this.editor.querySelector('button[data-action="subscript"]');
            if (subBtn) {
              try {
                var isSub = document.queryCommandState('subscript');
                subBtn.classList.toggle('active', isSub);
              } catch (e) {
                var _parent4 = this.getParentTag(range, ['sub']);
                subBtn.classList.toggle('active', !!_parent4);
              }
            }

            // Update superscript button
            var supBtn = this.editor.querySelector('button[data-action="superscript"]');
            if (supBtn) {
              try {
                var isSup = document.queryCommandState('superscript');
                supBtn.classList.toggle('active', isSup);
              } catch (e) {
                var _parent5 = this.getParentTag(range, ['sup']);
                supBtn.classList.toggle('active', !!_parent5);
              }
            }

            // Update format block (headings, paragraph)
            this.updateFormatBlockState(range);

            // Update list buttons
            var olBtn = this.editor.querySelector('button[data-action="insertOrderedList"]');
            if (olBtn) {
              try {
                var isOL = document.queryCommandState('insertOrderedList');
                olBtn.classList.toggle('active', isOL);
              } catch (e) {
                var _parent6 = this.getParentTag(range, ['ol']);
                olBtn.classList.toggle('active', !!_parent6);
              }
            }
            var ulBtn = this.editor.querySelector('button[data-action="insertUnorderedList"]');
            if (ulBtn) {
              try {
                var isUL = document.queryCommandState('insertUnorderedList');
                ulBtn.classList.toggle('active', isUL);
              } catch (e) {
                var _parent7 = this.getParentTag(range, ['ul']);
                ulBtn.classList.toggle('active', !!_parent7);
              }
            }

            // Update alignment buttons
            var alignLeftBtn = this.editor.querySelector('button[data-action="justifyLeft"]');
            if (alignLeftBtn) {
              try {
                var isLeft = document.queryCommandState('justifyLeft');
                alignLeftBtn.classList.toggle('active', isLeft);
              } catch (e) {
                alignLeftBtn.classList.remove('active');
              }
            }
            var alignCenterBtn = this.editor.querySelector('button[data-action="justifyCenter"]');
            if (alignCenterBtn) {
              try {
                var isCenter = document.queryCommandState('justifyCenter');
                alignCenterBtn.classList.toggle('active', isCenter);
              } catch (e) {
                alignCenterBtn.classList.remove('active');
              }
            }
            var alignRightBtn = this.editor.querySelector('button[data-action="justifyRight"]');
            if (alignRightBtn) {
              try {
                var isRight = document.queryCommandState('justifyRight');
                alignRightBtn.classList.toggle('active', isRight);
              } catch (e) {
                alignRightBtn.classList.remove('active');
              }
            }
            var justifyBtn = this.editor.querySelector('button[data-action="justifyFull"]');
            if (justifyBtn) {
              try {
                var isJustify = document.queryCommandState('justifyFull');
                justifyBtn.classList.toggle('active', isJustify);
              } catch (e) {
                justifyBtn.classList.remove('active');
              }
            }
          }

          /**
           * Get parent element with specific tag names
           */
        }, {
          key: "getParentTag",
          value: function getParentTag(range, tagNames) {
            var node = range.commonAncestorContainer;
            if (node.nodeType === 3) {
              node = node.parentElement;
            }
            while (node && node !== this.playGround) {
              if (node.nodeType === 1 && tagNames.includes(node.tagName.toLowerCase())) {
                return node;
              }
              node = node.parentElement;
            }
            return null;
          }

          /**
           * Update format block state (headings, paragraph)
           */
        }, {
          key: "updateFormatBlockState",
          value: function updateFormatBlockState(range) {
            var node = range.commonAncestorContainer;
            if (node.nodeType === 3) {
              node = node.parentElement;
            }

            // Find the block-level element
            var blockTag = null;
            while (node && node !== this.playGround) {
              if (node.nodeType === 1) {
                var tagName = node.tagName.toLowerCase();
                if (['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'blockquote', 'pre', 'code', 'div'].includes(tagName)) {
                  blockTag = tagName;
                  break;
                }
              }
              node = node.parentElement;
            }

            // Update heading/format buttons
            var headingBtns = this.editor.querySelectorAll('button[data-action="formatBlock"]');
            headingBtns.forEach(function (btn) {
              var value = btn.getAttribute('data-value');
              if (value) {
                var valueLower = value.toLowerCase();
                // Handle paragraph - can be 'p' or 'P'
                if (valueLower === 'p' && (blockTag === 'p' || blockTag === 'div' || !blockTag)) {
                  btn.classList.toggle('active', true);
                } else if (valueLower === blockTag) {
                  btn.classList.toggle('active', true);
                } else {
                  btn.classList.remove('active');
                }
              }
            });
          }

          /**
           * Clear all toolbar button active states
           */
        }, {
          key: "clearAllToolbarStates",
          value: function clearAllToolbarStates() {
            var allButtons = this.editor.querySelectorAll('button[data-action]');
            allButtons.forEach(function (btn) {
              return btn.classList.remove('active');
            });
          }

          /**
           * Emit custom event
           */
        }, {
          key: "emitEvent",
          value: function emitEvent(eventName) {
            var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var event = new CustomEvent("ozzwyg:".concat(eventName), {
              detail: _objectSpread({
                editorID: this.editorID,
                editor: this.editor,
                playGround: this.playGround
              }, data),
              bubbles: true,
              cancelable: true
            });

            // Dispatch on both the editor element and the playground
            this.editor.dispatchEvent(event);
            this.playGround.dispatchEvent(event);
          }

          /**
           * Setup Editor DOM
           * @returns {*} EditorDOM
           */
        }, {
          key: "editorDOM",
          value: function editorDOM() {
            var _this11 = this;
            var toolsDOM = '';
            this.options.tools.forEach(function (tool) {
              if (_this11.tools[tool]) {
                var parentTool = document.createElement('div');
                parentTool.classList.add('ozz-wyg__tool', "ozz-wyg__tool--".concat(tool));
                if (_this11.tools[tool].child) {
                  parentTool.innerHTML = "<div class=\"ozz-wyg__tool-has-child\">".concat(_this11.tools[tool].dom, "<span class=\"more-tools-trigger\"></span></div>");
                  // Get Child tools
                  var childElementWrapper = document.createElement('div');
                  childElementWrapper.classList.add('ozz-wyg__tool-child');
                  _this11.options.tools.forEach(function (child2) {
                    if (_this11.tools[tool].child[child2]) {
                      var childItem = _this11.tools[tool].child[child2];
                      childElementWrapper.innerHTML += childItem.dom;
                    }
                  });
                  parentTool.appendChild(childElementWrapper);
                } else {
                  parentTool.innerHTML = _this11.tools[tool].dom;
                }
                toolsDOM += parentTool.outerHTML;
              }
            });
            this.toolbar = "<div class=\"ozz-wyg__toolbar\">".concat(toolsDOM, "</div>");
            this.editableArea = "<div class=\"ozz-wyg__editor-area\" data-editor-area contenteditable=\"true\"></div>";
            return this.toolbar + this.editableArea;
          }

          /**
           * Check if HTML view enabled
           * @returns {boolean}
           */
        }, {
          key: "isHTML",
          value: function isHTML() {
            return this.playGround.classList.contains('ozz-wyg-html-view');
          }

          /**
           * Utility - Find nested object item
           * @param {*} obj 
           * @param {*} key 
           * @returns 
           */
        }, {
          key: "findObject",
          value: function findObject(obj, key) {
            if (obj.hasOwnProperty(key)) {
              return obj[key];
            } else {
              for (var prop in obj) {
                if (obj[prop] !== null && _typeof2(obj[prop]) === 'object') {
                  var result = this.findObject(obj[prop], key);
                  if (result) {
                    return result;
                  }
                }
              }
            }
            return null;
          }

          /**
           * Random ID
           */
        }, {
          key: "randomId",
          value: function randomId() {
            var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 6;
            return Math.random().toString(36).substring(2, length + 2);
          }

          /**
           * Fire Action
           * @param {*} event
           */
        }, {
          key: "fireAction",
          value: function fireAction(event) {
            var _this12 = this;
            var action = event.target.getAttribute('data-action');

            // Format block
            var value = action == 'formatBlock' ? event.target.getAttribute('data-value') : null;
            if (action == 'link') {
              // Link
              this.linkPopUp(event);
            } else if (action == 'table') {
              // Create Table
              this.tablePopUp(event);
            } else if (action == 'media') {
              // insert Media
              this.mediaPopUp(event);
            } else if (action == 'quote') {
              this.quoteText();
            } else if (action == 'code') {
              this.codeText();
            } else if (action == 'codeView') {
              this.toggleCodeView();
            } else {
              this.exeCMD(action, value);
            }

            // Update toolbar states after action
            setTimeout(function () {
              return _this12.updateToolbarStates();
            }, 10);
          }

          /**
           * Link Tool Popup
           */
        }, {
          key: "linkPopUp",
          value: function linkPopUp(ev) {
            var _this13 = this;
            var linkCls = 'ozz-wyg__tool-link-',
              parent = ev.target.closest(".".concat(linkCls, "trigger"));
            if (!parent) return;
            var settingsDOM = parent.querySelector(".".concat(linkCls, "setting"));
            if (!settingsDOM) return;
            var selection = window.getSelection();

            // Store selection
            var sRange = false;
            var selectionStr = selection.toString();
            if (selection.getRangeAt && selection.rangeCount) {
              sRange = selection.getRangeAt(0).cloneRange();
            }

            // Check if there's an existing anchor link
            var existingAnchor = null;
            if (selection.anchorNode) {
              var _parent8 = selection.anchorNode.parentElement;
              if (_parent8 && _parent8.tagName === 'A') {
                existingAnchor = _parent8;
              } else if (_parent8 && _parent8.closest('a')) {
                existingAnchor = _parent8.closest('a');
              }
            }
            var existingURL = existingAnchor ? existingAnchor.href : '';
            var existingTarget = existingAnchor ? existingAnchor.target : '';
            settingsDOM.innerHTML = "\n      <label>URL:</label> <input type=\"text\" id=\"url-".concat(this.editorID, "\" value=\"").concat(existingURL, "\"><br>\n      <label>Target:</label> <input type=\"text\" id=\"target-").concat(this.editorID, "\" value=\"").concat(existingTarget ? existingTarget : '_blank', "\"><br>\n      <button type=\"button\" class=\"ozz-wyg-regular-btn\" id=\"insertLinkTrigger-").concat(this.editorID, "\">").concat(existingAnchor ? 'Update' : 'Insert', "</button>");
            settingsDOM.classList.toggle('active');

            // Insert or update link
            var insertLinkTrigger = settingsDOM.querySelector('#insertLinkTrigger-' + this.editorID);
            insertLinkTrigger.addEventListener('click', function () {
              var urlInput = settingsDOM.querySelector('#url-' + _this13.editorID).value;
              var targetInput = settingsDOM.querySelector('#target-' + _this13.editorID).value;
              if (urlInput && targetInput) {
                if (existingAnchor) {
                  // Update existing anchor
                  existingAnchor.href = urlInput;
                  existingAnchor.target = targetInput;
                } else {
                  // Create new anchor
                  var anchor = document.createElement('a');
                  anchor.href = urlInput;
                  anchor.target = targetInput;
                  anchor.textContent = selectionStr || urlInput;
                  if (sRange) {
                    selection.removeAllRanges();
                    selection.addRange(sRange);
                  }
                  document.execCommand('insertHTML', false, anchor.outerHTML);
                }
                settingsDOM.classList.remove('active'); // Close Popup
                _this13.linkPopOver(); // Init Link Popover
              }
            });

            // Close popup
            document.addEventListener('click', function (e) {
              if (!parent.contains(e.target)) {
                settingsDOM.classList.remove('active');
                _this13.linkPopOver(); // Init Link Popover
              }
            });
          }

          /**
           * Link popover
           */
        }, {
          key: "linkPopOver",
          value: function linkPopOver() {
            var _this14 = this;
            this.playGround.querySelectorAll('a').forEach(function (anchor) {
              // Only add listeners if not already added
              if (anchor.hasAttribute('data-link-handled')) {
                return;
              }
              anchor.setAttribute('data-link-handled', 'true');
              anchor.addEventListener('click', function (e) {
                if (anchor.getAttribute('role') !== 'popover') {
                  e.preventDefault();
                  e.stopPropagation();
                  var popoverDOM = document.createElement('span');
                  popoverDOM.setAttribute('contenteditable', false);
                  popoverDOM.classList.add('ozz-wyg-popover');
                  popoverDOM.innerHTML = "\n          <a href=\"".concat(anchor.href, "\" role=\"popover\" target=\"_blank\">").concat(anchor.href, "</a>\n          <button type=\"button\" class=\"ozz-wyg-editlink\"></button>\n          <button type=\"button\" class=\"ozz-wyg-unlink\"></button>");
                  if (_this14.editor.querySelectorAll('.ozz-wyg-popover').length === 0) {
                    anchor.insertAdjacentElement('afterend', popoverDOM);

                    // Position popover element
                    var _2 = 0,
                      rx = _2.rx,
                      ry = _2.ry;
                    if (popoverDOM.closest('.ozz-wyg-table-wrapper')) {
                      var cTbl = popoverDOM.closest('.ozz-wyg-table-wrapper');
                      ry = cTbl.getBoundingClientRect().y;
                      rx = cTbl.getBoundingClientRect().x;
                    }
                    popoverDOM.style.top = "".concat(e.clientY - ry, "px");
                    popoverDOM.style.left = "".concat(e.clientX - rx, "px");
                  }
                  var _removePopoverEv = function removePopoverEv(ev) {
                    if (!anchor.contains(ev.target) && !popoverDOM.contains(ev.target)) {
                      popoverDOM.remove();
                      document.removeEventListener('click', _removePopoverEv);
                    }
                  };
                  document.addEventListener('click', _removePopoverEv);

                  // Unlink
                  popoverDOM.querySelector('.ozz-wyg-unlink').addEventListener('click', function (ev) {
                    ev.stopPropagation();
                    var textNode = document.createTextNode(anchor.textContent);
                    anchor.parentNode.replaceChild(textNode, anchor);
                    popoverDOM.remove();
                    document.removeEventListener('click', _removePopoverEv);
                  });

                  // Edit this link
                  popoverDOM.querySelector('.ozz-wyg-editlink').addEventListener('click', function () {
                    var linkBtn = _this14.editor.querySelector('button[data-action="link"]');
                    setTimeout(function () {
                      linkBtn.click();
                    }, 1);
                  });
                }
              });
            });
          }

          /**
           * Table Popup
           */
        }, {
          key: "tablePopUp",
          value: function tablePopUp(ev) {
            var _this15 = this;
            var tableCls = 'ozz-wyg__tool-table-',
              parent = ev.target.closest(".".concat(tableCls, "trigger"));
            if (!parent) return;
            var settingsDOM = parent.querySelector(".".concat(tableCls, "setting"));
            if (!settingsDOM) return;
            var selection = window.getSelection();

            // Store selection
            var sRange = false;
            if (selection.getRangeAt && selection.rangeCount) {
              sRange = selection.getRangeAt(0).cloneRange();
            }
            settingsDOM.innerHTML = "\n      <input type=\"number\" min=\"1\" max=\"100\" value=\"2\" placeholder=\"X\" id=\"row-".concat(this.editorID, "\">\n      <input type=\"number\" min=\"1\" max=\"100\" value=\"2\" placeholder=\"Y\" id=\"column-").concat(this.editorID, "\">\n      <span class=\"sub-options\">\n        <span>\n          <input type=\"checkbox\" id=\"has-th-").concat(this.editorID, "\">\n          <label for=\"has-th-").concat(this.editorID, "\">No Header</label>\n        </span>\n        <span>\n          <input type=\"checkbox\" id=\"has-footer-").concat(this.editorID, "\">\n          <label for=\"has-footer-").concat(this.editorID, "\">No Footer</label>\n        </span>\n      </span>\n      <button type=\"button\" class=\"ozz-wyg-regular-btn\" id=\"insertTableTrigger-").concat(this.editorID, "\">Insert</button>");
            settingsDOM.classList.toggle('active');

            // Insert or update Table
            var insertTableTrigger = settingsDOM.querySelector('#insertTableTrigger-' + this.editorID);
            insertTableTrigger.addEventListener('click', function () {
              var rows = settingsDOM.querySelector('#row-' + _this15.editorID).value,
                columns = settingsDOM.querySelector('#column-' + _this15.editorID).value,
                noHead = settingsDOM.querySelector('#has-th-' + _this15.editorID).checked,
                noFooter = settingsDOM.querySelector('#has-footer-' + _this15.editorID).checked;
              rows = rows > 100 ? 100 : rows;
              columns = columns > 100 ? 100 : columns;

              // Create Table
              var table = document.createElement('table');
              // Table Head
              if (noHead === false) {
                var tHead = table.createTHead();
                var headerRow = tHead.insertRow();
                for (var i = 0; i < columns; i++) {
                  var th = document.createElement('th');
                  headerRow.appendChild(th);
                }
              }

              // Table Body
              var tBody = table.createTBody();
              for (var _i = 0; _i < rows; _i++) {
                var tRows = tBody.insertRow(_i);
                for (var j = 0; j < columns; j++) {
                  tRows.insertCell(j);
                }
              }

              // Table Footer
              if (noFooter === false) {
                var tFoot = table.createTFoot();
                var footRow = tFoot.insertRow();
                for (var _i2 = 0; _i2 < columns; _i2++) {
                  footRow.insertCell(_i2);
                }
              }

              // Set Range Again
              if (sRange) {
                selection.removeAllRanges();
                selection.addRange(sRange);
              }

              // Create Table Wrapper
              var $table = document.createElement('div');
              $table.classList.add('ozz-wyg-table-wrapper');
              $table.innerHTML = table.outerHTML;
              document.execCommand('insertHTML', false, "<br>".concat($table.outerHTML, "<br>"));
              _this15.tableActions(); // Table Actions
            });

            // Close popup
            document.addEventListener('click', function (e) {
              if (!parent.contains(e.target)) {
                settingsDOM.classList.remove('active');
              }
            });
          }

          /**
           * Table actions
           */
        }, {
          key: "tableActions",
          value: function tableActions() {
            var _this16 = this;
            var $table = this.playGround.querySelectorAll('.ozz-wyg-table-wrapper');
            $table.forEach(function (tbl) {
              // Only add listeners if not already added
              if (tbl.hasAttribute('data-table-handled')) {
                return;
              }
              tbl.setAttribute('data-table-handled', 'true');
              tbl.addEventListener('mouseover', function () {
                var tblTools = tbl.querySelectorAll('.ozz-wyg-table-actions');
                if (tblTools.length === 0) {
                  var actions = document.createElement('div');
                  actions.setAttribute('contenteditable', false);
                  actions.classList.add('ozz-wyg-table-actions');
                  actions.innerHTML = "\n          <span class=\"ozz-wyg-table-actions__row\">\n            <button type=\"button\" title=\"Add Row\" data-tbl-action=\"addrow\">Add Row</button>\n            <button type=\"button\" title=\"Remove Row\" data-tbl-action=\"deleterow\">Delete Row</button>\n          </span>\n          <span class=\"ozz-wyg-table-actions__column\">\n            <button type=\"button\" title=\"Add Column\" data-tbl-action=\"addcol\">Add Column</button>\n            <button type=\"button\" title=\"Remove Column\" data-tbl-action=\"deletecol\">Delete Column</button>\n          </span>";

                  // Perform Table Actions
                  actions.querySelectorAll('button').forEach(function (btn) {
                    btn.addEventListener('click', function (e) {
                      e.preventDefault();
                      e.stopPropagation();
                      var action = e.target.getAttribute('data-tbl-action');
                      switch (action) {
                        case 'addrow':
                          _this16.addTableRow(tbl);
                          break;
                        case 'deleterow':
                          _this16.deleteTableRow(tbl);
                          break;
                        case 'addcol':
                          _this16.addTableCol(tbl);
                          break;
                        case 'deletecol':
                          _this16.deleteTableCol(tbl);
                          break;
                        default:
                          break;
                      }
                    });
                  });
                  tbl.appendChild(actions);
                }
              });
              tbl.addEventListener('mouseleave', function () {
                var tblTools = tbl.querySelectorAll('.ozz-wyg-table-actions');
                if (tblTools.length > 0) {
                  tblTools[0].remove();
                }
              });
            });
          }

          /**
           * Add Table Row
           * @param table_wrap
           */
        }, {
          key: "addTableRow",
          value: function addTableRow(table_wrap) {
            if (!table_wrap) return;
            var tbody = table_wrap.querySelector('tbody');
            if (tbody) {
              var firstRow = tbody.querySelector('tr');
              var cellsCount = firstRow ? firstRow.querySelectorAll('td, th').length : 1;
              var newRow = tbody.insertRow(-1);
              for (var i = 0; i < cellsCount; i++) {
                var td = document.createElement('td');
                td.innerHTML = '<br>';
                newRow.appendChild(td);
              }
            }
          }

          /**
           * Delete Table Row
           * @param table_wrap
           */
        }, {
          key: "deleteTableRow",
          value: function deleteTableRow(table_wrap) {
            if (!table_wrap) return;
            var table = table_wrap.querySelector('table');
            if (!table) return;
            var tbody = table.querySelector('tbody');
            if (tbody && tbody.rows.length > 1) {
              tbody.deleteRow(-1);
            }
          }

          /**
           * Add Table Column
           * @param table_wrap
           */
        }, {
          key: "addTableCol",
          value: function addTableCol(table_wrap) {
            if (!table_wrap) return;
            var thead = table_wrap.querySelector('thead');
            var tbody = table_wrap.querySelector('tbody');
            var tfoot = table_wrap.querySelector('tfoot');
            var addCellToRows = function addCellToRows(rows, newCellIndex) {
              var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'td';
              if (!rows || rows.length === 0) return;
              rows.forEach(function (row) {
                var td = document.createElement(type);
                td.innerHTML = '<br>';
                if (newCellIndex < row.cells.length) {
                  row.insertBefore(td, row.cells[newCellIndex]);
                } else {
                  row.appendChild(td);
                }
              });
            };
            if (thead) {
              var headerRows = thead.querySelectorAll('tr');
              if (headerRows.length > 0) {
                var firstRow = headerRows[0];
                var newCellIndex = firstRow ? firstRow.querySelectorAll('th, td').length : 0;
                addCellToRows(headerRows, newCellIndex, 'th');
              }
            }
            if (tbody) {
              var bodyRows = tbody.querySelectorAll('tr');
              if (bodyRows.length > 0) {
                var _firstRow = bodyRows[0];
                var _newCellIndex = _firstRow ? _firstRow.querySelectorAll('td').length : 0;
                addCellToRows(bodyRows, _newCellIndex);
              }
            }
            if (tfoot) {
              var footerRows = tfoot.querySelectorAll('tr');
              if (footerRows.length > 0) {
                var _firstRow2 = footerRows[0];
                var _newCellIndex2 = _firstRow2 ? _firstRow2.querySelectorAll('td').length : 0;
                addCellToRows(footerRows, _newCellIndex2);
              }
            }
          }

          /**
           * Delete Table Column
           * @param table_wrap
           */
        }, {
          key: "deleteTableCol",
          value: function deleteTableCol(table_wrap) {
            if (!table_wrap) return;
            var thead = table_wrap.querySelector('thead');
            var tbody = table_wrap.querySelector('tbody');
            var tfoot = table_wrap.querySelector('tfoot');
            var deleteLastCell = function deleteLastCell(rows) {
              if (!rows || rows.length === 0) return;
              var firstRow = rows[0];
              if (!firstRow) return;
              var lastCellIndex = firstRow.cells.length - 1;
              if (lastCellIndex >= 0) {
                rows.forEach(function (row) {
                  if (row.cells.length > 1) {
                    row.deleteCell(lastCellIndex);
                  }
                });
              }
            };
            if (thead) {
              deleteLastCell(thead.querySelectorAll('tr'));
            }
            if (tbody) {
              deleteLastCell(tbody.querySelectorAll('tr'));
            }
            if (tfoot) {
              deleteLastCell(tfoot.querySelectorAll('tr'));
            }
          }

          /**
           * Insert Media
           */
        }, {
          key: "mediaPopUp",
          value: function mediaPopUp(ev) {
            var _this17 = this;
            var linkCls = 'ozz-wyg__tool-media-',
              parent = ev.target.closest(".".concat(linkCls, "trigger"));
            if (!parent) return;
            var settingsDOM = parent.querySelector(".".concat(linkCls, "setting"));
            if (!settingsDOM) return;
            var selection = window.getSelection();

            // Store selection
            var sRange = false;
            if (selection.getRangeAt && selection.rangeCount) {
              sRange = selection.getRangeAt(0).cloneRange();
            }

            // Get Selected Media element tp update - To Do
            var existingURL = '';
            var existingALT = '';
            settingsDOM.innerHTML = "\n      <label>Upload:</label> <input type=\"file\" accept=\"image/*,video/*\" id=\"file-".concat(this.editorID, "\"><br>\n      <label>Media URL:</label> <input type=\"text\" id=\"url-").concat(this.editorID, "\" value=\"").concat(existingURL, "\"><br>\n      <label>Alt:</label> <input type=\"text\" id=\"alt-").concat(this.editorID, "\" value=\"").concat(existingALT, "\"><br>\n      <button type=\"button\" class=\"ozz-wyg-regular-btn\" id=\"insertMediaTrigger-").concat(this.editorID, "\">").concat(existingURL ? 'Update' : 'Insert', "</button>");
            settingsDOM.classList.toggle('active');

            // Insert Media
            var insertMediaTrigger = settingsDOM.querySelector('#insertMediaTrigger-' + this.editorID);
            insertMediaTrigger.addEventListener('click', function () {
              var files = settingsDOM.querySelector('#file-' + _this17.editorID).files;
              var url = settingsDOM.querySelector('#url-' + _this17.editorID).value;
              var alt = settingsDOM.querySelector('#alt-' + _this17.editorID).value;
              var altText = alt;
              var fileType = 'unknown';

              // Set Range Again
              if (sRange) {
                selection.removeAllRanges();
                selection.addRange(sRange);
              }
              if (files.length > 0) {
                // File (DataURI)
                var file = files[0];
                fileType = file.type.split('/')[0];
                if (fileType === 'image' || fileType === 'video') {
                  var reader = new FileReader();
                  reader.onload = function (event) {
                    altText = altText == '' ? file.name : altText;
                    processAndInsertMediaElement(fileType, event.target.result, altText);
                  };
                  reader.readAsDataURL(file);
                }
              } else if (url !== '') {
                // URL attachment
                var urlParts = url.split('/');
                var filename = urlParts[urlParts.length - 1];
                var fileExt = filename.includes('.') ? filename.split('.').pop().toLowerCase() : '';

                // Determine file type based on the file extension or URL
                if (['jpg', 'jpeg', 'png', 'svg', 'webp', 'gif'].includes(fileExt)) {
                  fileType = 'image';
                } else if (['mp4', 'webm', 'ogg', 'avi', 'mov'].includes(fileExt)) {
                  fileType = 'video';
                } else if (_this17.isYouTubeURL(url)) {
                  fileType = 'youtube';
                } else if (_this17.isVimeoURL(url)) {
                  fileType = 'vimeo';
                }
                altText = altText !== '' ? altText : filename;
                processAndInsertMediaElement(fileType, url, altText);
              }
            });

            // Process and Insert Media Element
            var processAndInsertMediaElement = function processAndInsertMediaElement(fileType, mediaItem, altText) {
              var mediaElement;
              if (fileType === 'image') {
                mediaElement = "<img src=\"".concat(mediaItem, "\" class=\"align-center\" alt=\"").concat(altText, "\">");
              } else if (fileType === 'video') {
                mediaElement = "<br><div class=\"media-wrapper\"><video src=\"".concat(mediaItem, "\" controls></video></div><br>");
              } else if (fileType === 'youtube') {
                mediaElement = "<br>".concat(_this17.getYouTubeEmbedCode(mediaItem), "<br>");
              } else if (fileType === 'vimeo') {
                mediaElement = "<br>".concat(_this17.getVimeoEmbedCode(mediaItem), "<br>");
              } else {
                mediaElement = false;
              }

              // Insert Media
              if (mediaElement !== false) {
                document.execCommand('insertHTML', false, "<br>".concat(mediaElement, "<br>"));
                settingsDOM.classList.remove('active'); // Close PopUp

                _this17.mediaPopover(); // Config Media Popover
              }
            };

            // Close popup
            document.addEventListener('click', function (e) {
              if (!parent.contains(e.target)) {
                settingsDOM.classList.remove('active');
              }
            });
          }

          /**
           * Media Popover
           */
        }, {
          key: "mediaPopover",
          value: function mediaPopover() {
            var _this18 = this;
            // Use event delegation to prevent duplicate listeners
            var mediaItems = this.playGround.querySelectorAll('img, .media-wrapper');
            mediaItems.forEach(function (mediaItem) {
              // Remove existing click handlers by cloning
              if (mediaItem.hasAttribute('data-media-handled')) {
                return;
              }
              mediaItem.setAttribute('data-media-handled', 'true');
              mediaItem.addEventListener('click', function (e) {
                var popoverDOM = document.createElement('div');
                popoverDOM.setAttribute('contenteditable', false);
                popoverDOM.classList.add('ozz-wyg-media-actions');

                // Set Selected Width
                var regex = /^w-\d+/;
                var widthClass = Array.from(mediaItem.classList).find(function (className) {
                  return regex.test(className);
                });
                var options = '<option value="auto">Auto</option>';
                for (var i = 1; i < 21; i++) {
                  var clsName = 'w-' + i * 5;
                  if (clsName == widthClass) {
                    options += "<option selected value=\"".concat(clsName, "\">").concat(i * 5, "%</option>");
                  } else {
                    options += "<option value=\"".concat(clsName, "\">").concat(i * 5, "%</option>");
                  }
                }
                popoverDOM.innerHTML = "\n          <button type=\"button\" title=\"Align Left\" data-media-action=\"align-left\">Align Left</button>\n          <button type=\"button\" title=\"Align Center\" data-media-action=\"align-center\">Align Center</button>\n          <button type=\"button\" title=\"Align Right\" data-media-action=\"align-right\">Align Right</button>\n          <button type=\"button\" title=\"Inline\" data-media-action=\"inline\">Inline</button>\n          <select data-media-action=\"width\">".concat(options, "</select>\n          <button type=\"button\" title=\"Delete\" data-media-action=\"delete\">Delete</button>\n        ");

                // Remove any existing popover first
                var existingPopover = _this18.editor.querySelector('.ozz-wyg-media-actions');
                if (existingPopover) {
                  existingPopover.remove();
                }
                mediaItem.insertAdjacentElement('afterend', popoverDOM);

                // Position popover element at the click point
                // Get the editor's position relative to viewport
                var editorRect = _this18.editor.getBoundingClientRect();

                // Calculate position relative to editor container
                var relativeX = e.clientX - editorRect.left;
                var relativeY = e.clientY - editorRect.top;

                // Ensure editor has relative positioning for absolute children
                var editorPosition = window.getComputedStyle(_this18.editor).position;
                if (editorPosition === 'static') {
                  _this18.editor.style.position = 'relative';
                }

                // Set position relative to editor (not absolute screen coordinates)
                popoverDOM.style.position = 'absolute';
                popoverDOM.style.top = "".concat(relativeY, "px");
                popoverDOM.style.left = "".concat(relativeX, "px");
                popoverDOM.style.zIndex = '1000';

                // Media Actions
                popoverDOM.querySelectorAll('button, select').forEach(function (actionTrigger) {
                  if (actionTrigger.tagName === 'SELECT') {
                    actionTrigger.addEventListener('change', function () {
                      var _mediaItem$classList;
                      var action = actionTrigger.value;
                      (_mediaItem$classList = mediaItem.classList).remove.apply(_mediaItem$classList, _toConsumableArray2(Array.from(mediaItem.classList).filter(function (className) {
                        return className.startsWith('w-');
                      })));
                      if (action !== 'auto') {
                        mediaItem.classList.add(action);
                      }
                    });
                  } else {
                    actionTrigger.addEventListener('click', function () {
                      var action = actionTrigger.getAttribute('data-media-action');
                      if (action == 'align-left' || action == 'align-right' || action == 'align-center') {
                        var _mediaItem$classList2;
                        (_mediaItem$classList2 = mediaItem.classList).remove.apply(_mediaItem$classList2, _toConsumableArray2(Array.from(mediaItem.classList).filter(function (className) {
                          return className.startsWith('align-');
                        })));
                        mediaItem.classList.add(action);
                      } else if (action == 'inline') {
                        mediaItem.classList.toggle(action);
                      } else if (action == 'delete') {
                        mediaItem.remove();
                        popoverDOM.remove();
                      }
                    });
                  }
                });

                // Close popover
                var _tempCloseEvent = function tempCloseEvent(ev) {
                  if (!popoverDOM.contains(ev.target) && ev.target !== popoverDOM && ev.target !== mediaItem) {
                    var _this18$editor$queryS;
                    (_this18$editor$queryS = _this18.editor.querySelector('.ozz-wyg-media-actions')) === null || _this18$editor$queryS === void 0 || _this18$editor$queryS.remove();
                    document.removeEventListener('click', _tempCloseEvent);
                  }
                };
                document.addEventListener('click', _tempCloseEvent);
              });
            });
          }

          /**
           * Is Youtube URL
           * @param {string} url
           * @return
           */
        }, {
          key: "isYouTubeURL",
          value: function isYouTubeURL(url) {
            return url.includes('youtube.com/watch') || url.includes('youtu.be') || url.includes('youtube.com/embed');
          }

          /**
           * Is Vimeo URL
           * @param {string} url
           * @returns
           */
        }, {
          key: "isVimeoURL",
          value: function isVimeoURL(url) {
            return url.includes('vimeo.com') || url.includes('player.vimeo.com/video');
          }

          /**
           * Get Embed code (Youtube)
           * @param {string} url
           * @returns 
           */
        }, {
          key: "getYouTubeEmbedCode",
          value: function getYouTubeEmbedCode(url) {
            var videoID = this.extractYouTubeVideoID(url);
            return "<div class=\"media-wrapper\"><span class=\"height-holder\"></span><iframe src=\"https://www.youtube.com/embed/".concat(videoID, "\" frameborder=\"0\" allowfullscreen></iframe></div>");
          }

          /**
           * Extract Youtube video ID
           * @param {string} url 
           * @returns 
           */
        }, {
          key: "extractYouTubeVideoID",
          value: function extractYouTubeVideoID(url) {
            var regex = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
            var match = url.match(regex);
            return match ? match[1] : '';
          }

          /**
           * Get Embed code (Vimeo)
           * @param {string} url 
           * @returns 
           */
        }, {
          key: "getVimeoEmbedCode",
          value: function getVimeoEmbedCode(url) {
            var videoID = this.extractVimeoVideoID(url);
            return "<div class=\"media-wrapper\"><span class=\"height-holder\"></span><iframe src=\"https://player.vimeo.com/video/".concat(videoID, "\" frameborder=\"0\" allowfullscreen></iframe></div>");
          }

          /**
           * Extract Vimeo video ID
           * @param {string} url 
           * @returns 
           */
        }, {
          key: "extractVimeoVideoID",
          value: function extractVimeoVideoID(url) {
            var regex = /vimeo\.com\/(?:video\/)?(\d+)/;
            var match = url.match(regex);
            return match ? match[1] : '';
          }

          /**
           * Execute Command
           * @param {string} command
           * @param value
           */
        }, {
          key: "exeCMD",
          value: function exeCMD(command) {
            var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            document.execCommand(command, false, value);
          }

          /**
           * Quote Text
           */
        }, {
          key: "quoteText",
          value: function quoteText() {
            var selection = window.getSelection();
            var selectedText = selection.toString().trim();
            var quote = '<blockquote><p>' + (selectedText === '' ? '<br>' : selectedText) + '</p><footer class="blockquote-footer">--Footer, <cite>cite</cite></footer></blockquote><br>';
            document.execCommand('insertHTML', false, quote);
          }

          /**
           * Add Code
           */
        }, {
          key: "codeText",
          value: function codeText() {
            var selection = window.getSelection();
            var selectedText = selection.toString();
            if (selectedText === '') {
              // If no selection, insert empty code tag
              document.execCommand('insertHTML', false, '<code></code>');
            } else {
              var code = '<code>' + selectedText + '</code>';
              document.execCommand('insertHTML', false, code);
            }
          }

          /**
           * Toggle Code and visual view
           */
        }, {
          key: "toggleCodeView",
          value: function toggleCodeView() {
            var _this19 = this;
            if (this.isHTML()) {
              this.playGround.classList.remove('ozz-wyg-html-view');
              // Parse HTML from text content
              var htmlContent = this.playGround.textContent;
              this.playGround.innerHTML = htmlContent;
              // Re-initialize all interactive features after switching back to visual view
              setTimeout(function () {
                _this19.initializeContentFeatures();
              }, 0);
            } else {
              this.playGround.querySelectorAll('[contenteditable="false"]').forEach(function (element) {
                element.remove();
              });
              this.playGround.classList.add('ozz-wyg-html-view');
              this.playGround.textContent = this.playGround.innerHTML;
            }
          }

          /**
           * Get value from editor
           * @param {string} editorID - Optional editor ID, if not provided returns first editor's value
           */
        }, {
          key: "getValue",
          value: function getValue() {
            var editorID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            if (editorID && this.editorInstances.has(editorID)) {
              return this.editorInstances.get(editorID).playGround.innerHTML;
            }
            // Return first editor's value for backward compatibility
            if (this.editorInstances.size > 0) {
              var firstInstance = this.editorInstances.values().next().value;
              return firstInstance.playGround.innerHTML;
            }
            return this.playGround ? this.playGround.innerHTML : '';
          }

          /**
           * Initialize interactive features for loaded content
           * This should be called after setting content via setValue or when content is loaded
           */
        }, {
          key: "initializeContentFeatures",
          value: function initializeContentFeatures() {
            if (!this.playGround) return;

            // Wrap tables that aren't wrapped yet
            var tables = this.playGround.querySelectorAll('table');
            tables.forEach(function (table) {
              if (!table.closest('.ozz-wyg-table-wrapper')) {
                var tableWrapped = document.createElement('div');
                tableWrapped.classList.add('ozz-wyg-table-wrapper');
                var tableParent = table.parentNode;
                tableParent.insertBefore(tableWrapped, table);
                tableWrapped.appendChild(table);

                // Clear inline styles
                table.removeAttribute('style');
                var tItems = table.querySelectorAll('tbody, thead, tfoot, tr, td, th');
                tItems.forEach(function (item) {
                  item.removeAttribute('style');
                });
              }
            });

            // Remove existing handlers to re-initialize
            this.playGround.querySelectorAll('[data-link-handled]').forEach(function (el) {
              el.removeAttribute('data-link-handled');
            });
            this.playGround.querySelectorAll('[data-media-handled]').forEach(function (el) {
              el.removeAttribute('data-media-handled');
            });
            this.playGround.querySelectorAll('[data-table-handled]').forEach(function (el) {
              el.removeAttribute('data-table-handled');
            });

            // Initialize all interactive features
            this.mediaPopover();
            this.tableActions();
            this.linkPopOver();
          }

          /**
           * Set value for editor
           * @param {string} value - HTML string to set
           * @param {string|null} editorID - target editor ID; if null and single editor exists, applies to first
           */
        }, {
          key: "setValue",
          value: function setValue(value) {
            var _this20 = this;
            var editorID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            if (value === undefined || value === null) return;
            var targetInstance = null;
            if (editorID && this.editorInstances.has(editorID)) {
              targetInstance = this.editorInstances.get(editorID);
            } else if (this.editorInstances.size === 1) {
              targetInstance = this.editorInstances.values().next().value;
            }
            var playGroundToSet = null;
            var editorToSet = null;
            var editorIDToSet = null;
            if (targetInstance && targetInstance.playGround) {
              playGroundToSet = targetInstance.playGround;
              editorToSet = targetInstance.element;
              editorIDToSet = targetInstance.id;
            } else if (this.playGround) {
              playGroundToSet = this.playGround;
              editorToSet = this.editor;
              editorIDToSet = this.editorID;
            }
            if (playGroundToSet) {
              // Set the content
              playGroundToSet.innerHTML = value;

              // Initialize features after DOM update
              // Use captured values in closure to ensure correct editor instance
              setTimeout(function () {
                // Set context for initialization using captured values
                var originalEditor = _this20.editor;
                var originalPlayGround = _this20.playGround;
                var originalEditorID = _this20.editorID;
                _this20.editor = editorToSet;
                _this20.playGround = playGroundToSet;
                _this20.editorID = editorIDToSet;
                if (editorIDToSet) {
                  _this20.currentEditorID = editorIDToSet;
                }
                _this20.initializeContentFeatures();

                // Restore original context after initialization
                _this20.editor = originalEditor;
                _this20.playGround = originalPlayGround;
                _this20.editorID = originalEditorID;
              }, 0);
            }
          }

          /**
           * Get editor instance by editor ID
           * @param {string} editorID - Editor ID
           * @returns {Object|null} Editor instance or null
           */
        }, {
          key: "getEditorInstance",
          value: function getEditorInstance(editorID) {
            return this.editorInstances.get(editorID) || null;
          }

          /**
           * Get all editor instances
           * @returns {Map} Map of all editor instances
           */
        }, {
          key: "getAllEditorInstances",
          value: function getAllEditorInstances() {
            return this.editorInstances;
          }

          /**
           * Bind event to specific editor instance
           * @param {string} editorID - Editor ID
           * @param {string} eventName - Event name (without 'ozzwyg:' prefix)
           * @param {Function} callback - Event callback function
           */
        }, {
          key: "on",
          value: function on(editorID, eventName, callback) {
            var instance = this.getEditorInstance(editorID);
            if (instance && instance.element) {
              instance.element.addEventListener("ozzwyg:".concat(eventName), callback);
            }
          }

          /**
           * Unbind event from specific editor instance
           * @param {string} editorID - Editor ID
           * @param {string} eventName - Event name (without 'ozzwyg:' prefix)
           * @param {Function} callback - Event callback function
           */
        }, {
          key: "off",
          value: function off(editorID, eventName, callback) {
            var instance = this.getEditorInstance(editorID);
            if (instance && instance.element) {
              instance.element.removeEventListener("ozzwyg:".concat(eventName), callback);
            }
          }
        }]);
      }();
      /**
       * Static method to get OzzWyg instance from DOM element
       * @param {string|HTMLElement} selector - CSS selector or DOM element
       * @returns {OzzWyg|null} OzzWyg instance or null
       */
      // Static registry to track all editor instances
      _defineProperty2(OzzWyg, "instances", new Map());
      OzzWyg.getInstance = function (selector) {
        var element = null;
        if (typeof selector === 'string') {
          element = document.querySelector(selector);
        } else if (selector instanceof HTMLElement) {
          element = selector;
        }
        if (element) {
          // Check if element has data-editor attribute
          var editorID = element.getAttribute('data-editor');
          if (editorID && OzzWyg.instances.has(editorID)) {
            return OzzWyg.instances.get(editorID);
          }
          // Check if element itself is registered
          if (OzzWyg.instances.has(element)) {
            return OzzWyg.instances.get(element);
          }
        }
        return null;
      };

      /**
       * Static method to get value from editor by selector
       * @param {string|HTMLElement} selector - CSS selector or DOM element
       * @returns {string} Editor content or empty string
       */
      OzzWyg.getValue = function (selector) {
        var instance = OzzWyg.getInstance(selector);
        if (instance) {
          var element = typeof selector === 'string' ? document.querySelector(selector) : selector;
          var editorID = element ? element.getAttribute('data-editor') : null;
          return instance.getValue(editorID);
        }
        return '';
      };

      /**
       * Static method to set value for editor by selector or element
       * @param {string|HTMLElement} selector - CSS selector or DOM element
       * @param {string} value - HTML string
       */
      OzzWyg.setValue = function (selector, value) {
        var instance = OzzWyg.getInstance(selector);
        if (instance) {
          var element = typeof selector === 'string' ? document.querySelector(selector) : selector;
          var editorID = element ? element.getAttribute('data-editor') : null;
          instance.setValue(value, editorID);
        }
      };

      /**
       * Static method to bind event to editor by selector
       * @param {string|HTMLElement} selector - CSS selector or DOM element
       * @param {string} eventName - Event name (without 'ozzwyg:' prefix)
       * @param {Function} callback - Event callback function
       */
      OzzWyg.on = function (selector, eventName, callback) {
        var instance = OzzWyg.getInstance(selector);
        if (instance) {
          var element = typeof selector === 'string' ? document.querySelector(selector) : selector;
          var editorID = element ? element.getAttribute('data-editor') : null;
          if (editorID) {
            instance.on(editorID, eventName, callback);
          } else if (element) {
            // Fallback: bind directly to element
            element.addEventListener("ozzwyg:".concat(eventName), callback);
          }
        }
      };

      /**
       * Static method to unbind event from editor by selector
       * @param {string|HTMLElement} selector - CSS selector or DOM element
       * @param {string} eventName - Event name (without 'ozzwyg:' prefix)
       * @param {Function} callback - Event callback function
       */
      OzzWyg.off = function (selector, eventName, callback) {
        var instance = OzzWyg.getInstance(selector);
        if (instance) {
          var element = typeof selector === 'string' ? document.querySelector(selector) : selector;
          var editorID = element ? element.getAttribute('data-editor') : null;
          if (editorID) {
            instance.off(editorID, eventName, callback);
          } else if (element) {
            // Fallback: unbind directly from element
            element.removeEventListener("ozzwyg:".concat(eventName), callback);
          }
        }
      };

      // Default options for the plugin
      OzzWyg.defaults = {
        pluginName: 'Ozz Wysiwyg Editor',
        selector: '[data-ozz-wyg]',
        tools: ['headings', 'paragraph', 'code', 'quote', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'bold', 'italic', 'underline', 'strikethrough', 'subscript', 'superscript', 'alignLeft', 'alignRight', 'alignCenter', 'justify', 'indent', 'outdent', 'ol', 'ul', 'link', 'table', 'media', 'codeView']
      };
      /* harmony default export */
      var __WEBPACK_DEFAULT_EXPORT__ = OzzWyg;

      /***/
    } /******/
  };
  /************************************************************************/
  /******/ // The module cache
  /******/
  var __webpack_module_cache__ = {};
  /******/
  /******/ // The require function
  /******/
  function __webpack_require__(moduleId) {
    /******/ // Check if module is in cache
    /******/var cachedModule = __webpack_module_cache__[moduleId];
    /******/
    if (cachedModule !== undefined) {
      /******/return cachedModule.exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/
    var module = __webpack_module_cache__[moduleId] = {
      /******/id: moduleId,
      /******/loaded: false,
      /******/exports: {}
      /******/
    };
    /******/
    /******/ // Execute the module function
    /******/
    if (!(moduleId in __webpack_modules__)) {
      /******/delete __webpack_module_cache__[moduleId];
      /******/
      var e = new Error("Cannot find module '" + moduleId + "'");
      /******/
      e.code = 'MODULE_NOT_FOUND';
      /******/
      throw e;
      /******/
    }
    /******/
    __webpack_modules__[moduleId](module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/
    module.loaded = true;
    /******/
    /******/ // Return the exports of the module
    /******/
    return module.exports;
    /******/
  }
  /******/
  /************************************************************************/
  /******/ /* webpack/runtime/amd options */
  /******/
  (function () {
    /******/__webpack_require__.amdO = {};
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/define property getters */
  /******/
  (function () {
    /******/ // define getter/value functions for harmony exports
    /******/__webpack_require__.d = function (exports, definition) {
      /******/if (Array.isArray(definition)) {
        /******/var i = 0;
        /******/
        while (i < definition.length) {
          /******/var key = definition[i++];
          /******/
          var binding = definition[i++];
          /******/
          if (!__webpack_require__.o(exports, key)) {
            /******/if (binding === 0) {
              /******/Object.defineProperty(exports, key, {
                enumerable: true,
                value: definition[i++]
              });
              /******/
            } else {
              /******/Object.defineProperty(exports, key, {
                enumerable: true,
                get: binding
              });
              /******/
            }
            /******/
          } else if (binding === 0) {
            i++;
          }
          /******/
        }
        /******/
      } else {
        /******/for (var key in definition) {
          /******/if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
            /******/Object.defineProperty(exports, key, {
              enumerable: true,
              get: definition[key]
            });
            /******/
          }
          /******/
        }
        /******/
      }
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/harmony module decorator */
  /******/
  (function () {
    /******/__webpack_require__.hmd = function (module) {
      /******/module = Object.create(module);
      /******/
      if (!module.children) module.children = [];
      /******/
      Object.defineProperty(module, 'exports', {
        /******/enumerable: true,
        /******/set: function set() {
          /******/throw new Error('ES Modules may not assign module.exports or exports.*, Use ESM export syntax, instead: ' + module.id);
          /******/
        } /******/
      });
      /******/
      return module;
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/hasOwnProperty shorthand */
  /******/
  (function () {
    /******/__webpack_require__.o = function (obj, prop) {
      return Object.prototype.hasOwnProperty.call(obj, prop);
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/make namespace object */
  /******/
  (function () {
    /******/ // define __esModule on exports
    /******/__webpack_require__.r = function (exports) {
      /******/if (Symbol.toStringTag) {
        /******/Object.defineProperty(exports, Symbol.toStringTag, {
          value: 'Module'
        });
        /******/
      }
      /******/
      Object.defineProperty(exports, '__esModule', {
        value: true
      });
      /******/
    };
    /******/
  })();
  /******/
  /************************************************************************/
  var __webpack_exports__ = {};
  // This entry needs to be wrapped in an IIFE because it needs to be isolated against other modules in the chunk.
  (function () {
    /*!*******************!*\
      !*** ./js/app.js ***!
      \*******************/
    __webpack_require__.r(__webpack_exports__);
    /* harmony import */
    var _modules_header__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modules/header */"./js/modules/header.js");
    /* harmony import */
    var _modules_highlight_text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modules/highlight-text */"./js/modules/highlight-text.js");
    /* harmony import */
    var _modules_template_carousel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./modules/template-carousel */"./js/modules/template-carousel.js");
    /* harmony import */
    var _modules_testimonial_slider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./modules/testimonial-slider */"./js/modules/testimonial-slider.js");
    /* harmony import */
    var _modules_accordion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./modules/accordion */"./js/modules/accordion.js");
    /* harmony import */
    var _modules_blog_filter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./modules/blog-filter */"./js/modules/blog-filter.js");
    /* harmony import */
    var _modules_cv_builder_v2__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./modules/cv-builder-v2 */"./js/modules/cv-builder-v2.js");
    /* harmony import */
    var _modules_repeater__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./modules/repeater */"./js/modules/repeater.js");
    /* harmony import */
    var _modules_color_picker__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./modules/color-picker */"./js/modules/color-picker.js");
    /* harmony import */
    var _modules_hash_route__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./modules/hash-route */"./js/modules/hash-route.js");
    /* harmony import */
    var _modules_image_preview__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./modules/image-preview */"./js/modules/image-preview.js");
    /* harmony import */
    var _modules_common__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./modules/common */"./js/modules/common.js");
    /* harmony import */
    var _modules_notification__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./modules/notification */"./js/modules/notification.js");
    /* harmony import */
    var _modules_main_alert__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./modules/main-alert */"./js/modules/main-alert.js");
    /* harmony import */
    var _modules_blog_progress_bar__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./modules/blog-progress-bar */"./js/modules/blog-progress-bar.js");
    /* harmony import */
    var _modules_date_picker__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./modules/date-picker */"./js/modules/date-picker.js");
    /* harmony import */
    var _modules_custom_range__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./modules/custom-range */"./js/modules/custom-range.js");
    /* harmony import */
    var _modules_cv_delete_action__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./modules/cv-delete-action */"./js/modules/cv-delete-action.js");
    /* harmony import */
    var _modules_icon_selector__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./modules/icon-selector */"./js/modules/icon-selector.js");
    /* harmony import */
    var _modules_smart_assistant__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./modules/smart-assistant */"./js/modules/smart-assistant.js");
    // JS

    (function () {
      _modules_header__WEBPACK_IMPORTED_MODULE_0__["default"].mobileNavToggle();
      _modules_highlight_text__WEBPACK_IMPORTED_MODULE_1__["default"].highlight();
      _modules_template_carousel__WEBPACK_IMPORTED_MODULE_2__["default"].init();
      _modules_testimonial_slider__WEBPACK_IMPORTED_MODULE_3__["default"].init();
      _modules_accordion__WEBPACK_IMPORTED_MODULE_4__["default"].init();
      _modules_blog_filter__WEBPACK_IMPORTED_MODULE_5__["default"].init();
      _modules_cv_builder_v2__WEBPACK_IMPORTED_MODULE_6__["default"].init();
      _modules_repeater__WEBPACK_IMPORTED_MODULE_7__["default"].init();
      _modules_color_picker__WEBPACK_IMPORTED_MODULE_8__["default"].init();
      _modules_hash_route__WEBPACK_IMPORTED_MODULE_9__["default"].init();
      _modules_image_preview__WEBPACK_IMPORTED_MODULE_10__["default"].init();
      _modules_common__WEBPACK_IMPORTED_MODULE_11__["default"].init();
      _modules_notification__WEBPACK_IMPORTED_MODULE_12__["default"].init();
      _modules_main_alert__WEBPACK_IMPORTED_MODULE_13__["default"].init();
      _modules_blog_progress_bar__WEBPACK_IMPORTED_MODULE_14__["default"].init();
      _modules_date_picker__WEBPACK_IMPORTED_MODULE_15__["default"].init();
      _modules_custom_range__WEBPACK_IMPORTED_MODULE_16__["default"].init();
      _modules_cv_delete_action__WEBPACK_IMPORTED_MODULE_17__["default"].init();
      _modules_icon_selector__WEBPACK_IMPORTED_MODULE_18__["default"].init();
      _modules_smart_assistant__WEBPACK_IMPORTED_MODULE_19__["default"].init();
    })();
  })();

  /******/
})();